'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var T = require('prop-types');
require('@styled-system/prop-types');
var united = require('@olist/united');
var styled = require('styled-components');
var styledSystem = require('styled-system');
var themeGet = require('@styled-system/theme-get');
var reactUse = require('react-use');
var reactFinalForm = require('react-final-form');
var MaskedInput = require('react-text-mask');
var luxon = require('luxon');
var axios = require('axios');
require('x2js');
var Cookie = require('js-cookie');
var require$$1 = require('react-dom');
var Uppy = require('@uppy/core');
var XHRUpload = require('@uppy/xhr-upload');
var UppyAwsS3 = require('@uppy/aws-s3');
require('@brazilian-utils/is-valid-cnpj');
var Lottie = require('react-lottie-player');
require('react-router-dom');
var isEqual = require('react-fast-compare');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var T__namespace = /*#__PURE__*/_interopNamespace(T);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var themeGet__default = /*#__PURE__*/_interopDefaultLegacy(themeGet);
var MaskedInput__default = /*#__PURE__*/_interopDefaultLegacy(MaskedInput);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var Cookie__default = /*#__PURE__*/_interopDefaultLegacy(Cookie);
var require$$1__default = /*#__PURE__*/_interopDefaultLegacy(require$$1);
var Uppy__default = /*#__PURE__*/_interopDefaultLegacy(Uppy);
var XHRUpload__default = /*#__PURE__*/_interopDefaultLegacy(XHRUpload);
var UppyAwsS3__default = /*#__PURE__*/_interopDefaultLegacy(UppyAwsS3);
var Lottie__default = /*#__PURE__*/_interopDefaultLegacy(Lottie);
var isEqual__default = /*#__PURE__*/_interopDefaultLegacy(isEqual);

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _templateObject$r;

var setStyledCopied = function setStyledCopied(_ref) {
  var copied = _ref.copied;
  return copied && styled.css(["svg path{fill:", ";}:hover{svg path{fill:", ";}}"], themeGet.themeGet('olist.color.success.base'), themeGet.themeGet('olist.color.success.base'));
};

var setSize = function setSize(_ref2) {
  var size = _ref2.size;
  return {
    medium: styled.css(["width:32px;height:32px;"]),
    small: styled.css(["width:24px;height:24px;"])
  }[size];
};

var ButtonWrapper = styled__default["default"](united.Flex).attrs({
  alignItems: 'center',
  justifyContent: 'center'
})(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-flex;\n\n  :hover {\n    background-color: ", ";\n\n    svg path {\n      fill: ", ";\n    }\n  }\n\n  ", "\n  ", "\n  ", ";\n"])), themeGet.themeGet('olist.color.neutral.softer'), themeGet.themeGet('olist.color.primary.base'), setSize, styledSystem.layout, setStyledCopied);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$s =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$r = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$q = fails$r;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$q(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable$1 = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$5 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$5 && !$propertyIsEnumerable$1.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$5(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable$1;

var createPropertyDescriptor$6 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString$2 = {}.toString;

var classofRaw$1 = function (it) {
  return toString$2.call(it).slice(8, -1);
};

var fails$p = fails$r;
var classof$a = classofRaw$1;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$p(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$a(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$d = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$4 = indexedObject;
var requireObjectCoercible$c = requireObjectCoercible$d;

var toIndexedObject$9 = function (it) {
  return IndexedObject$4(requireObjectCoercible$c(it));
};

var isObject$i = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var isObject$h = isObject$i;

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive$5 = function (input, PREFERRED_STRING) {
  if (!isObject$h(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$h(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject$h(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$h(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var requireObjectCoercible$b = requireObjectCoercible$d;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$c = function (argument) {
  return Object(requireObjectCoercible$b(argument));
};

var toObject$b = toObject$c;

var hasOwnProperty = {}.hasOwnProperty;

var has$f = function hasOwn(it, key) {
  return hasOwnProperty.call(toObject$b(it), key);
};

var global$r = global$s;
var isObject$g = isObject$i;

var document$3 = global$r.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject$g(document$3) && isObject$g(document$3.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS ? document$3.createElement(it) : {};
};

var DESCRIPTORS$d = descriptors;
var fails$o = fails$r;
var createElement$1 = documentCreateElement$1;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$d && !fails$o(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$c = descriptors;
var propertyIsEnumerableModule$2 = objectPropertyIsEnumerable;
var createPropertyDescriptor$5 = createPropertyDescriptor$6;
var toIndexedObject$8 = toIndexedObject$9;
var toPrimitive$4 = toPrimitive$5;
var has$e = has$f;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$c ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$8(O);
  P = toPrimitive$4(P, true);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (has$e(O, P)) return createPropertyDescriptor$5(!propertyIsEnumerableModule$2.f.call(O, P), O[P]);
};

var objectDefineProperty = {};

var isObject$f = isObject$i;

var anObject$i = function (it) {
  if (!isObject$f(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

var DESCRIPTORS$b = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var anObject$h = anObject$i;
var toPrimitive$3 = toPrimitive$5;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty$1 = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$b ? $defineProperty$1 : function defineProperty(O, P, Attributes) {
  anObject$h(O);
  P = toPrimitive$3(P, true);
  anObject$h(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty$1(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$a = descriptors;
var definePropertyModule$6 = objectDefineProperty;
var createPropertyDescriptor$4 = createPropertyDescriptor$6;

var createNonEnumerableProperty$a = DESCRIPTORS$a ? function (object, key, value) {
  return definePropertyModule$6.f(object, key, createPropertyDescriptor$4(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$d = {exports: {}};

var global$q = global$s;
var createNonEnumerableProperty$9 = createNonEnumerableProperty$a;

var setGlobal$3 = function (key, value) {
  try {
    createNonEnumerableProperty$9(global$q, key, value);
  } catch (error) {
    global$q[key] = value;
  } return value;
};

var global$p = global$s;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$p[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store$2.inspectSource != 'function') {
  store$2.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$3 = store$2.inspectSource;

var global$o = global$s;
var inspectSource$2 = inspectSource$3;

var WeakMap$1 = global$o.WeakMap;

var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource$2(WeakMap$1));

var shared$5 = {exports: {}};

var isPure = false;

var store$1 = sharedStore;

(shared$5.exports = function (key, value) {
  return store$1[key] || (store$1[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.12.1',
  mode: 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});

var id$1 = 0;
var postfix = Math.random();

var uid$4 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id$1 + postfix).toString(36);
};

var shared$4 = shared$5.exports;
var uid$3 = uid$4;

var keys$1 = shared$4('keys');

var sharedKey$4 = function (key) {
  return keys$1[key] || (keys$1[key] = uid$3(key));
};

var hiddenKeys$6 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$n = global$s;
var isObject$e = isObject$i;
var createNonEnumerableProperty$8 = createNonEnumerableProperty$a;
var objectHas = has$f;
var shared$3 = sharedStore;
var sharedKey$3 = sharedKey$4;
var hiddenKeys$5 = hiddenKeys$6;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global$n.WeakMap;
var set$1, get, has$d;

var enforce = function (it) {
  return has$d(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$e(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$3.state) {
  var store = shared$3.state || (shared$3.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set$1 = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$d = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey$3('state');
  hiddenKeys$5[STATE] = true;
  set$1 = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$8(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$d = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has$d,
  enforce: enforce,
  getterFor: getterFor
};

var global$m = global$s;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$a;
var has$c = has$f;
var setGlobal$1 = setGlobal$3;
var inspectSource$1 = inspectSource$3;
var InternalStateModule$7 = internalState;

var getInternalState$4 = InternalStateModule$7.get;
var enforceInternalState = InternalStateModule$7.enforce;
var TEMPLATE = String(String).split('String');

(redefine$d.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has$c(value, 'name')) {
      createNonEnumerableProperty$7(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global$m) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$7(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState$4(this).source || inspectSource$1(this);
});

var global$l = global$s;

var path$2 = global$l;

var path$1 = path$2;
var global$k = global$s;

var aFunction$7 = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn$7 = function (namespace, method) {
  return arguments.length < 2 ? aFunction$7(path$1[namespace]) || aFunction$7(global$k[namespace])
    : path$1[namespace] && path$1[namespace][method] || global$k[namespace] && global$k[namespace][method];
};

var objectGetOwnPropertyNames = {};

var ceil$1 = Math.ceil;
var floor$4 = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var toInteger$7 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor$4 : ceil$1)(argument);
};

var toInteger$6 = toInteger$7;

var min$6 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$d = function (argument) {
  return argument > 0 ? min$6(toInteger$6(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toInteger$5 = toInteger$7;

var max$3 = Math.max;
var min$5 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$3 = function (index, length) {
  var integer = toInteger$5(index);
  return integer < 0 ? max$3(integer + length, 0) : min$5(integer, length);
};

var toIndexedObject$7 = toIndexedObject$9;
var toLength$c = toLength$d;
var toAbsoluteIndex$2 = toAbsoluteIndex$3;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$6 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$7($this);
    var length = toLength$c(O.length);
    var index = toAbsoluteIndex$2(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$6(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$6(false)
};

var has$b = has$f;
var toIndexedObject$6 = toIndexedObject$9;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$4 = hiddenKeys$6;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$6(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$b(hiddenKeys$4, key) && has$b(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$b(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$3 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$3);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$6 = getBuiltIn$7;
var getOwnPropertyNamesModule$1 = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$2 = objectGetOwnPropertySymbols;
var anObject$g = anObject$i;

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$6('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule$1.f(anObject$g(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$2.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var has$a = has$f;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule$1 = objectGetOwnPropertyDescriptor;
var definePropertyModule$5 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$5.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule$1.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has$a(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$n = fails$r;

var replacement = /#|\.prototype\./;

var isForced$4 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails$n(detection)
    : !!detection;
};

var normalize = isForced$4.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$4.data = {};
var NATIVE = isForced$4.NATIVE = 'N';
var POLYFILL = isForced$4.POLYFILL = 'P';

var isForced_1 = isForced$4;

var global$j = global$s;
var getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$a;
var redefine$c = redefine$d.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$3 = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$j;
  } else if (STATIC) {
    target = global$j[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$j[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$4(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$3(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$6(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$c(target, key, sourceProperty, options);
  }
};

var getBuiltIn$5 = getBuiltIn$7;

var engineUserAgent = getBuiltIn$5('navigator', 'userAgent') || '';

var $$E = _export;
var global$i = global$s;
var userAgent$3 = engineUserAgent;

var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent$3); // <- dirty ie9- check

var wrap$1 = function (scheduler) {
  return function (handler, timeout /* , ...arguments */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : undefined;
    return scheduler(boundArgs ? function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (typeof handler == 'function' ? handler : Function(handler)).apply(this, args);
    } : handler, timeout);
  };
};

// ie9- setTimeout & setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
$$E({ global: true, bind: true, forced: MSIE }, {
  // `setTimeout` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
  setTimeout: wrap$1(global$i.setTimeout),
  // `setInterval` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
  setInterval: wrap$1(global$i.setInterval)
});

var useCopyWithDelay = function useCopyWithDelay(valueToCopy) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;

  var _useCopyToClipboard = reactUse.useCopyToClipboard(),
      _useCopyToClipboard2 = _slicedToArray(_useCopyToClipboard, 2),
      copyToClipboard = _useCopyToClipboard2[1];

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasCopied = _useState2[0],
      setCopied = _useState2[1];

  React.useEffect(function () {
    var timeoutId;

    if (hasCopied) {
      timeoutId = setTimeout(function () {
        setCopied(false);
      }, delay);
    }

    return function () {
      clearTimeout(timeoutId);
    };
  }, [hasCopied, delay]);

  var handleCopy = function handleCopy(e) {
    e.preventDefault();
    e.stopPropagation();
    setCopied(true);
    copyToClipboard(valueToCopy);
  };

  return {
    hasCopied: hasCopied,
    handleCopy: handleCopy
  };
};

var CopyButton = function CopyButton(_ref) {
  var message = _ref.message,
      size = _ref.size,
      tooltipPlacement = _ref.tooltipPlacement,
      valueToCopy = _ref.valueToCopy,
      props = _objectWithoutProperties(_ref, ["message", "size", "tooltipPlacement", "valueToCopy"]);

  var _useCopy = useCopyWithDelay(valueToCopy),
      hasCopied = _useCopy.hasCopied,
      handleCopy = _useCopy.handleCopy;

  var component = /*#__PURE__*/React__default["default"].createElement(ButtonWrapper, _extends({
    onClick: handleCopy,
    copied: hasCopied,
    size: size
  }, props, {
    role: "button"
  }), /*#__PURE__*/React__default["default"].createElement(united.Icon, {
    "data-testid": hasCopied ? 'success-outline' : 'copy-outline',
    name: hasCopied ? 'success-outline' : 'copy-outline',
    size: size === 'small' ? 18 : 20
  }));
  return message ? /*#__PURE__*/React__default["default"].createElement(united.Tooltip, {
    "data-testid": "tooltip-holder",
    content: message,
    placement: tooltipPlacement
  }, component) : component;
};

CopyButton.defaultProps = {
  message: '',
  size: 'medium',
  tooltipPlacement: 'bottom'
};

var _templateObject$q;
var ChipButton = styled__default["default"](united.Button)(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  height: 30px;\n  line-height: 30px;\n  font-weight: unset;\n  padding-right: ", ";\n  ", "\n\n  svg {\n    padding: 0 0px 0 6px;\n  }\n\n  :focus,\n  :hover {\n    svg,\n    path {\n      fill: ", ";\n    }\n\n    :hover,\n    :active {\n      box-shadow: none;\n    }\n  }\n"])), themeGet.themeGet('olist.color.neutral.softest'), themeGet.themeGet('olist.borderRadius.pill'), themeGet.themeGet('olist.spacing.inline.1xsmall'), styledSystem.layout, themeGet.themeGet('olist.color.primary.base'));

var Chip = function Chip(_ref) {
  var label = _ref.label,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["label", "onClick"]);

  return /*#__PURE__*/React__default["default"].createElement(ChipButton, _extends({
    onClick: onClick
  }, props), label, /*#__PURE__*/React__default["default"].createElement(united.Icon, {
    name: "close-outline",
    size: 24
  }));
};

var _templateObject$p;
var LoadingSpinner = styled__default["default"].div(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral(["\n  width: 18px;\n  height: 18px;\n  border: 3px solid ", ";\n  border-radius: ", ";\n  top: 50%;\n  left: 50%;\n  margin: auto;\n  animation: spin 600ms infinite linear;\n  border-top-color: ", ";\n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n"])), themeGet.themeGet('olist.color.primary.base'), themeGet.themeGet('olist.borderRadius.circle'), themeGet.themeGet('olist.color.neutral.softest'));

var DescriptionTerm = function DescriptionTerm(_ref) {
  var term = _ref.term;
  return !!term && /*#__PURE__*/React__default["default"].createElement(united.Text, {
    color: united.getColor('text', 'light')
  }, term);
};
var DescriptionValue = function DescriptionValue(_ref2) {
  var value = _ref2.value;
  return /*#__PURE__*/React__default["default"].createElement(united.Text, null, value || '-');
};

var DescriptionItem = function DescriptionItem(_ref3) {
  var term = _ref3.term,
      value = _ref3.value;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(DescriptionTerm, {
    term: term
  }), /*#__PURE__*/React__default["default"].isValidElement(value) ? value : /*#__PURE__*/React__default["default"].createElement(DescriptionValue, {
    value: value
  }));
};

var Emoji = function Emoji(_ref) {
  var label = _ref.label,
      symbol = _ref.symbol,
      rest = _objectWithoutProperties(_ref, ["label", "symbol"]);

  return /*#__PURE__*/React__default["default"].createElement(united.Box, _extends({
    as: "span",
    role: "img",
    "aria-label": label,
    "aria-hidden": label ? 'false' : 'true'
  }, rest), symbol);
};

Emoji.defaultProps = {
  label: ''
};

var _templateObject$o;
var SeparatorWithText = styled__default["default"](united.Text.Small)(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n  overflow: hidden;\n  text-align: center;\n  width: 100%;\n  ", "\n\n  &:after,\n  &:before {\n    background-color: currentColor;\n    content: '';\n    display: inline-block;\n    height: 1px;\n    position: relative;\n    vertical-align: middle;\n    width: 50%;\n  }\n\n  &:after {\n    margin-right: -50%;\n    left: 9px;\n  }\n\n  &:before {\n    right: 9px;\n    margin-left: -50%;\n  }\n"])), styledSystem.space);

var global$h = global$s;
var userAgent$2 = engineUserAgent;

var process$3 = global$h.process;
var versions = process$3 && process$3.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent$2) {
  match = userAgent$2.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$2.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION$3 = engineV8Version;
var fails$m = fails$r;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$m(function () {
  return !String(Symbol()) ||
    // Chrome 38 Symbol has incorrect toString conversion
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$3 && V8_VERSION$3 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$2 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var classof$9 = classofRaw$1;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$5 = Array.isArray || function isArray(arg) {
  return classof$9(arg) == 'Array';
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$4 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$9 = descriptors;
var definePropertyModule$4 = objectDefineProperty;
var anObject$f = anObject$i;
var objectKeys$3 = objectKeys$4;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var objectDefineProperties = DESCRIPTORS$9 ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$f(O);
  var keys = objectKeys$3(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$4.f(O, key = keys[index++], Properties[key]);
  return O;
};

var getBuiltIn$4 = getBuiltIn$7;

var html$2 = getBuiltIn$4('document', 'documentElement');

var anObject$e = anObject$i;
var defineProperties$1 = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys$2 = hiddenKeys$6;
var html$1 = html$2;
var documentCreateElement = documentCreateElement$1;
var sharedKey$2 = sharedKey$4;

var GT = '>';
var LT = '<';
var PROTOTYPE$1 = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$2('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE$1][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys$2[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE$1] = anObject$e(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties$1(result, Properties);
};

var objectGetOwnPropertyNamesExternal = {};

/* eslint-disable es/no-object-getownpropertynames -- safe */

var toIndexedObject$5 = toIndexedObject$9;
var $getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;

var toString$1 = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames$1(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
objectGetOwnPropertyNamesExternal.f = function getOwnPropertyNames(it) {
  return windowNames && toString$1.call(it) == '[object Window]'
    ? getWindowNames(it)
    : $getOwnPropertyNames$1(toIndexedObject$5(it));
};

var global$g = global$s;
var shared$2 = shared$5.exports;
var has$9 = has$f;
var uid$2 = uid$4;
var NATIVE_SYMBOL$1 = nativeSymbol;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var WellKnownSymbolsStore$1 = shared$2('wks');
var Symbol$1 = global$g.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$2;

var wellKnownSymbol$o = function (name) {
  if (!has$9(WellKnownSymbolsStore$1, name) || !(NATIVE_SYMBOL$1 || typeof WellKnownSymbolsStore$1[name] == 'string')) {
    if (NATIVE_SYMBOL$1 && has$9(Symbol$1, name)) {
      WellKnownSymbolsStore$1[name] = Symbol$1[name];
    } else {
      WellKnownSymbolsStore$1[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore$1[name];
};

var wellKnownSymbolWrapped = {};

var wellKnownSymbol$n = wellKnownSymbol$o;

wellKnownSymbolWrapped.f = wellKnownSymbol$n;

var path = path$2;
var has$8 = has$f;
var wrappedWellKnownSymbolModule$1 = wellKnownSymbolWrapped;
var defineProperty$7 = objectDefineProperty.f;

var defineWellKnownSymbol$1 = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has$8(Symbol, NAME)) defineProperty$7(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule$1.f(NAME)
  });
};

var defineProperty$6 = objectDefineProperty.f;
var has$7 = has$f;
var wellKnownSymbol$m = wellKnownSymbol$o;

var TO_STRING_TAG$3 = wellKnownSymbol$m('toStringTag');

var setToStringTag$7 = function (it, TAG, STATIC) {
  if (it && !has$7(it = STATIC ? it : it.prototype, TO_STRING_TAG$3)) {
    defineProperty$6(it, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var aFunction$6 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

var aFunction$5 = aFunction$6;

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction$5(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var isObject$d = isObject$i;
var isArray$4 = isArray$5;
var wellKnownSymbol$l = wellKnownSymbol$o;

var SPECIES$6 = wellKnownSymbol$l('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$3 = function (originalArray, length) {
  var C;
  if (isArray$4(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray$4(C.prototype))) C = undefined;
    else if (isObject$d(C)) {
      C = C[SPECIES$6];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var bind$6 = functionBindContext;
var IndexedObject$3 = indexedObject;
var toObject$a = toObject$c;
var toLength$b = toLength$d;
var arraySpeciesCreate$2 = arraySpeciesCreate$3;

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod$5 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject$a($this);
    var self = IndexedObject$3(O);
    var boundFunction = bind$6(callbackfn, that, 3);
    var length = toLength$b(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate$2;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$5(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$5(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$5(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$5(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$5(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$5(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$5(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod$5(7)
};

var $$D = _export;
var global$f = global$s;
var getBuiltIn$3 = getBuiltIn$7;
var DESCRIPTORS$8 = descriptors;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;
var fails$l = fails$r;
var has$6 = has$f;
var isArray$3 = isArray$5;
var isObject$c = isObject$i;
var anObject$d = anObject$i;
var toObject$9 = toObject$c;
var toIndexedObject$4 = toIndexedObject$9;
var toPrimitive$2 = toPrimitive$5;
var createPropertyDescriptor$3 = createPropertyDescriptor$6;
var nativeObjectCreate = objectCreate;
var objectKeys$2 = objectKeys$4;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertyNamesExternal = objectGetOwnPropertyNamesExternal;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$3 = objectDefineProperty;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$a;
var redefine$b = redefine$d.exports;
var shared$1 = shared$5.exports;
var sharedKey$1 = sharedKey$4;
var hiddenKeys$1 = hiddenKeys$6;
var uid$1 = uid$4;
var wellKnownSymbol$k = wellKnownSymbol$o;
var wrappedWellKnownSymbolModule = wellKnownSymbolWrapped;
var defineWellKnownSymbol = defineWellKnownSymbol$1;
var setToStringTag$6 = setToStringTag$7;
var InternalStateModule$6 = internalState;
var $forEach$1 = arrayIteration.forEach;

var HIDDEN$1 = sharedKey$1('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol$k('toPrimitive');
var setInternalState$6 = InternalStateModule$6.set;
var getInternalState$3 = InternalStateModule$6.getterFor(SYMBOL);
var ObjectPrototype$1 = Object[PROTOTYPE];
var $Symbol = global$f.Symbol;
var $stringify = getBuiltIn$3('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule$3.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule$1.f;
var AllSymbols = shared$1('symbols');
var ObjectPrototypeSymbols = shared$1('op-symbols');
var StringToSymbolRegistry = shared$1('string-to-symbol-registry');
var SymbolToStringRegistry = shared$1('symbol-to-string-registry');
var WellKnownSymbolsStore = shared$1('wks');
var QObject = global$f.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS$8 && fails$l(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype$1, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype$1[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$1) {
    nativeDefineProperty(ObjectPrototype$1, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState$6(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS$8) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype$1) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject$d(O);
  var key = toPrimitive$2(P, true);
  anObject$d(Attributes);
  if (has$6(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has$6(O, HIDDEN$1)) nativeDefineProperty(O, HIDDEN$1, createPropertyDescriptor$3(1, {}));
      O[HIDDEN$1][key] = true;
    } else {
      if (has$6(O, HIDDEN$1) && O[HIDDEN$1][key]) O[HIDDEN$1][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor$3(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject$d(O);
  var properties = toIndexedObject$4(Properties);
  var keys = objectKeys$2(properties).concat($getOwnPropertySymbols(properties));
  $forEach$1(keys, function (key) {
    if (!DESCRIPTORS$8 || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive$2(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype$1 && has$6(AllSymbols, P) && !has$6(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has$6(this, P) || !has$6(AllSymbols, P) || has$6(this, HIDDEN$1) && this[HIDDEN$1][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject$4(O);
  var key = toPrimitive$2(P, true);
  if (it === ObjectPrototype$1 && has$6(AllSymbols, key) && !has$6(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has$6(AllSymbols, key) && !(has$6(it, HIDDEN$1) && it[HIDDEN$1][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject$4(O));
  var result = [];
  $forEach$1(names, function (key) {
    if (!has$6(AllSymbols, key) && !has$6(hiddenKeys$1, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$1;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject$4(O));
  var result = [];
  $forEach$1(names, function (key) {
    if (has$6(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has$6(ObjectPrototype$1, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid$1(description);
    var setter = function (value) {
      if (this === ObjectPrototype$1) setter.call(ObjectPrototypeSymbols, value);
      if (has$6(this, HIDDEN$1) && has$6(this[HIDDEN$1], tag)) this[HIDDEN$1][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor$3(1, value));
    };
    if (DESCRIPTORS$8 && USE_SETTER) setSymbolDescriptor(ObjectPrototype$1, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine$b($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState$3(this).tag;
  });

  redefine$b($Symbol, 'withoutSetter', function (description) {
    return wrap(uid$1(description), description);
  });

  propertyIsEnumerableModule$1.f = $propertyIsEnumerable;
  definePropertyModule$3.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule$1.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol$k(name), name);
  };

  if (DESCRIPTORS$8) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState$3(this).description;
      }
    });
    {
      redefine$b(ObjectPrototype$1, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$$D({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach$1(objectKeys$2(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$$D({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has$6(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has$6(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$$D({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS$8 }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$$D({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$$D({ target: 'Object', stat: true, forced: fails$l(function () { getOwnPropertySymbolsModule$1.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule$1.f(toObject$9(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails$l(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $$D({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject$c(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray$3(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty$5($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag$6($Symbol, SYMBOL);

hiddenKeys$1[HIDDEN$1] = true;

var $$C = _export;
var DESCRIPTORS$7 = descriptors;
var global$e = global$s;
var has$5 = has$f;
var isObject$b = isObject$i;
var defineProperty$5 = objectDefineProperty.f;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$e.Symbol;

if (DESCRIPTORS$7 && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty$5(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject$b(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has$5(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$C({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

var _templateObject$n;
var centerBase = styled.css(["bottom:0;left:0;margin:auto;position:absolute;right:0;top:0;"]);
var Circles = styled__default["default"](united.Relative)(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: ", ";\n  display: flex;\n  height: 56px;\n  justify-content: center;\n  width: 56px;\n\n  svg {\n    position: relative;\n    z-index: 1;\n  }\n\n  &:before {\n    background-color: ", ";\n    border-radius: ", ";\n    content: '';\n    height: 48px;\n    width: 48px;\n    ", "\n  }\n\n  &:after {\n    background-color: ", ";\n    border-radius: ", ";\n    content: '';\n    height: 40px;\n    width: 40px;\n    ", "\n  }\n"])), function (_ref) {
  var color = _ref.color;
  return "".concat(color, "4d");
}, themeGet.themeGet('olist.borderRadius.circle'), function (_ref2) {
  var color = _ref2.color;
  return "".concat(color, "80");
}, themeGet.themeGet('olist.borderRadius.circle'), centerBase, function (_ref3) {
  var color = _ref3.color;
  return color;
}, themeGet.themeGet('olist.borderRadius.circle'), centerBase);

var getAction = function getAction(action) {
  if ( /*#__PURE__*/React__default["default"].isValidElement(action)) {
    return action;
  }

  if (action.href) {
    return /*#__PURE__*/React__default["default"].createElement(united.Link, {
      "data-ref": "action",
      href: action.href,
      target: action.newWindow ? '_blank' : '_self'
    }, action.label);
  }

  if (action.onClick) {
    return /*#__PURE__*/React__default["default"].createElement(united.Button, {
      "data-ref": "action-button",
      variation: "default",
      onClick: action.onClick
    }, action.label);
  }

  return false;
};

var inverter = 'olist.color.neutral.softest';
var cardVariation = {
  alternate: {
    color: 'olist.color.primary.base',
    inverter: inverter
  },
  primary: {
    color: 'olist.color.accent.base',
    inverter: inverter
  },
  accent: {
    color: 'olist.color.informative.base',
    inverter: inverter
  },
  warning: {
    color: 'olist.color.notice.base',
    inverter: inverter
  },
  danger: {
    color: 'olist.color.alert.base',
    inverter: inverter
  },
  shadow: {
    color: 'olist.color.neutral.soft',
    inverter: inverter
  },
  "default": {
    color: 'olist.color.neutral.softer',
    inverter: inverter
  },
  link: {
    color: 'olist.color.primary.base',
    inverter: inverter
  },
  text: {
    color: 'olist.color.neutral.stronger',
    inverter: inverter
  }
};

var CardFeedback = function CardFeedback(_ref) {
  var action = _ref.action,
      description = _ref.description,
      highlight = _ref.highlight,
      icon = _ref.icon,
      title = _ref.title,
      variation = _ref.variation,
      props = _objectWithoutProperties(_ref, ["action", "description", "highlight", "icon", "title", "variation"]);

  var theme = styled.useTheme();
  var cardColors = cardVariation[variation] || {};
  return /*#__PURE__*/React__default["default"].createElement(united.Card, _extends({
    "data-ref": "card",
    variation: variation,
    px: 4,
    py: 3
  }, props), /*#__PURE__*/React__default["default"].createElement(united.Flex, {
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React__default["default"].createElement(united.Flex, {
    flex: 1
  }, !!icon && highlight && /*#__PURE__*/React__default["default"].createElement(Circles, {
    alignSelf: "center",
    "data-ref": "highlight",
    color: themeGet.themeGet(cardColors.color)({
      theme: theme
    }) || united.getColor(variation),
    mr: 3
  }, /*#__PURE__*/React__default["default"].isValidElement(icon) ? icon : /*#__PURE__*/React__default["default"].createElement(united.Icon, {
    "data-ref": "icon",
    name: icon,
    color: themeGet.themeGet(cardColors.inverter)({
      theme: theme
    }) || united.getColor(variation, 'inverter'),
    size: 20
  })), !!icon && !highlight && /*#__PURE__*/React__default["default"].createElement(united.Box, {
    pt: "1px",
    pr: 2
  }, /*#__PURE__*/React__default["default"].isValidElement(icon) ? icon : /*#__PURE__*/React__default["default"].createElement(united.Icon, {
    "data-ref": "icon",
    name: icon,
    color: themeGet.themeGet(cardColors.color)({
      theme: theme
    }) || united.getColor(variation)
  })), /*#__PURE__*/React__default["default"].createElement(united.Box, {
    flex: 1,
    mr: 24
  }, !!title && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].isValidElement(title) ? title : /*#__PURE__*/React__default["default"].createElement(united.Text, {
    "data-ref": "title",
    fontSize: "large",
    fontWeight: "bold",
    variation: variation
  }, title)), !!description && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].isValidElement(description) ? description : /*#__PURE__*/React__default["default"].createElement(united.Text, {
    "data-ref": "description",
    color: themeGet.themeGet('olist.color.neutral.base')({
      theme: theme
    })
  }, description)))), !!action && getAction(action)));
};

CardFeedback.defaultProps = {
  action: undefined,
  description: '',
  highlight: false,
  icon: '',
  title: '',
  variation: 'alternate'
};

var _templateObject$m, _templateObject2$e;
var Info = styled__default["default"](united.Box)(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n  p {\n    padding-left: ", ";\n  }\n\n  a {\n    font-size: inherit;\n    color: ", ";\n  }\n"])), themeGet.themeGet('olist.spacing.inline.medium'), themeGet.themeGet('olist.color.primary.base'));
var Title$3 = styled__default["default"](united.Flex)(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n  align-items: center;\n  flex-direction: row;\n\n  h5 {\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    margin: 0 0 0 ", ";\n    padding: 0;\n  }\n"])), themeGet.themeGet('olist.color.primary.base'), themeGet.themeGet('olist.fontSize.large'), themeGet.themeGet('olist.fontWeight.bold'), themeGet.themeGet('olist.lineHeight.medium'), themeGet.themeGet('olist.spacing.inline.1xsmall'));
Info.Title = Title$3;

var Condition = function Condition(_ref) {
  var when = _ref.when,
      is = _ref.is,
      children = _ref.children;
  return /*#__PURE__*/React__default["default"].createElement(reactFinalForm.Field, {
    name: when,
    subscription: {
      value: true
    }
  }, function (_ref2) {
    var value = _ref2.input.value;
    return value === is ? children : null;
  });
};

var toPrimitive$1 = toPrimitive$5;
var definePropertyModule$2 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$6;

var createProperty$5 = function (object, key, value) {
  var propertyKey = toPrimitive$1(key);
  if (propertyKey in object) definePropertyModule$2.f(object, propertyKey, createPropertyDescriptor$2(0, value));
  else object[propertyKey] = value;
};

var fails$k = fails$r;
var wellKnownSymbol$j = wellKnownSymbol$o;
var V8_VERSION$2 = engineV8Version;

var SPECIES$5 = wellKnownSymbol$j('species');

var arrayMethodHasSpeciesSupport$5 = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION$2 >= 51 || !fails$k(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$5] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var $$B = _export;
var isObject$a = isObject$i;
var isArray$2 = isArray$5;
var toAbsoluteIndex$1 = toAbsoluteIndex$3;
var toLength$a = toLength$d;
var toIndexedObject$3 = toIndexedObject$9;
var createProperty$4 = createProperty$5;
var wellKnownSymbol$i = wellKnownSymbol$o;
var arrayMethodHasSpeciesSupport$4 = arrayMethodHasSpeciesSupport$5;

var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport$4('slice');

var SPECIES$4 = wellKnownSymbol$i('species');
var nativeSlice = [].slice;
var max$2 = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$$B({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$3 }, {
  slice: function slice(start, end) {
    var O = toIndexedObject$3(this);
    var length = toLength$a(O.length);
    var k = toAbsoluteIndex$1(start, length);
    var fin = toAbsoluteIndex$1(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray$2(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray$2(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject$a(Constructor)) {
        Constructor = Constructor[SPECIES$4];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max$2(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty$4(result, n, O[k]);
    result.length = n;
    return result;
  }
});

var Fields = function Fields(_ref) {
  var names = _ref.names,
      subscription = _ref.subscription,
      _ref$fieldsState = _ref.fieldsState,
      fieldsState = _ref$fieldsState === void 0 ? {} : _ref$fieldsState,
      children = _ref.children,
      originalRender = _ref.originalRender;

  if (!names.length) {
    return (originalRender || children)(fieldsState);
  }

  var _names = _toArray(names),
      name = _names[0],
      rest = _names.slice(1);

  return /*#__PURE__*/React__default["default"].createElement(reactFinalForm.Field, {
    name: name,
    subscription: subscription
  }, function (fieldState) {
    return /*#__PURE__*/React__default["default"].createElement(Fields, {
      names: rest,
      subscription: subscription,
      originalRender: originalRender || children,
      fieldsState: _objectSpread2(_objectSpread2({}, fieldsState), {}, _defineProperty({}, name, fieldState))
    });
  });
};

Fields.defaultProps = {
  subscription: undefined,
  originalRender: null
};

var DESCRIPTORS$6 = descriptors;
var defineProperty$4 = objectDefineProperty.f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS$6 && !(NAME in FunctionPrototype)) {
  defineProperty$4(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}

var getErrors = function getErrors(meta, initialErrors) {
  var getClientErrors = meta.touched && meta.error;
  var getServerErrors = !meta.dirtySinceLastSubmit && (meta.submitError || initialErrors);
  return getClientErrors || getServerErrors;
};

var InputLabelError = function InputLabelError(_ref) {
  var initialErrors = _ref.initialErrors,
      label = _ref.label,
      mask = _ref.mask,
      name = _ref.name,
      onBlur = _ref.onBlur,
      optionalLabel = _ref.optionalLabel,
      showMessages = _ref.showMessages,
      rest = _objectWithoutProperties(_ref, ["initialErrors", "label", "mask", "name", "onBlur", "optionalLabel", "showMessages"]);

  var theme = styled.useTheme();

  var handleBlur = function handleBlur(input, meta) {
    return function (event) {
      input.onBlur(event);
      onBlur(event, input, meta);
    };
  };

  return /*#__PURE__*/React__default["default"].createElement(reactFinalForm.Field, _extends({}, rest, {
    name: name
  }), function (_ref2) {
    var input = _ref2.input,
        meta = _ref2.meta;
    var defaultColor = themeGet.themeGet('olist.color.neutral.stronger')({
      theme: theme
    });
    var errorColor = themeGet.themeGet('olist.color.alert.base')({
      theme: theme
    });
    var errors = getErrors(meta, initialErrors[input.name]);
    var hasErrors = !!errors;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(united.Label, {
      color: errors !== null && errors !== void 0 && errors.length ? errorColor : defaultColor,
      htmlFor: input.name
    }, label, !!optionalLabel && /*#__PURE__*/React__default["default"].createElement(united.OptionalField, {
      ml: 1
    }, optionalLabel)), mask ? /*#__PURE__*/React__default["default"].createElement(MaskedInput__default["default"], _extends({}, rest, input, {
      error: hasErrors,
      id: input.name,
      mask: mask,
      onBlur: handleBlur(input, meta),
      render: function render(ref, props) {
        return /*#__PURE__*/React__default["default"].createElement(united.Input, _extends({
          ref: ref
        }, props));
      }
    })) : /*#__PURE__*/React__default["default"].createElement(united.Input, _extends({}, rest, input, {
      error: hasErrors,
      id: input.name,
      onBlur: handleBlur(input, meta)
    })), showMessages && hasErrors && /*#__PURE__*/React__default["default"].createElement(united.Box, {
      mt: 2
    }, /*#__PURE__*/React__default["default"].createElement(united.FieldError, {
      messages: errors
    })));
  });
};

InputLabelError.defaultProps = {
  initialErrors: {},
  mask: false,
  onBlur: function onBlur() {},
  showMessages: true,
  optionalLabel: ''
};

var SelectLabelError = function SelectLabelError(_ref) {
  var initialErrors = _ref.initialErrors,
      label = _ref.label,
      name = _ref.name,
      options = _ref.options,
      showMessages = _ref.showMessages,
      rest = _objectWithoutProperties(_ref, ["initialErrors", "label", "name", "options", "showMessages"]);

  return /*#__PURE__*/React__default["default"].createElement(reactFinalForm.Field, _extends({}, rest, {
    name: name
  }), function (_ref2) {
    var input = _ref2.input,
        meta = _ref2.meta;
    var errors = getErrors(meta, initialErrors[input.name]);
    var hasErrors = !!errors;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(united.Label, {
      htmlFor: input.name
    }, label), /*#__PURE__*/React__default["default"].createElement(united.SelectFilter, _extends({}, rest, input, {
      onOptionChange: function onOptionChange(option) {
        return !!option && input.onChange(option.value);
      },
      onInputBlur: input.onBlur,
      onInputFocus: input.onFocus,
      options: options,
      error: hasErrors,
      id: input.name
    })), showMessages && hasErrors && /*#__PURE__*/React__default["default"].createElement(united.Box, {
      mt: 2
    }, /*#__PURE__*/React__default["default"].createElement(united.FieldError, {
      messages: errors
    })));
  });
};

SelectLabelError.defaultProps = {
  initialErrors: {},
  showMessages: true
};

var $$A = _export;
var toAbsoluteIndex = toAbsoluteIndex$3;
var toInteger$4 = toInteger$7;
var toLength$9 = toLength$d;
var toObject$8 = toObject$c;
var arraySpeciesCreate$1 = arraySpeciesCreate$3;
var createProperty$3 = createProperty$5;
var arrayMethodHasSpeciesSupport$3 = arrayMethodHasSpeciesSupport$5;

var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport$3('splice');

var max$1 = Math.max;
var min$4 = Math.min;
var MAX_SAFE_INTEGER$1 = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$$A({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$2 }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject$8(this);
    var len = toLength$9(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$4(max$1(toInteger$4(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER$1) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate$1(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty$3(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});

var $$z = _export;
var $filter = arrayIteration.filter;
var arrayMethodHasSpeciesSupport$2 = arrayMethodHasSpeciesSupport$5;

var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport$2('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$$z({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var wellKnownSymbol$h = wellKnownSymbol$o;
var create$4 = objectCreate;
var definePropertyModule$1 = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$h('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  definePropertyModule$1.f(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$4(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$3 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$j = fails$r;

var correctPrototypeGetter = !fails$j(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var has$4 = has$f;
var toObject$7 = toObject$c;
var sharedKey = sharedKey$4;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject$7(O);
  if (has$4(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};

var fails$i = fails$r;
var getPrototypeOf$1 = objectGetPrototypeOf;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$a;
var has$3 = has$f;
var wellKnownSymbol$g = wellKnownSymbol$o;

var ITERATOR$7 = wellKnownSymbol$g('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

var returnThis$2 = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$i(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$7].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!has$3(IteratorPrototype$2, ITERATOR$7)) {
  createNonEnumerableProperty$4(IteratorPrototype$2, ITERATOR$7, returnThis$2);
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$3 = objectCreate;
var createPropertyDescriptor$1 = createPropertyDescriptor$6;
var setToStringTag$5 = setToStringTag$7;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$2 = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$3(IteratorPrototype$1, { next: createPropertyDescriptor$1(1, next) });
  setToStringTag$5(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var isObject$9 = isObject$i;

var aPossiblePrototype$1 = function (it) {
  if (!isObject$9(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

/* eslint-disable no-proto -- safe */

var anObject$c = anObject$i;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$c(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$y = _export;
var createIteratorConstructor$1 = createIteratorConstructor$2;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$2 = objectSetPrototypeOf;
var setToStringTag$4 = setToStringTag$7;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$a;
var redefine$a = redefine$d.exports;
var wellKnownSymbol$f = wellKnownSymbol$o;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$6 = wellKnownSymbol$f('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$3 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$6]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$2) {
          setPrototypeOf$2(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR$6] != 'function') {
          createNonEnumerableProperty$3(CurrentIteratorPrototype, ITERATOR$6, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$4(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if (IterablePrototype[ITERATOR$6] !== defaultIterator) {
    createNonEnumerableProperty$3(IterablePrototype, ITERATOR$6, defaultIterator);
  }
  Iterators$3[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine$a(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$y({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var toIndexedObject$2 = toIndexedObject$9;
var addToUnscopables$2 = addToUnscopables$3;
var Iterators$2 = iterators;
var InternalStateModule$5 = internalState;
var defineIterator$2 = defineIterator$3;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$5 = InternalStateModule$5.set;
var getInternalState$2 = InternalStateModule$5.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator$2(Array, 'Array', function (iterated, kind) {
  setInternalState$5(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject$2(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$2(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$2('keys');
addToUnscopables$2('values');
addToUnscopables$2('entries');

var wellKnownSymbol$e = wellKnownSymbol$o;

var TO_STRING_TAG$2 = wellKnownSymbol$e('toStringTag');
var test$1 = {};

test$1[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test$1) === '[object z]';

var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
var classofRaw = classofRaw$1;
var wellKnownSymbol$d = wellKnownSymbol$o;

var TO_STRING_TAG$1 = wellKnownSymbol$d('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$8 = TO_STRING_TAG_SUPPORT$2 ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
var classof$7 = classof$8;

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString = TO_STRING_TAG_SUPPORT$1 ? {}.toString : function toString() {
  return '[object ' + classof$7(this) + ']';
};

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var redefine$9 = redefine$d.exports;
var toString = objectToString;

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine$9(Object.prototype, 'toString', toString, { unsafe: true });
}

var internalMetadata = {exports: {}};

var fails$h = fails$r;

var freezing = !fails$h(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});

var hiddenKeys = hiddenKeys$6;
var isObject$8 = isObject$i;
var has$2 = has$f;
var defineProperty$3 = objectDefineProperty.f;
var uid = uid$4;
var FREEZING$1 = freezing;

var METADATA = uid('meta');
var id = 0;

// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty$3(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey$1 = function (it, create) {
  // return a primitive with prefix
  if (!isObject$8(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has$2(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has$2(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze$1 = function (it) {
  if (FREEZING$1 && meta.REQUIRED && isExtensible(it) && !has$2(it, METADATA)) setMetadata(it);
  return it;
};

var meta = internalMetadata.exports = {
  REQUIRED: false,
  fastKey: fastKey$1,
  getWeakData: getWeakData,
  onFreeze: onFreeze$1
};

hiddenKeys[METADATA] = true;

var wellKnownSymbol$c = wellKnownSymbol$o;
var Iterators$1 = iterators;

var ITERATOR$5 = wellKnownSymbol$c('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$2 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$5] === it);
};

var classof$6 = classof$8;
var Iterators = iterators;
var wellKnownSymbol$b = wellKnownSymbol$o;

var ITERATOR$4 = wellKnownSymbol$b('iterator');

var getIteratorMethod$4 = function (it) {
  if (it != undefined) return it[ITERATOR$4]
    || it['@@iterator']
    || Iterators[classof$6(it)];
};

var anObject$b = anObject$i;

var iteratorClose$2 = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject$b(returnMethod.call(iterator)).value;
  }
};

var anObject$a = anObject$i;
var isArrayIteratorMethod$1 = isArrayIteratorMethod$2;
var toLength$8 = toLength$d;
var bind$5 = functionBindContext;
var getIteratorMethod$3 = getIteratorMethod$4;
var iteratorClose$1 = iteratorClose$2;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate$4 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$5(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose$1(iterator);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$a(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$3(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod$1(iterFn)) {
      for (index = 0, length = toLength$8(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose$1(iterator);
      throw error;
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

var anInstance$5 = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};

var wellKnownSymbol$a = wellKnownSymbol$o;

var ITERATOR$3 = wellKnownSymbol$a('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$3] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$2 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$3] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var isObject$7 = isObject$i;
var setPrototypeOf$1 = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$2 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf$1 &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject$7(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf$1($this, NewTargetPrototype);
  return $this;
};

var $$x = _export;
var global$d = global$s;
var isForced$2 = isForced_1;
var redefine$8 = redefine$d.exports;
var InternalMetadataModule = internalMetadata.exports;
var iterate$3 = iterate$4;
var anInstance$4 = anInstance$5;
var isObject$6 = isObject$i;
var fails$g = fails$r;
var checkCorrectnessOfIteration$1 = checkCorrectnessOfIteration$2;
var setToStringTag$3 = setToStringTag$7;
var inheritIfRequired$1 = inheritIfRequired$2;

var collection$1 = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global$d[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine$8(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject$6(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject$6(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject$6(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced$2(
    CONSTRUCTOR_NAME,
    typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails$g(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.REQUIRED = true;
  } else if (isForced$2(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails$g(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration$1(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails$g(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance$4(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired$1(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate$3(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $$x({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag$3(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};

var redefine$7 = redefine$d.exports;

var redefineAll$3 = function (target, src, options) {
  for (var key in src) redefine$7(target, key, src[key], options);
  return target;
};

var getBuiltIn$2 = getBuiltIn$7;
var definePropertyModule = objectDefineProperty;
var wellKnownSymbol$9 = wellKnownSymbol$o;
var DESCRIPTORS$5 = descriptors;

var SPECIES$3 = wellKnownSymbol$9('species');

var setSpecies$2 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$2(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS$5 && Constructor && !Constructor[SPECIES$3]) {
    defineProperty(Constructor, SPECIES$3, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var defineProperty$2 = objectDefineProperty.f;
var create$2 = objectCreate;
var redefineAll$2 = redefineAll$3;
var bind$4 = functionBindContext;
var anInstance$3 = anInstance$5;
var iterate$2 = iterate$4;
var defineIterator$1 = defineIterator$3;
var setSpecies$1 = setSpecies$2;
var DESCRIPTORS$4 = descriptors;
var fastKey = internalMetadata.exports.fastKey;
var InternalStateModule$4 = internalState;

var setInternalState$4 = InternalStateModule$4.set;
var internalStateGetterFor = InternalStateModule$4.getterFor;

var collectionStrong$1 = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance$3(that, C, CONSTRUCTOR_NAME);
      setInternalState$4(that, {
        type: CONSTRUCTOR_NAME,
        index: create$2(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS$4) that.size = 0;
      if (iterable != undefined) iterate$2(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS$4) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll$2(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS$4) state.size = 0;
        else that.size = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS$4) state.size--;
          else that.size--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind$4(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll$2(C.prototype, IS_MAP ? {
      // 23.1.3.6 Map.prototype.get(key)
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // 23.1.3.9 Map.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // 23.2.3.1 Set.prototype.add(value)
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS$4) defineProperty$2(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    defineIterator$1(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState$4(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies$1(CONSTRUCTOR_NAME);
  }
};

var collection = collection$1;
var collectionStrong = collectionStrong$1;

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);

var toInteger$3 = toInteger$7;
var requireObjectCoercible$a = requireObjectCoercible$d;

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$4 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible$a($this));
    var position = toInteger$3(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$4(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$4(true)
};

var charAt$1 = stringMultibyte.charAt;
var InternalStateModule$3 = internalState;
var defineIterator = defineIterator$3;

var STRING_ITERATOR = 'String Iterator';
var setInternalState$3 = InternalStateModule$3.set;
var getInternalState$1 = InternalStateModule$3.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState$3(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$1(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt$1(string, index);
  state.index += point.length;
  return { value: point, done: false };
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var global$c = global$s;
var DOMIterables$1 = domIterables;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$a;
var wellKnownSymbol$8 = wellKnownSymbol$o;

var ITERATOR$2 = wellKnownSymbol$8('iterator');
var TO_STRING_TAG = wellKnownSymbol$8('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME$1 in DOMIterables$1) {
  var Collection$1 = global$c[COLLECTION_NAME$1];
  var CollectionPrototype$1 = Collection$1 && Collection$1.prototype;
  if (CollectionPrototype$1) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype$1[ITERATOR$2] !== ArrayValues) try {
      createNonEnumerableProperty$2(CollectionPrototype$1, ITERATOR$2, ArrayValues);
    } catch (error) {
      CollectionPrototype$1[ITERATOR$2] = ArrayValues;
    }
    if (!CollectionPrototype$1[TO_STRING_TAG]) {
      createNonEnumerableProperty$2(CollectionPrototype$1, TO_STRING_TAG, COLLECTION_NAME$1);
    }
    if (DOMIterables$1[COLLECTION_NAME$1]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype$1[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$2(CollectionPrototype$1, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype$1[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}

var MAX_FILE_SIZE = 10485760;
var VARIATION_DEFAULT = 'default';
var VARIATION_INVERTER = 'inverter';

var $$w = _export;
var fails$f = fails$r;
var isArray$1 = isArray$5;
var isObject$5 = isObject$i;
var toObject$6 = toObject$c;
var toLength$7 = toLength$d;
var createProperty$2 = createProperty$5;
var arraySpeciesCreate = arraySpeciesCreate$3;
var arrayMethodHasSpeciesSupport$1 = arrayMethodHasSpeciesSupport$5;
var wellKnownSymbol$7 = wellKnownSymbol$o;
var V8_VERSION$1 = engineV8Version;

var IS_CONCAT_SPREADABLE = wellKnownSymbol$7('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION$1 >= 51 || !fails$f(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport$1('concat');

var isConcatSpreadable = function (O) {
  if (!isObject$5(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray$1(O);
};

var FORCED$5 = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$$w({ target: 'Array', proto: true, forced: FORCED$5 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject$6(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength$7(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty$2(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty$2(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

var toInteger$2 = toInteger$7;
var requireObjectCoercible$9 = requireObjectCoercible$d;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
var stringRepeat = function repeat(count) {
  var str = String(requireObjectCoercible$9(this));
  var result = '';
  var n = toInteger$2(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

// https://github.com/tc39/proposal-string-pad-start-end
var toLength$6 = toLength$d;
var repeat$2 = stringRepeat;
var requireObjectCoercible$8 = requireObjectCoercible$d;

var ceil = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod$3 = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = String(requireObjectCoercible$8($this));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : String(fillString);
    var intMaxLength = toLength$6(maxLength);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr == '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat$2.call(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

var stringPad = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod$3(false),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: createMethod$3(true)
};

var fails$e = fails$r;
var padStart = stringPad.start;

var abs = Math.abs;
var DatePrototype$1 = Date.prototype;
var getTime$1 = DatePrototype$1.getTime;
var nativeDateToISOString = DatePrototype$1.toISOString;

// `Date.prototype.toISOString` method implementation
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit fails here:
var dateToIsoString = (fails$e(function () {
  return nativeDateToISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails$e(function () {
  nativeDateToISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime$1.call(this))) throw RangeError('Invalid time value');
  var date = this;
  var year = date.getUTCFullYear();
  var milliseconds = date.getUTCMilliseconds();
  var sign = year < 0 ? '-' : year > 9999 ? '+' : '';
  return sign + padStart(abs(year), sign ? 6 : 4, 0) +
    '-' + padStart(date.getUTCMonth() + 1, 2, 0) +
    '-' + padStart(date.getUTCDate(), 2, 0) +
    'T' + padStart(date.getUTCHours(), 2, 0) +
    ':' + padStart(date.getUTCMinutes(), 2, 0) +
    ':' + padStart(date.getUTCSeconds(), 2, 0) +
    '.' + padStart(milliseconds, 3, 0) +
    'Z';
} : nativeDateToISOString;

var $$v = _export;
var toISOString = dateToIsoString;

// `Date.prototype.toISOString` method
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit has a broken implementations
$$v({ target: 'Date', proto: true, forced: Date.prototype.toISOString !== toISOString }, {
  toISOString: toISOString
});

var anObject$9 = anObject$i;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$9(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var regexpStickyHelpers = {};

var fails$d = fails$r;

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

regexpStickyHelpers.UNSUPPORTED_Y = fails$d(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

regexpStickyHelpers.BROKEN_CARET = fails$d(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

/* eslint-disable regexp/no-assertion-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var regexpFlags = regexpFlags$1;
var stickyHelpers$1 = regexpStickyHelpers;
var shared = shared$5.exports;

var nativeExec = RegExp.prototype.exec;
var nativeReplace = shared('native-string-replace', String.prototype.replace);

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = stickyHelpers$1.UNSUPPORTED_Y || stickyHelpers$1.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var regexpExec$3 = patchedExec;

var $$u = _export;
var exec = regexpExec$3;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$u({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var redefine$6 = redefine$d.exports;
var regexpExec$2 = regexpExec$3;
var fails$c = fails$r;
var wellKnownSymbol$6 = wellKnownSymbol$o;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$a;

var SPECIES$2 = wellKnownSymbol$6('species');
var RegExpPrototype$1 = RegExp.prototype;

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$c(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol$6('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$c(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var fixRegexpWellKnownSymbolLogic = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol$6(KEY);

  var DELEGATES_TO_SYMBOL = !fails$c(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$c(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$2] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$2 || $exec === RegExpPrototype$1.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine$6(String.prototype, KEY, stringMethod);
    redefine$6(RegExpPrototype$1, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty$1(RegExpPrototype$1[SYMBOL], 'sham', true);
};

var isObject$4 = isObject$i;
var classof$5 = classofRaw$1;
var wellKnownSymbol$5 = wellKnownSymbol$o;

var MATCH$1 = wellKnownSymbol$5('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$4(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$5(it) == 'RegExp');
};

var anObject$8 = anObject$i;
var aFunction$4 = aFunction$6;
var wellKnownSymbol$4 = wellKnownSymbol$o;

var SPECIES$1 = wellKnownSymbol$4('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$2 = function (O, defaultConstructor) {
  var C = anObject$8(O).constructor;
  var S;
  return C === undefined || (S = anObject$8(C)[SPECIES$1]) == undefined ? defaultConstructor : aFunction$4(S);
};

var charAt = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$2 = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

var classof$4 = classofRaw$1;
var regexpExec$1 = regexpExec$3;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof$4(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec$1.call(R, S);
};

var fixRegExpWellKnownSymbolLogic$2 = fixRegexpWellKnownSymbolLogic;
var isRegExp$1 = isRegexp;
var anObject$7 = anObject$i;
var requireObjectCoercible$7 = requireObjectCoercible$d;
var speciesConstructor$1 = speciesConstructor$2;
var advanceStringIndex$1 = advanceStringIndex$2;
var toLength$5 = toLength$d;
var callRegExpExec = regexpExecAbstract;
var regexpExec = regexpExec$3;
var stickyHelpers = regexpStickyHelpers;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var arrayPush = [].push;
var min$3 = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// @@split logic
fixRegExpWellKnownSymbolLogic$2('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible$7(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp$1(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible$7(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject$7(regexp);
      var S = String(this);
      var C = speciesConstructor$1(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? S.slice(q) : S);
        var e;
        if (
          z === null ||
          (e = min$3(toLength$5(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex$1(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, UNSUPPORTED_Y);

var toDate = function toDate(dateStr) {
  var endOfDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!dateStr) {
    return null;
  }

  var dateTime = luxon.DateTime.fromISO(dateStr);

  if (endOfDay) {
    return dateTime.endOf('day').toJSDate();
  }

  return dateTime.toJSDate();
};
var toLocalDateStringFormat = function toLocalDateStringFormat(isoDateString) {
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
  var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var dateTimeSeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';

  if (!isoDateString) {
    return null;
  }

  var dateFormat = {
    en: 'yyyy/MM/dd',
    'pt-br': 'dd/MM/yyyy'
  };
  var hourFormat = {
    en: 'h:mm a',
    'pt-br': 'HH:mm'
  };
  var parsedLang = lang.toLocaleLowerCase();
  var langDateFormat = dateFormat[parsedLang] || dateFormat.en;
  var langHourFormat = hourFormat[parsedLang] || hourFormat.en;
  var format = time ? langDateFormat.concat(dateTimeSeparator, langHourFormat) : langDateFormat;
  return luxon.DateTime.fromISO(isoDateString).toFormat(format);
};
var normalizeFormat = function normalizeFormat(date) {
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  if (!date) {
    return null;
  }

  var dateStr = date;

  if (date.toISOString) {
    try {
      dateStr = toLocalDateStringFormat(date.toISOString());
    } catch (_unused) {
      return null;
    }
  }

  var _dateStr$split = dateStr.split('/'),
      _dateStr$split2 = _slicedToArray(_dateStr$split, 3),
      year = _dateStr$split2[0],
      month = _dateStr$split2[1],
      day = _dateStr$split2[2];

  var parsedLang = lang.toLocaleLowerCase();

  if (parsedLang === 'pt-br') {
    var _dateStr$split3 = dateStr.split('/');

    var _dateStr$split4 = _slicedToArray(_dateStr$split3, 3);

    day = _dateStr$split4[0];
    month = _dateStr$split4[1];
    year = _dateStr$split4[2];
  }

  return "".concat(year, "-").concat(month, "-").concat(day);
};

var DATE_PATTERN = [/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/];
var DATE_PATTERN_PT_BR = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

var toObject$5 = toObject$c;

var floor$3 = Math.floor;
var replace$1 = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$5(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$1.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor$3(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var anObject$6 = anObject$i;
var toLength$4 = toLength$d;
var toInteger$1 = toInteger$7;
var requireObjectCoercible$6 = requireObjectCoercible$d;
var advanceStringIndex = advanceStringIndex$2;
var getSubstitution = getSubstitution$1;
var regExpExec$1 = regexpExecAbstract;

var max = Math.max;
var min$2 = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic$1('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$6(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject$6(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec$1(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength$4(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min$2(toInteger$1(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
});

// a string of all valid unicode whitespaces
var whitespaces$4 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var requireObjectCoercible$5 = requireObjectCoercible$d;
var whitespaces$3 = whitespaces$4;

var whitespace = '[' + whitespaces$3 + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$2 = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible$5($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$2(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$2(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$2(3)
};

var fails$b = fails$r;
var whitespaces$2 = whitespaces$4;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$b(function () {
    return !!whitespaces$2[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces$2[METHOD_NAME].name !== METHOD_NAME;
  });
};

var $$t = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$t({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

var getDigits = function getDigits() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return string.replace(/\D+/g, '');
};
var removeLeadingZeros = function removeLeadingZeros() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return string.replace(/^0+([0-9]+)/, '$1');
};

_objectSpread2(_objectSpread2({}, axios__default["default"].create({
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
})), {}, {
  cancelToken: axios__default["default"].CancelToken
});

var runtime = {exports: {}};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (module) {
var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
}(runtime));

var global$b = global$s;

var nativePromiseConstructor = global$b.Promise;

var userAgent$1 = engineUserAgent;

var engineIsIos = /(?:iphone|ipod|ipad).*applewebkit/i.test(userAgent$1);

var classof$3 = classofRaw$1;
var global$a = global$s;

var engineIsNode = classof$3(global$a.process) == 'process';

var global$9 = global$s;
var fails$a = fails$r;
var bind$3 = functionBindContext;
var html = html$2;
var createElement = documentCreateElement$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;

var location = global$9.location;
var set = global$9.setImmediate;
var clear = global$9.clearImmediate;
var process$2 = global$9.process;
var MessageChannel = global$9.MessageChannel;
var Dispatch = global$9.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins -- safe
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$9.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$3(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$9.addEventListener &&
    typeof postMessage == 'function' &&
    !global$9.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails$a(post)
  ) {
    defer = post;
    global$9.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var global$8 = global$s;
var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;

var MutationObserver$1 = global$8.MutationObserver || global$8.WebKitMutationObserver;
var document$2 = global$8.document;
var process$1 = global$8.process;
var Promise$1 = global$8.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$3(global$8, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$1.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver$1 && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver$1(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = promise.then;
    notify$1 = function () {
      then.call(promise, flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify$1 = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global$8, flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var newPromiseCapability$2 = {};

var aFunction$3 = aFunction$6;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction$3(resolve);
  this.reject = aFunction$3(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var anObject$5 = anObject$i;
var isObject$3 = isObject$i;
var newPromiseCapability$1 = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$5(C);
  if (isObject$3(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var global$7 = global$s;

var hostReportErrors$1 = function (a, b) {
  var console = global$7.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$1 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var engineIsBrowser = typeof window == 'object';

var $$s = _export;
var global$6 = global$s;
var getBuiltIn$1 = getBuiltIn$7;
var NativePromise = nativePromiseConstructor;
var redefine$5 = redefine$d.exports;
var redefineAll$1 = redefineAll$3;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag$2 = setToStringTag$7;
var setSpecies = setSpecies$2;
var isObject$2 = isObject$i;
var aFunction$2 = aFunction$6;
var anInstance$2 = anInstance$5;
var inspectSource = inspectSource$3;
var iterate$1 = iterate$4;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$2;
var speciesConstructor = speciesConstructor$2;
var task = task$1.set;
var microtask = microtask$1;
var promiseResolve = promiseResolve$1;
var hostReportErrors = hostReportErrors$1;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform = perform$1;
var InternalStateModule$2 = internalState;
var isForced$1 = isForced_1;
var wellKnownSymbol$3 = wellKnownSymbol$o;
var IS_BROWSER = engineIsBrowser;
var IS_NODE$1 = engineIsNode;
var V8_VERSION = engineV8Version;

var SPECIES = wellKnownSymbol$3('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule$2.get;
var setInternalState$2 = InternalStateModule$2.set;
var getInternalPromiseState = InternalStateModule$2.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromiseConstructorPrototype = NativePromisePrototype;
var TypeError$1 = global$6.TypeError;
var document$1 = global$6.document;
var process = global$6.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$6.dispatchEvent);
var NATIVE_REJECTION_EVENT = typeof PromiseRejectionEvent == 'function';
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED$4 = isForced$1(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION = FORCED$4 || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject$2(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$6.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global$6['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  task.call(global$6, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE$1) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$1 || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  task.call(global$6, function () {
    var promise = state.facade;
    if (IS_NODE$1) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$2 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind$2(internalResolve, wrapper, state),
            bind$2(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance$2(this, PromiseConstructor, PROMISE);
    aFunction$2(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind$2(internalResolve, state), bind$2(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromiseConstructorPrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$2(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll$1(PromiseConstructorPrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE$1 ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind$2(internalResolve, state);
    this.reject = bind$2(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (typeof NativePromise == 'function' && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine$5(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          nativeThen.call(that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine$5(NativePromisePrototype, 'catch', PromiseConstructorPrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromiseConstructorPrototype);
    }
  }
}

$$s({ global: true, wrap: true, forced: FORCED$4 }, {
  Promise: PromiseConstructor
});

setToStringTag$2(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn$1(PROMISE);

// statics
$$s({ target: PROMISE, stat: true, forced: FORCED$4 }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$$s({ target: PROMISE, stat: true, forced: FORCED$4 }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

$$s({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction$2(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction$2(C.resolve);
      iterate$1(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var fails$9 = fails$r;

var arrayMethodIsStrict$7 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$9(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $forEach = arrayIteration.forEach;
var arrayMethodIsStrict$6 = arrayMethodIsStrict$7;

var STRICT_METHOD$6 = arrayMethodIsStrict$6('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD$6 ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

var $$r = _export;
var forEach$1 = arrayForEach;

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$$r({ target: 'Array', proto: true, forced: [].forEach != forEach$1 }, {
  forEach: forEach$1
});

var global$5 = global$s;
var DOMIterables = domIterables;
var forEach = arrayForEach;
var createNonEnumerableProperty = createNonEnumerableProperty$a;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global$5[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}

var $$q = _export;
var toObject$4 = toObject$c;
var nativeKeys = objectKeys$4;
var fails$8 = fails$r;

var FAILS_ON_PRIMITIVES$1 = fails$8(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$$q({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$1 }, {
  keys: function keys(it) {
    return nativeKeys(toObject$4(it));
  }
});

var debounce = function debounce(fn, time) {
  var timeout; // eslint-disable-next-line func-names

  return function () {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var functionCall = function functionCall() {
      return fn.apply(_this, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(functionCall, time);
  };
};

var $$p = _export;
var $includes = arrayIncludes.includes;
var addToUnscopables$1 = addToUnscopables$3;

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$p({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('includes');

var isRegExp = isRegexp;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$2 = wellKnownSymbol$o;

var MATCH = wellKnownSymbol$2('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$o = _export;
var notARegExp$2 = notARegexp;
var requireObjectCoercible$4 = requireObjectCoercible$d;
var correctIsRegExpLogic$2 = correctIsRegexpLogic;

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$o({ target: 'String', proto: true, forced: !correctIsRegExpLogic$2('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible$4(this))
      .indexOf(notARegExp$2(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});

var remount_es5 = {exports: {}};

(function (module, exports) {
(function (global, factory) {
  factory(exports, React__default["default"], require$$1__default["default"]) ;
}(commonjsGlobal, function (exports, React, ReactDOM) {
  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }

  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  /* global HTMLElement */

  /*
   * Adapted from https://cdn.jsdelivr.net/npm/@webcomponents/webcomponentsjs@2.0.4/custom-elements-es5-adapter.js
   * Rolling this in so we don't need another polyfill.
   */
  function inject() {
    if (window.HTMLElement && window.HTMLElement._babelES5Adapter || void 0 === window.Reflect || void 0 === window.customElements || window.customElements.hasOwnProperty('polyfillWrapFlushCallback')) {
      return;
    }

    var a = HTMLElement;

    window.HTMLElement = function () {
      return Reflect.construct(a, [], this.constructor);
    };

    HTMLElement.prototype = a.prototype;
    HTMLElement.prototype.constructor = HTMLElement;
    Object.setPrototypeOf(HTMLElement, a);
    HTMLElement._babelES5Adapter = true;
  }

  /**
   * The name of this strategy.
   * @type string
   */

  var name = 'CustomElements';
  /**
   * Registers a custom element.
   *
   * This creates a custom element (ie, a subclass of `window.HTMLElement`) and
   * registers it (ie, `window.customElements.define`).
   *
   * Events will be triggered when something interesting happens.
   *
   * @example
   *     defineElement(
   *       { component: Tooltip },
   *       'x-tooltip',
   *       { onUpdate, onUnmount }
   *     )
   *
   * @private
   * @param {ElementSpec} elSpec
   * @param {string} elName
   * @param {ElementEvents} events
   */

  function defineElement(elSpec, elName, events) {
    var onUpdate = events.onUpdate,
        onUnmount = events.onUnmount,
        onMount = events.onMount;
    inject();
    var attributes = elSpec.attributes || [];

    var ComponentElement =
    /*#__PURE__*/
    function (_HTMLElement) {
      _inherits(ComponentElement, _HTMLElement);

      function ComponentElement() {
        _classCallCheck(this, ComponentElement);

        return _possibleConstructorReturn(this, _getPrototypeOf(ComponentElement).apply(this, arguments));
      }

      _createClass(ComponentElement, [{
        key: "connectedCallback",
        value: function connectedCallback() {
          this._mountPoint = createMountPoint(this, elSpec);
          onMount(this, this._mountPoint);
        }
      }, {
        key: "disconnectedCallback",
        value: function disconnectedCallback() {
          if (!this._mountPoint) {
            return;
          }

          onUnmount(this, this._mountPoint);
        }
      }, {
        key: "attributeChangedCallback",
        value: function attributeChangedCallback() {
          if (!this._mountPoint) {
            return;
          }

          onUpdate(this, this._mountPoint);
        }
      }], [{
        key: "observedAttributes",
        get: function get() {
          return ['props-json'].concat(_toConsumableArray(attributes));
        }
      }]);

      return ComponentElement;
    }(_wrapNativeSuper(HTMLElement)); // Supress warning when quiet mode is on


    if (elSpec.quiet && window.customElements.get(elName)) {
      return;
    }

    window.customElements.define(elName, ComponentElement);
  }
  function isSupported() {
    return !!(window.customElements && window.customElements.define);
  }
  /**
   * Creates a `<span>` element that serves as the mounting point for React
   * components. If `shadow: true` is requested, it'll attach a shadow node.
   *
   * @private
   * @param {HTMLElement} element
   * @param {ElementSpec} elSpec
   */

  function createMountPoint(element, elSpec) {
    var shadow = elSpec.shadow;

    if (shadow && element.attachShadow) {
      var mountPoint = document.createElement('span');
      element.attachShadow({
        mode: 'open'
      }).appendChild(mountPoint);
      return mountPoint;
    } else {
      return element;
    }
  }
  /**
   * Check if Shadow DOM is supported.
   */


  function supportsShadow() {
    return !!(document && document.body && document.body.attachShadow);
  }

  var CustomElementsStrategy = /*#__PURE__*/Object.freeze({
    name: name,
    defineElement: defineElement,
    isSupported: isSupported,
    supportsShadow: supportsShadow
  });

  // @ts-check

  /**
   * Some implementations of MutationObserver don't have .forEach,
   * so we need our own `forEach` shim. This is usually the case with
   * polyfilled environments.
   *
   * @type { import('./types').Each }
   */
  function each(
  /** @type any */
  list,
  /** @type any */
  fn) {
    for (var i = 0, len = list.length; i < len; i++) {
      fn(list[i]);
    }
  }

  // @ts-check
  /**
   * The name of this strategy.
   * @type string
   */

  var name$1 = 'MutationObserver';
  /**
   * List of observers tags.
   * @type ObserverList
   */

  var observers = {};
  function isSupported$1() {
    return 'MutationObserver' in window;
  }
  /**
   * Defines a custom element.
   *
   * @example
   *     defineElement(
   *       { component: MyComponent },
   *       'my-div',
   *       {
   *         onMount: () => {},
   *         onUpdate: () => {},
   *         onUnmount: () => {},
   *       }
   *     )
   *
   * @private
   * @param {ElementSpec} elSpec
   * @param {string} elName
   * @param {ElementEvents} events
   */

  function defineElement$1(elSpec, elName, events) {
    elName = elName.toLowerCase(); // Maintain parity with what would happen in Custom Elements mode

    if (!isValidName(elName)) {
      if (elSpec.quiet) {
        return;
      }

      throw new Error("Remount: \"".concat(elName, "\" is not a valid custom element elName"));
    }

    if (observers[elName]) {
      if (elSpec.quiet) {
        return;
      }

      throw new Error("Remount: \"".concat(elName, "\" is already registered"));
    }

    var observer = new MutationObserver(
    /** @type MutationCallback */
    function (mutations) {
      each(mutations, function (
      /** @type MutationRecord */
      mutation) {
        each(mutation.addedNodes, function (
        /** @type Node */
        node) {
          if (isElement(node)) {
            checkForMount(node, elName, events);
          }
        });
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    observers[name$1] =
    /* true */
    observer;
    window.addEventListener('DOMContentLoaded', function () {
      var nodes = document.getElementsByTagName(name$1);
      each(nodes, function (
      /** @type HTMLElement */
      node) {
        return checkForMount(node, name$1, events);
      });
    });
  }
  /**
   * Checks if this new element should fire an `onUpdate` hook.
   * Recurses down to its descendant nodes.
   *
   * @param {HTMLElement} node
   * @param {string} elName
   * @param {ElementEvents} events
   */

  function checkForMount(node, elName, events) {
    if (node.nodeName.toLowerCase() === elName) {
      // It's a match!
      events.onMount(node, node);
      observeForUpdates(node, events);
      observeForRemoval(node, events);
    } else if (node.children && node.children.length) {
      // Recurse down into the other additions
      each(node.children, function (
      /** @type HTMLElement */
      subnode) {
        if (isElement(subnode)) {
          checkForMount(subnode, elName, events);
        }
      });
    }
  }
  /**
   * Observes for any changes in attributes.
   *
   * @param {Element} node
   * @param {ElementEvents} events
   */


  function observeForUpdates(node, events) {
    var onUpdate = events.onUpdate;
    var observer = new MutationObserver(
    /** @type MutationCallback */
    function (mutations) {
      each(mutations, function (
      /** @type MutationRecord */
      mutation) {
        var targetNode = mutation.target;

        if (isElement(targetNode)) {
          onUpdate(targetNode, targetNode);
        }
      });
    });
    observer.observe(node, {
      attributes: true
    });
  }
  /**
   * Observes a node's parent to wait until the node is removed
   * @param {HTMLElement} node
   * @param {ElementEvents} events
   */


  function observeForRemoval(node, events) {
    var onUnmount = events.onUnmount;
    var parent = node.parentNode; // Not sure when this can happen, but let's add this for type safety

    if (!parent) {
      return;
    }

    var observer = new MutationObserver(
    /** @type MutationCallback */
    function (mutations) {
      each(mutations, function (
      /** @type MutationRecord */
      mutation) {
        each(mutation.removedNodes, function (
        /** @type Node */
        subnode) {
          if (node !== subnode) {
            return;
          }

          if (isElement(node)) {
            // @ts-ignore TypeScript expects 0 arguments...?
            observer.disconnect(parent);
            onUnmount(node, node);
          }
        });
      });
    });
    observer.observe(parent, {
      childList: true,
      subtree: true
    });
  }
  /**
   * Validate a custom tag.
   *
   * Since Remount can work with either Custom Elements or MutationObserver API's,
   * it'd be wise if we rejected element names that won't work in Custom Elements
   * mode (even if we're using MutationObserver mode).
   *
   * @param {string} elName
   * @returns {boolean}
   *
   * @example
   *     isValidName('div')      // => false
   *     isValidName('my-div')   // => true
   *     isValidName('123-456')  // => false
   *     isValidName('my-123')   // => true
   *
   * @private
   */


  function isValidName(elName) {
    return !!(elName.indexOf('-') !== -1 && elName.match(/^[a-z][a-z0-9-]*$/));
  }
  /**
   * Shadow DOM is not supported with the Mutation Observer strategy.
   */


  function supportsShadow$1() {
    return false;
  }
  /**
   * Checks if a given Node is an HTMLElement.
   *
   * It's possible that a mutation's `addedNodes` return something that isn't an
   * HTMLElement.
   *
   * @param {any} node
   * @returns {node is HTMLElement}
   */

  function isElement(node) {
    if (node) {
      return true;
    }

    return false;
  }

  var MutationObserverStrategy = /*#__PURE__*/Object.freeze({
    name: name$1,
    observers: observers,
    isSupported: isSupported$1,
    defineElement: defineElement$1,
    supportsShadow: supportsShadow$1
  });

  var reactEvents = ["onAbort", "onAnimationCancel", "onAnimationEnd", "onAnimationIteration", "onAuxClick", "onBlur",
      "onChange", "onClick", "onClose", "onContextMenu", "onDoubleClick", "onError", "onFocus", "onGotPointerCapture",
      "onInput", "onKeyDown", "onKeyPress", "onKeyUp", "onLoad", "onLoadEnd", "onLoadStart", "onLostPointerCapture",
      "onMouseDown", "onMouseMove", "onMouseOut", "onMouseOver", "onMouseUp", "onPointerCancel", "onPointerDown",
      "onPointerEnter", "onPointerLeave", "onPointerMove", "onPointerOut", "onPointerOver", "onPointerUp", "onReset",
      "onResize", "onScroll", "onSelect", "onSelectionChange", "onSelectStart", "onSubmit", "onTouchCancel",
      "onTouchMove", "onTouchStart", "onTransitionCancel", "onTransitionEnd", "onDrag", "onDragEnd", "onDragEnter",
      "onDragExit", "onDragLeave", "onDragOver", "onDragStart", "onDrop", "onFocusOut"];

  var divergentNativeEvents = {
      onDoubleClick: 'dblclick'
  };

  var mimickedReactEvents = {
      onInput: 'onChange',
      onFocusOut: 'onBlur',
      onSelectionChange: 'onSelect'
  };

  var reactShadowDomRetargetEvents = function retargetEvents(shadowRoot) {

      reactEvents.forEach(function (reactEventName) {

          var nativeEventName = getNativeEventName(reactEventName);

          shadowRoot.addEventListener(nativeEventName, function (event) {
              
              var path = event.path || (event.composedPath && event.composedPath()) || composedPath(event.target);

              for (var i = 0; i < path.length; i++) {

                  var el = path[i];
                  var reactComponent = findReactComponent(el);
                  var props = findReactProps(reactComponent);

                  if (reactComponent && props) {
                      dispatchEvent(event, reactEventName, props);
                  }

                  if (reactComponent && props && mimickedReactEvents[reactEventName]) {
                      dispatchEvent(event, mimickedReactEvents[reactEventName], props);
                  }

                  if (event.cancelBubble) { 
                      break; 
                  }                

                  if (el === shadowRoot) {
                      break;
                  }
              }
          }, false);
      });
  };

  function findReactComponent(item) {
      for (var key in item) {
          if (item.hasOwnProperty(key) && key.indexOf('_reactInternal') !== -1) {
              return item[key];
          }
      }
  }

  function findReactProps(component) {
      if (!component) return undefined;
      if (component.memoizedProps) return component.memoizedProps; // React 16 Fiber
      if (component._currentElement && component._currentElement.props) return component._currentElement.props; // React <=15

  }

  function dispatchEvent(event, eventType, componentProps) {
      if (componentProps[eventType]) {
          componentProps[eventType](event);
      }
  }

  function getNativeEventName(reactEventName) {
      if (divergentNativeEvents[reactEventName]) {
          return divergentNativeEvents[reactEventName];
      }
      return reactEventName.replace(/^on/, '').toLowerCase();
  }

  function composedPath(el) {
    var path = [];
    while (el) {
      path.push(el);
      if (el.tagName === 'HTML') {
        path.push(document);
        path.push(window);
        return path;
      }
      el = el.parentElement;
    }
  }

  // @ts-check
  /**
   * @param {ElementSpec} elSpec
   * @param {HTMLElement} mountPoint
   * @param {object} props
   * @param {HTMLElement | null} element
   */

  function mount(elSpec, mountPoint, props, element) {
    return update(elSpec, mountPoint, props, element);
  }
  /**
   * Updates a custom element by calling `ReactDOM.render()`.
   * @private
   *
   * @param {ElementSpec} elSpec
   * @param {HTMLElement} mountPoint
   * @param {object} props
   * @param {HTMLElement | null} element
   */

  function update(elSpec, mountPoint, props, element) {
    var component = elSpec.component;
    var reactElement = React.createElement(component, props);
    ReactDOM.render(reactElement, mountPoint);

    if (element) {
      reactShadowDomRetargetEvents(element.shadowRoot);
    }
  }
  /**
   * Unmounts a component.
   * @private
   *
   * @param {ElementSpec} elSpec
   * @param {HTMLElement} mountPoint
   */

  function unmount(elSpec, mountPoint) {
    ReactDOM.unmountComponentAtNode(mountPoint);
  }

  var ReactAdapter = /*#__PURE__*/Object.freeze({
    mount: mount,
    update: update,
    unmount: unmount
  });

  /**
   * Cache of the strategy determined by `getStrategy()`.
   * @type {Strategy | null | undefined}
   */

  var cachedStrategy;
  /**
   * Detect what API can be used.
   *
   * @example
   *     Remount.getStrategy().name
   */

  function getStrategy() {
    if (cachedStrategy) {
      return cachedStrategy;
    }

    var StrategyUsed = [CustomElementsStrategy, MutationObserverStrategy].find(function (strategy) {
      return !!strategy.isSupported();
    });

    if (!StrategyUsed) {
      /* tslint:disable no-console */
      console.warn("Remount: This browser doesn't support the " + 'MutationObserver API or the Custom Elements API. Including ' + 'polyfills might fix this. Remount elements will not work. ' + 'https://github.com/rstacruz/remount');
    }

    cachedStrategy = StrategyUsed;
    return StrategyUsed;
  }
  /**
   * Registers custom elements and links them to React components.
   * @param {ElementMap} components
   * @param {Defaults=} defaults
   *
   * @example
   *     define({ 'x-tooltip': Tooltip })
   *
   * @example
   *     define(
   *       { 'x-tooltip': Tooltip },
   *       { attributes: ['title', 'body'] }
   *     )
   */

  function define(components, defaults) {
    var Strategy = getStrategy();

    if (!Strategy) {
      return;
    }

    Object.keys(components).forEach(function (
    /** @type string */
    name$$1) {
      // Construct the specs for the element.
      // (eg, { component: Tooltip, attributes: ['title'] })

      /** @type ElementSpec */
      var elSpec = Object.assign({}, defaults, toElementSpec(components[name$$1]));
      /** @type Adapter */

      var adapter = elSpec.adapter || ReactAdapter; // Define a custom element.

      Strategy.defineElement(elSpec, name$$1, {
        onMount: function onMount(element, mountPoint) {
          var props = getProps(element, elSpec.attributes);

          if (elSpec.shadow && elSpec.retarget) {
            adapter.mount(elSpec, mountPoint, props, element);
          } else {
            adapter.mount(elSpec, mountPoint, props, null);
          }
        },
        onUpdate: function onUpdate(element, mountPoint) {
          var props = getProps(element, elSpec.attributes);
          adapter.update(elSpec, mountPoint, props, null);
        },
        onUnmount: function onUnmount(element, mountPoint) {
          adapter.unmount(elSpec, mountPoint);
        }
      });
    });
  }
  /**
   * Coerces something into an `ElementSpec` type.
   *
   * @param {ElementSpec | Component} thing
   * @returns {ElementSpec}
   * @private
   *
   * @example
   *     toElementSpec(Tooltip)
   *     // => { component: Tooltip }
   *
   *     toElementSpec({ component: Tooltip })
   *     // => { component: Tooltip }
   */

  function toElementSpec(thing) {
    if (isElementSpec(thing)) {
      return thing;
    }

    return {
      component: thing
    };
  }
  /**
   * Checks if a given `spec` is an ElementSpec.
   *
   * @param {any} spec
   * @returns {spec is ElementSpec}
   */


  function isElementSpec(spec) {
    return _typeof(spec) === 'object' && spec.component;
  }
  /**
   * Returns properties for a given HTML element.
   *
   * @private
   * @param {HTMLElement} element
   * @param {string[] | null | undefined} attributes
   *
   * @example
   *     getProps(div, ['name'])
   *     // => { name: 'Romeo' }
   */


  function getProps(element, attributes) {
    var rawJson = element.getAttribute('props-json');

    if (rawJson) {
      return JSON.parse(rawJson);
    }

    var names = attributes || [];
    return names.reduce(function (
    /** @type PropertyMap */
    result,
    /** @type string */
    attribute) {
      result[attribute] = element.getAttribute(attribute);
      return result;
    }, {});
  }

  exports.getStrategy = getStrategy;
  exports.define = define;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
}(remount_es5, remount_es5.exports));

var $$n = _export;
var isArray = isArray$5;

// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$$n({ target: 'Array', stat: true }, {
  isArray: isArray
});

var $$m = _export;
var $some = arrayIteration.some;
var arrayMethodIsStrict$5 = arrayMethodIsStrict$7;

var STRICT_METHOD$5 = arrayMethodIsStrict$5('some');

// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$$m({ target: 'Array', proto: true, forced: !STRICT_METHOD$5 }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $$l = _export;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var toLength$3 = toLength$d;
var notARegExp$1 = notARegexp;
var requireObjectCoercible$3 = requireObjectCoercible$d;
var correctIsRegExpLogic$1 = correctIsRegexpLogic;

// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var $endsWith = ''.endsWith;
var min$1 = Math.min;

var CORRECT_IS_REGEXP_LOGIC$1 = correctIsRegExpLogic$1('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG$1 = !CORRECT_IS_REGEXP_LOGIC$1 && !!function () {
  var descriptor = getOwnPropertyDescriptor$2(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$$l({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG$1 && !CORRECT_IS_REGEXP_LOGIC$1 }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = String(requireObjectCoercible$3(this));
    notARegExp$1(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength$3(that.length);
    var end = endPosition === undefined ? len : min$1(toLength$3(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

var fileAccept = function fileAccept(file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = file.type || '';
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType.toLowerCase());
      }

      if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

var $$k = _export;
var IndexedObject$2 = indexedObject;
var toIndexedObject$1 = toIndexedObject$9;
var arrayMethodIsStrict$4 = arrayMethodIsStrict$7;

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject$2 != Object;
var STRICT_METHOD$4 = arrayMethodIsStrict$4('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$$k({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD$4 }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject$1(this), separator === undefined ? ',' : separator);
  }
});

var DESCRIPTORS$3 = descriptors;
var objectKeys$1 = objectKeys$4;
var toIndexedObject = toIndexedObject$9;
var propertyIsEnumerable = objectPropertyIsEnumerable.f;

// `Object.{ entries, values }` methods implementation
var createMethod$1 = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys$1(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS$3 || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

var objectToArray = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod$1(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod$1(false)
};

var $$j = _export;
var $entries = objectToArray.entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$$j({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});

var aFunction$1 = aFunction$6;
var toObject$3 = toObject$c;
var IndexedObject$1 = indexedObject;
var toLength$2 = toLength$d;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction$1(callbackfn);
    var O = toObject$3(that);
    var self = IndexedObject$1(O);
    var length = toLength$2(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};

var $$i = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict$3 = arrayMethodIsStrict$7;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

var STRICT_METHOD$3 = arrayMethodIsStrict$3('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$i({ target: 'Array', proto: true, forced: !STRICT_METHOD$3 || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $$h = _export;
var $map = arrayIteration.map;
var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$5;

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$$h({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var sanitizeParams = function sanitizeParams(params) {
  var entries = Object.entries(params);
  var newParams = entries.reduce(function (previous, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        current = _ref2[0],
        currentParam = _ref2[1];

    var removableValues = [undefined, null, ''];
    var shouldRemove = removableValues.includes(currentParam);
    return shouldRemove ? previous : _objectSpread2(_objectSpread2({}, previous), {}, _defineProperty({}, current, currentParam));
  }, {});
  return newParams;
};

var getQueryString = function getQueryString(params) {
  var sanitizedParams = sanitizeParams(params);
  var queryString = Object.entries(sanitizedParams).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        param = _ref4[0],
        value = _ref4[1];

    return "".concat(param, "=").concat(encodeURI(value));
  }).join('&');
  return queryString;
};

var objectToQueryString = function objectToQueryString(params) {
  var defaultParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isInvalid = !params || Array.isArray(params) || _typeof(params) !== 'object';

  if (isInvalid) {
    // eslint-disable-next-line no-console
    console.warn('Must be passed an object with key and value!');
    return getQueryString(defaultParams);
  }

  var newParams = _objectSpread2(_objectSpread2({}, params), defaultParams);

  return getQueryString(newParams);
};

var global$4 = global$s;
var trim$2 = stringTrim.trim;
var whitespaces$1 = whitespaces$4;

var $parseFloat = global$4.parseFloat;
var FORCED$3 = 1 / $parseFloat(whitespaces$1 + '-0') !== -Infinity;

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
var numberParseFloat = FORCED$3 ? function parseFloat(string) {
  var trimmedString = trim$2(String(string));
  var result = $parseFloat(trimmedString);
  return result === 0 && trimmedString.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

var $$g = _export;
var parseFloatImplementation = numberParseFloat;

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$$g({ global: true, forced: parseFloat != parseFloatImplementation }, {
  parseFloat: parseFloatImplementation
});

var $$f = _export;
var iterate = iterate$4;
var createProperty$1 = createProperty$5;

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$$f({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty$1(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});

var fails$7 = fails$r;
var wellKnownSymbol$1 = wellKnownSymbol$o;
var IS_PURE = isPure;

var ITERATOR$1 = wellKnownSymbol$1('iterator');

var nativeUrl = !fails$7(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR$1]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

var DESCRIPTORS$2 = descriptors;
var fails$6 = fails$r;
var objectKeys = objectKeys$4;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$2 = toObject$c;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$1 = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$6(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$2 && $assign({ b: 1 }, $assign(defineProperty$1({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$1(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$2(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$2 || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var anObject$4 = anObject$i;
var iteratorClose = iteratorClose$2;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$4(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    iteratorClose(iterator);
    throw error;
  }
};

var bind$1 = functionBindContext;
var toObject$1 = toObject$c;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var isArrayIteratorMethod = isArrayIteratorMethod$2;
var toLength$1 = toLength$d;
var createProperty = createProperty$5;
var getIteratorMethod$2 = getIteratorMethod$4;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom$1 = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject$1(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod$2(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind$1(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength$1(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;
var floor$2 = Math.floor;
var stringFromCharCode = String.fromCharCode;

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$2(delta / damp) : delta >> 1;
  delta += floor$2(delta / numPoints);
  for (; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor$2(delta / baseMinusTMin);
  }
  return floor$2(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
// eslint-disable-next-line max-statements -- TODO
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      output.push(stringFromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    output.push(delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor$2((maxInt - delta) / handledCPCountPlusOne)) {
      throw RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        for (var k = base; /* no condition */; k += base) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor$2(qMinusT / baseMinusT);
        }

        output.push(stringFromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;
  }
  return output.join('');
};

var stringPunycodeToAscii = function (input) {
  var encoded = [];
  var labels = input.toLowerCase().replace(regexSeparators, '\u002E').split('.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    encoded.push(regexNonASCII.test(label) ? 'xn--' + encode(label) : label);
  }
  return encoded.join('.');
};

var anObject$3 = anObject$i;
var getIteratorMethod$1 = getIteratorMethod$4;

var getIterator$1 = function (it) {
  var iteratorMethod = getIteratorMethod$1(it);
  if (typeof iteratorMethod != 'function') {
    throw TypeError(String(it) + ' is not iterable');
  } return anObject$3(iteratorMethod.call(it));
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$e = _export;
var getBuiltIn = getBuiltIn$7;
var USE_NATIVE_URL$1 = nativeUrl;
var redefine$4 = redefine$d.exports;
var redefineAll = redefineAll$3;
var setToStringTag$1 = setToStringTag$7;
var createIteratorConstructor = createIteratorConstructor$2;
var InternalStateModule$1 = internalState;
var anInstance$1 = anInstance$5;
var hasOwn = has$f;
var bind = functionBindContext;
var classof$2 = classof$8;
var anObject$2 = anObject$i;
var isObject$1 = isObject$i;
var create$1 = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$6;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$4;
var wellKnownSymbol = wellKnownSymbol$o;

var $fetch = getBuiltIn('fetch');
var Headers = getBuiltIn('Headers');
var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalParamsState = InternalStateModule$1.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule$1.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = it.replace(plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = result.replace(percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replace = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replace[match];
};

var serialize = function (it) {
  return encodeURIComponent(it).replace(find, replacer);
};

var parseSearchParams = function (result, query) {
  if (query) {
    var attributes = query.split('&');
    var index = 0;
    var attribute, entry;
    while (index < attributes.length) {
      attribute = attributes[index++];
      if (attribute.length) {
        entry = attribute.split('=');
        result.push({
          key: deserialize(entry.shift()),
          value: deserialize(entry.join('='))
        });
      }
    }
  }
};

var updateSearchParams = function (query) {
  this.entries.length = 0;
  parseSearchParams(this.entries, query);
};

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState$1(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
});

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance$1(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var that = this;
  var entries = [];
  var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

  setInternalState$1(that, {
    type: URL_SEARCH_PARAMS,
    entries: entries,
    updateURL: function () { /* empty */ },
    updateSearchParams: updateSearchParams
  });

  if (init !== undefined) {
    if (isObject$1(init)) {
      iteratorMethod = getIteratorMethod(init);
      if (typeof iteratorMethod === 'function') {
        iterator = iteratorMethod.call(init);
        next = iterator.next;
        while (!(step = next.call(iterator)).done) {
          entryIterator = getIterator(anObject$2(step.value));
          entryNext = entryIterator.next;
          if (
            (first = entryNext.call(entryIterator)).done ||
            (second = entryNext.call(entryIterator)).done ||
            !entryNext.call(entryIterator).done
          ) throw TypeError('Expected sequence with length 2');
          entries.push({ key: first.value + '', value: second.value + '' });
        }
      } else for (key in init) if (hasOwn(init, key)) entries.push({ key: key, value: init[key] + '' });
    } else {
      parseSearchParams(entries, typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : init + '');
    }
  }
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    state.entries.push({ key: name + '', value: value + '' });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) entries.splice(index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) result.push(entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = name + '';
    var val = value + '';
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) entries.splice(index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) entries.push({ key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    var entries = state.entries;
    // Array#sort is not stable in some engines
    var slice = entries.slice();
    var entry, entriesIndex, sliceIndex;
    entries.length = 0;
    for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
      entry = slice[sliceIndex];
      for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
        if (entries[entriesIndex].key > entry.key) {
          entries.splice(entriesIndex, 0, entry);
          break;
        }
      }
      if (entriesIndex === sliceIndex) entries.push(entry);
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine$4(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries);

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine$4(URLSearchParamsPrototype, 'toString', function toString() {
  var entries = getInternalParamsState(this).entries;
  var result = [];
  var index = 0;
  var entry;
  while (index < entries.length) {
    entry = entries[index++];
    result.push(serialize(entry.key) + '=' + serialize(entry.value));
  } return result.join('&');
}, { enumerable: true });

setToStringTag$1(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$$e({ global: true, forced: !USE_NATIVE_URL$1 }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` for correct work with polyfilled `URLSearchParams`
// https://github.com/zloirock/core-js/issues/674
if (!USE_NATIVE_URL$1 && typeof $fetch == 'function' && typeof Headers == 'function') {
  $$e({ global: true, enumerable: true, forced: true }, {
    fetch: function fetch(input /* , init */) {
      var args = [input];
      var init, body, headers;
      if (arguments.length > 1) {
        init = arguments[1];
        if (isObject$1(init)) {
          body = init.body;
          if (classof$2(body) === URL_SEARCH_PARAMS) {
            headers = init.headers ? new Headers(init.headers) : new Headers();
            if (!headers.has('content-type')) {
              headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
            init = create$1(init, {
              body: createPropertyDescriptor(0, String(body)),
              headers: createPropertyDescriptor(0, headers)
            });
          }
        }
        args.push(init);
      } return $fetch.apply(this, args);
    }
  });
}

var web_urlSearchParams = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$d = _export;
var DESCRIPTORS$1 = descriptors;
var USE_NATIVE_URL = nativeUrl;
var global$3 = global$s;
var defineProperties = objectDefineProperties;
var redefine$3 = redefine$d.exports;
var anInstance = anInstance$5;
var has$1 = has$f;
var assign = objectAssign;
var arrayFrom = arrayFrom$1;
var codeAt = stringMultibyte.codeAt;
var toASCII = stringPunycodeToAscii;
var setToStringTag = setToStringTag$7;
var URLSearchParamsModule = web_urlSearchParams;
var InternalStateModule = internalState;

var NativeURL = global$3.URL;
var URLSearchParams$1 = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;
var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var floor$1 = Math.floor;
var pow$1 = Math.pow;

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[A-Za-z]/;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.A-Za-z]/;
var DIGIT = /\d/;
var HEX_START = /^(0x|0X)/;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\dA-Fa-f]+$/;
/* eslint-disable no-control-regex -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:?@[\\]]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:?@[\\]]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable no-control-regex -- safe */
var EOF;

var parseHost = function (url, input) {
  var result, codePoints, index;
  if (input.charAt(0) == '[') {
    if (input.charAt(input.length - 1) != ']') return INVALID_HOST;
    result = parseIPv6(input.slice(1, -1));
    if (!result) return INVALID_HOST;
    url.host = result;
  // opaque host
  } else if (!isSpecial(url)) {
    if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(input)) return INVALID_HOST;
    result = '';
    codePoints = arrayFrom(input);
    for (index = 0; index < codePoints.length; index++) {
      result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
    }
    url.host = result;
  } else {
    input = toASCII(input);
    if (FORBIDDEN_HOST_CODE_POINT.test(input)) return INVALID_HOST;
    result = parseIPv4(input);
    if (result === null) return INVALID_HOST;
    url.host = result;
  }
};

var parseIPv4 = function (input) {
  var parts = input.split('.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.pop();
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && part.charAt(0) == '0') {
      radix = HEX_START.test(part) ? 16 : 8;
      part = part.slice(radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!(radix == 10 ? DEC : radix == 8 ? OCT : HEX).test(part)) return input;
      number = parseInt(part, radix);
    }
    numbers.push(number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow$1(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = numbers.pop();
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow$1(256, 3 - index);
  }
  return ipv4;
};

// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var char = function () {
    return input.charAt(pointer);
  };

  if (char() == ':') {
    if (input.charAt(1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (char()) {
    if (pieceIndex == 8) return;
    if (char() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && HEX.test(char())) {
      value = value * 16 + parseInt(char(), 16);
      pointer++;
      length++;
    }
    if (char() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (char()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (char() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!DIGIT.test(char())) return;
        while (DIGIT.test(char())) {
          number = parseInt(char(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (char() == ':') {
      pointer++;
      if (!char()) return;
    } else if (char()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      result.unshift(host % 256);
      host = floor$1(host / 256);
    } return result.join('.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += host[index].toString(16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (char, set) {
  var code = codeAt(char, 0);
  return code > 0x20 && code < 0x7F && !has$1(set, char) ? char : encodeURIComponent(char);
};

var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

var isSpecial = function (url) {
  return has$1(specialSchemes, url.scheme);
};

var includesCredentials = function (url) {
  return url.username != '' || url.password != '';
};

var cannotHaveUsernamePasswordPort = function (url) {
  return !url.host || url.cannotBeABaseURL || url.scheme == 'file';
};

var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && ALPHA.test(string.charAt(0))
    && ((second = string.charAt(1)) == ':' || (!normalized && second == '|'));
};

var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(string.slice(0, 2)) && (
    string.length == 2 ||
    ((third = string.charAt(2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

var shortenURLsPath = function (url) {
  var path = url.path;
  var pathSize = path.length;
  if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
    path.pop();
  }
};

var isSingleDot = function (segment) {
  return segment === '.' || segment.toLowerCase() === '%2e';
};

var isDoubleDot = function (segment) {
  segment = segment.toLowerCase();
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

// eslint-disable-next-line max-statements -- TODO
var parseURL = function (url, input, stateOverride, base) {
  var state = stateOverride || SCHEME_START;
  var pointer = 0;
  var buffer = '';
  var seenAt = false;
  var seenBracket = false;
  var seenPasswordToken = false;
  var codePoints, char, bufferCodePoints, failure;

  if (!stateOverride) {
    url.scheme = '';
    url.username = '';
    url.password = '';
    url.host = null;
    url.port = null;
    url.path = [];
    url.query = null;
    url.fragment = null;
    url.cannotBeABaseURL = false;
    input = input.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
  }

  input = input.replace(TAB_AND_NEW_LINE, '');

  codePoints = arrayFrom(input);

  while (pointer <= codePoints.length) {
    char = codePoints[pointer];
    switch (state) {
      case SCHEME_START:
        if (char && ALPHA.test(char)) {
          buffer += char.toLowerCase();
          state = SCHEME;
        } else if (!stateOverride) {
          state = NO_SCHEME;
          continue;
        } else return INVALID_SCHEME;
        break;

      case SCHEME:
        if (char && (ALPHANUMERIC.test(char) || char == '+' || char == '-' || char == '.')) {
          buffer += char.toLowerCase();
        } else if (char == ':') {
          if (stateOverride && (
            (isSpecial(url) != has$1(specialSchemes, buffer)) ||
            (buffer == 'file' && (includesCredentials(url) || url.port !== null)) ||
            (url.scheme == 'file' && !url.host)
          )) return;
          url.scheme = buffer;
          if (stateOverride) {
            if (isSpecial(url) && specialSchemes[url.scheme] == url.port) url.port = null;
            return;
          }
          buffer = '';
          if (url.scheme == 'file') {
            state = FILE;
          } else if (isSpecial(url) && base && base.scheme == url.scheme) {
            state = SPECIAL_RELATIVE_OR_AUTHORITY;
          } else if (isSpecial(url)) {
            state = SPECIAL_AUTHORITY_SLASHES;
          } else if (codePoints[pointer + 1] == '/') {
            state = PATH_OR_AUTHORITY;
            pointer++;
          } else {
            url.cannotBeABaseURL = true;
            url.path.push('');
            state = CANNOT_BE_A_BASE_URL_PATH;
          }
        } else if (!stateOverride) {
          buffer = '';
          state = NO_SCHEME;
          pointer = 0;
          continue;
        } else return INVALID_SCHEME;
        break;

      case NO_SCHEME:
        if (!base || (base.cannotBeABaseURL && char != '#')) return INVALID_SCHEME;
        if (base.cannotBeABaseURL && char == '#') {
          url.scheme = base.scheme;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          url.cannotBeABaseURL = true;
          state = FRAGMENT;
          break;
        }
        state = base.scheme == 'file' ? FILE : RELATIVE;
        continue;

      case SPECIAL_RELATIVE_OR_AUTHORITY:
        if (char == '/' && codePoints[pointer + 1] == '/') {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          pointer++;
        } else {
          state = RELATIVE;
          continue;
        } break;

      case PATH_OR_AUTHORITY:
        if (char == '/') {
          state = AUTHORITY;
          break;
        } else {
          state = PATH;
          continue;
        }

      case RELATIVE:
        url.scheme = base.scheme;
        if (char == EOF) {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
        } else if (char == '/' || (char == '\\' && isSpecial(url))) {
          state = RELATIVE_SLASH;
        } else if (char == '?') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          state = FRAGMENT;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.path.pop();
          state = PATH;
          continue;
        } break;

      case RELATIVE_SLASH:
        if (isSpecial(url) && (char == '/' || char == '\\')) {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        } else if (char == '/') {
          state = AUTHORITY;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          state = PATH;
          continue;
        } break;

      case SPECIAL_AUTHORITY_SLASHES:
        state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        if (char != '/' || buffer.charAt(pointer + 1) != '/') continue;
        pointer++;
        break;

      case SPECIAL_AUTHORITY_IGNORE_SLASHES:
        if (char != '/' && char != '\\') {
          state = AUTHORITY;
          continue;
        } break;

      case AUTHORITY:
        if (char == '@') {
          if (seenAt) buffer = '%40' + buffer;
          seenAt = true;
          bufferCodePoints = arrayFrom(buffer);
          for (var i = 0; i < bufferCodePoints.length; i++) {
            var codePoint = bufferCodePoints[i];
            if (codePoint == ':' && !seenPasswordToken) {
              seenPasswordToken = true;
              continue;
            }
            var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
            if (seenPasswordToken) url.password += encodedCodePoints;
            else url.username += encodedCodePoints;
          }
          buffer = '';
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (seenAt && buffer == '') return INVALID_AUTHORITY;
          pointer -= arrayFrom(buffer).length + 1;
          buffer = '';
          state = HOST;
        } else buffer += char;
        break;

      case HOST:
      case HOSTNAME:
        if (stateOverride && url.scheme == 'file') {
          state = FILE_HOST;
          continue;
        } else if (char == ':' && !seenBracket) {
          if (buffer == '') return INVALID_HOST;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PORT;
          if (stateOverride == HOSTNAME) return;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (isSpecial(url) && buffer == '') return INVALID_HOST;
          if (stateOverride && buffer == '' && (includesCredentials(url) || url.port !== null)) return;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PATH_START;
          if (stateOverride) return;
          continue;
        } else {
          if (char == '[') seenBracket = true;
          else if (char == ']') seenBracket = false;
          buffer += char;
        } break;

      case PORT:
        if (DIGIT.test(char)) {
          buffer += char;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url)) ||
          stateOverride
        ) {
          if (buffer != '') {
            var port = parseInt(buffer, 10);
            if (port > 0xFFFF) return INVALID_PORT;
            url.port = (isSpecial(url) && port === specialSchemes[url.scheme]) ? null : port;
            buffer = '';
          }
          if (stateOverride) return;
          state = PATH_START;
          continue;
        } else return INVALID_PORT;
        break;

      case FILE:
        url.scheme = 'file';
        if (char == '/' || char == '\\') state = FILE_SLASH;
        else if (base && base.scheme == 'file') {
          if (char == EOF) {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
          } else if (char == '?') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            if (!startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
              url.host = base.host;
              url.path = base.path.slice();
              shortenURLsPath(url);
            }
            state = PATH;
            continue;
          }
        } else {
          state = PATH;
          continue;
        } break;

      case FILE_SLASH:
        if (char == '/' || char == '\\') {
          state = FILE_HOST;
          break;
        }
        if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
          if (isWindowsDriveLetter(base.path[0], true)) url.path.push(base.path[0]);
          else url.host = base.host;
        }
        state = PATH;
        continue;

      case FILE_HOST:
        if (char == EOF || char == '/' || char == '\\' || char == '?' || char == '#') {
          if (!stateOverride && isWindowsDriveLetter(buffer)) {
            state = PATH;
          } else if (buffer == '') {
            url.host = '';
            if (stateOverride) return;
            state = PATH_START;
          } else {
            failure = parseHost(url, buffer);
            if (failure) return failure;
            if (url.host == 'localhost') url.host = '';
            if (stateOverride) return;
            buffer = '';
            state = PATH_START;
          } continue;
        } else buffer += char;
        break;

      case PATH_START:
        if (isSpecial(url)) {
          state = PATH;
          if (char != '/' && char != '\\') continue;
        } else if (!stateOverride && char == '?') {
          url.query = '';
          state = QUERY;
        } else if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          state = PATH;
          if (char != '/') continue;
        } break;

      case PATH:
        if (
          char == EOF || char == '/' ||
          (char == '\\' && isSpecial(url)) ||
          (!stateOverride && (char == '?' || char == '#'))
        ) {
          if (isDoubleDot(buffer)) {
            shortenURLsPath(url);
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else if (isSingleDot(buffer)) {
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else {
            if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
              if (url.host) url.host = '';
              buffer = buffer.charAt(0) + ':'; // normalize windows drive letter
            }
            url.path.push(buffer);
          }
          buffer = '';
          if (url.scheme == 'file' && (char == EOF || char == '?' || char == '#')) {
            while (url.path.length > 1 && url.path[0] === '') {
              url.path.shift();
            }
          }
          if (char == '?') {
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.fragment = '';
            state = FRAGMENT;
          }
        } else {
          buffer += percentEncode(char, pathPercentEncodeSet);
        } break;

      case CANNOT_BE_A_BASE_URL_PATH:
        if (char == '?') {
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          url.path[0] += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case QUERY:
        if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          if (char == "'" && isSpecial(url)) url.query += '%27';
          else if (char == '#') url.query += '%23';
          else url.query += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case FRAGMENT:
        if (char != EOF) url.fragment += percentEncode(char, fragmentPercentEncodeSet);
        break;
    }

    pointer++;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLConstructor, 'URL');
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var urlString = String(url);
  var state = setInternalState(that, { type: 'URL' });
  var baseState, failure;
  if (base !== undefined) {
    if (base instanceof URLConstructor) baseState = getInternalURLState(base);
    else {
      failure = parseURL(baseState = {}, String(base));
      if (failure) throw TypeError(failure);
    }
  }
  failure = parseURL(state, urlString, null, baseState);
  if (failure) throw TypeError(failure);
  var searchParams = state.searchParams = new URLSearchParams$1();
  var searchParamsState = getInternalSearchParamsState(searchParams);
  searchParamsState.updateSearchParams(state.query);
  searchParamsState.updateURL = function () {
    state.query = String(searchParams) || null;
  };
  if (!DESCRIPTORS$1) {
    that.href = serializeURL.call(that);
    that.origin = getOrigin.call(that);
    that.protocol = getProtocol.call(that);
    that.username = getUsername.call(that);
    that.password = getPassword.call(that);
    that.host = getHost.call(that);
    that.hostname = getHostname.call(that);
    that.port = getPort.call(that);
    that.pathname = getPathname.call(that);
    that.search = getSearch.call(that);
    that.searchParams = getSearchParams.call(that);
    that.hash = getHash.call(that);
  }
};

var URLPrototype = URLConstructor.prototype;

var serializeURL = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var username = url.username;
  var password = url.password;
  var host = url.host;
  var port = url.port;
  var path = url.path;
  var query = url.query;
  var fragment = url.fragment;
  var output = scheme + ':';
  if (host !== null) {
    output += '//';
    if (includesCredentials(url)) {
      output += username + (password ? ':' + password : '') + '@';
    }
    output += serializeHost(host);
    if (port !== null) output += ':' + port;
  } else if (scheme == 'file') output += '//';
  output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
  if (query !== null) output += '?' + query;
  if (fragment !== null) output += '#' + fragment;
  return output;
};

var getOrigin = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var port = url.port;
  if (scheme == 'blob') try {
    return new URLConstructor(scheme.path[0]).origin;
  } catch (error) {
    return 'null';
  }
  if (scheme == 'file' || !isSpecial(url)) return 'null';
  return scheme + '://' + serializeHost(url.host) + (port !== null ? ':' + port : '');
};

var getProtocol = function () {
  return getInternalURLState(this).scheme + ':';
};

var getUsername = function () {
  return getInternalURLState(this).username;
};

var getPassword = function () {
  return getInternalURLState(this).password;
};

var getHost = function () {
  var url = getInternalURLState(this);
  var host = url.host;
  var port = url.port;
  return host === null ? ''
    : port === null ? serializeHost(host)
    : serializeHost(host) + ':' + port;
};

var getHostname = function () {
  var host = getInternalURLState(this).host;
  return host === null ? '' : serializeHost(host);
};

var getPort = function () {
  var port = getInternalURLState(this).port;
  return port === null ? '' : String(port);
};

var getPathname = function () {
  var url = getInternalURLState(this);
  var path = url.path;
  return url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
};

var getSearch = function () {
  var query = getInternalURLState(this).query;
  return query ? '?' + query : '';
};

var getSearchParams = function () {
  return getInternalURLState(this).searchParams;
};

var getHash = function () {
  var fragment = getInternalURLState(this).fragment;
  return fragment ? '#' + fragment : '';
};

var accessorDescriptor = function (getter, setter) {
  return { get: getter, set: setter, configurable: true, enumerable: true };
};

if (DESCRIPTORS$1) {
  defineProperties(URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor(serializeURL, function (href) {
      var url = getInternalURLState(this);
      var urlString = String(href);
      var failure = parseURL(url, urlString);
      if (failure) throw TypeError(failure);
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor(getOrigin),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor(getProtocol, function (protocol) {
      var url = getInternalURLState(this);
      parseURL(url, String(protocol) + ':', SCHEME_START);
    }),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor(getUsername, function (username) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(username));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.username = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor(getPassword, function (password) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(password));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.password = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor(getHost, function (host) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(host), HOST);
    }),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor(getHostname, function (hostname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(hostname), HOSTNAME);
    }),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor(getPort, function (port) {
      var url = getInternalURLState(this);
      if (cannotHaveUsernamePasswordPort(url)) return;
      port = String(port);
      if (port == '') url.port = null;
      else parseURL(url, port, PORT);
    }),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor(getPathname, function (pathname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      url.path = [];
      parseURL(url, pathname + '', PATH_START);
    }),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor(getSearch, function (search) {
      var url = getInternalURLState(this);
      search = String(search);
      if (search == '') {
        url.query = null;
      } else {
        if ('?' == search.charAt(0)) search = search.slice(1);
        url.query = '';
        parseURL(url, search, QUERY);
      }
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor(getSearchParams),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor(getHash, function (hash) {
      var url = getInternalURLState(this);
      hash = String(hash);
      if (hash == '') {
        url.fragment = null;
        return;
      }
      if ('#' == hash.charAt(0)) hash = hash.slice(1);
      url.fragment = '';
      parseURL(url, hash, FRAGMENT);
    })
  });
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine$3(URLPrototype, 'toJSON', function toJSON() {
  return serializeURL.call(this);
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine$3(URLPrototype, 'toString', function toString() {
  return serializeURL.call(this);
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  if (nativeCreateObjectURL) redefine$3(URLConstructor, 'createObjectURL', function createObjectURL(blob) {
    return nativeCreateObjectURL.apply(NativeURL, arguments);
  });
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  if (nativeRevokeObjectURL) redefine$3(URLConstructor, 'revokeObjectURL', function revokeObjectURL(url) {
    return nativeRevokeObjectURL.apply(NativeURL, arguments);
  });
}

setToStringTag(URLConstructor, 'URL');

$$d({ global: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS$1 }, {
  URL: URLConstructor
});

var redefine$2 = redefine$d.exports;

var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING$1 = 'toString';
var nativeDateToString = DatePrototype[TO_STRING$1];
var getTime = DatePrototype.getTime;

// `Date.prototype.toString` method
// https://tc39.es/ecma262/#sec-date.prototype.tostring
if (new Date(NaN) + '' != INVALID_DATE) {
  redefine$2(DatePrototype, TO_STRING$1, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare -- NaN check
    return value === value ? nativeDateToString.call(this) : INVALID_DATE;
  });
}

var $$c = _export;

// `Date.now` method
// https://tc39.es/ecma262/#sec-date.now
$$c({ target: 'Date', stat: true }, {
  now: function now() {
    return new Date().getTime();
  }
});

var shouldDisplayBestFridayContent = function shouldDisplayBestFridayContent(initialDate, endDate) {
  var defaultInitialDate = '2021-09-30T12:00:00.0Z';
  var defaultEndDate = '2021-11-27T03:00:00.0Z';
  var contentInitialDate = initialDate || defaultInitialDate;
  var contentEndDate = endDate || defaultEndDate;
  var today = new Date(Date.now());
  var initial = new Date(contentInitialDate);
  var end = new Date(contentEndDate);
  return today >= initial && today < end;
};

var createUppyInstance = function createUppyInstance(_ref) {
  var allowedFileTypes = _ref.allowedFileTypes,
      endpoint = _ref.endpoint,
      fields = _ref.fields,
      getUploadParameters = _ref.getUploadParameters,
      fieldName = _ref.fieldName,
      url = _ref.url,
      _ref$useXHR = _ref.useXHR,
      useXHR = _ref$useXHR === void 0 ? false : _ref$useXHR,
      opts = _objectWithoutProperties(_ref, ["allowedFileTypes", "endpoint", "fields", "getUploadParameters", "fieldName", "url", "useXHR"]);

  var uppy = Uppy__default["default"]({
    autoProceed: opts.autoProceed || false,
    restrictions: {
      allowedFileTypes: allowedFileTypes,
      maxFileSize: opts.maxFileSize || MAX_FILE_SIZE,
      maxNumberOfFiles: opts.maxFiles || 1,
      minNumberOfFiles: opts.minFiles || 1
    }
  });

  if (useXHR) {
    uppy.use(XHRUpload__default["default"], {
      endpoint: endpoint,
      fieldName: fieldName,
      withCredentials: true
    });
  } else {
    var defaultGetUploadParameters = function defaultGetUploadParameters() {
      return {
        fields: fields,
        method: 'POST',
        url: url
      };
    };

    uppy.use(UppyAwsS3__default["default"], {
      getUploadParameters: getUploadParameters || defaultGetUploadParameters
    });
  }

  return uppy;
};

var $$b = _export;
var FREEZING = freezing;
var fails$5 = fails$r;
var isObject = isObject$i;
var onFreeze = internalMetadata.exports.onFreeze;

// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails$5(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$$b({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});

/* eslint-disable es/no-array-prototype-indexof -- required for testing */
var $$a = _export;
var $indexOf = arrayIncludes.indexOf;
var arrayMethodIsStrict$2 = arrayMethodIsStrict$7;

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD$2 = arrayMethodIsStrict$2('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$$a({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD$2 }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject$1 = anObject$i;
var requireObjectCoercible$2 = requireObjectCoercible$d;
var sameValue = sameValue$1;
var regExpExec = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic('search', 1, function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$2(this);
      var searcher = regexp == undefined ? undefined : regexp[SEARCH];
      return searcher !== undefined ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative(nativeSearch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject$1(regexp);
      var S = String(this);

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

var $$9 = _export;

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$$9({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number != number;
  }
});

var DESCRIPTORS = descriptors;
var global$2 = global$s;
var isForced = isForced_1;
var redefine$1 = redefine$d.exports;
var has = has$f;
var classof$1 = classofRaw$1;
var inheritIfRequired = inheritIfRequired$2;
var toPrimitive = toPrimitive$5;
var fails$4 = fails$r;
var create = objectCreate;
var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var defineProperty = objectDefineProperty.f;
var trim$1 = stringTrim.trim;

var NUMBER = 'Number';
var NativeNumber = global$2[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof$1(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim$1(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails$4(function () { NumberPrototype.valueOf.call(dummy); }) : classof$1(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor$1(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine$1(global$2, NUMBER, NumberWrapper);
}

var classof = classofRaw$1;

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
var thisNumberValue$1 = function (value) {
  if (typeof value != 'number' && classof(value) != 'Number') {
    throw TypeError('Incorrect invocation');
  }
  return +value;
};

var $$8 = _export;
var toInteger = toInteger$7;
var thisNumberValue = thisNumberValue$1;
var repeat$1 = stringRepeat;
var fails$3 = fails$r;

var nativeToFixed = 1.0.toFixed;
var floor = Math.floor;

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = String(data[index]);
      s = s === '' ? t : s + repeat$1.call('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED$2 = nativeToFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !fails$3(function () {
  // V8 ~ Android 4.3-
  nativeToFixed.call({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$$8({ target: 'Number', proto: true, forced: FORCED$2 }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toInteger(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat$1.call('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat$1.call('0', fractDigits - k) + result
        : result.slice(0, k - fractDigits) + '.' + result.slice(k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});

var global$1 = global$s;
var trim = stringTrim.trim;
var whitespaces = whitespaces$4;

var $parseInt = global$1.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED$1 = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$1 ? function parseInt(string, radix) {
  var S = trim(String(string));
  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt;

var $$7 = _export;
var parseIntImplementation = numberParseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$$7({ global: true, forced: parseInt != parseIntImplementation }, {
  parseInt: parseIntImplementation
});

var redefine = redefine$d.exports;
var anObject = anObject$i;
var fails$2 = fails$r;
var flags = regexpFlags$1;

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails$2(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}

var $$6 = _export;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var toLength = toLength$d;
var notARegExp = notARegexp;
var requireObjectCoercible$1 = requireObjectCoercible$d;
var correctIsRegExpLogic = correctIsRegexpLogic;

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var $startsWith = ''.startsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$$6({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = String(requireObjectCoercible$1(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

var fallBackLanguage = 'en';
var lang = !!global.window && window.languageCode || !!global.window && window.navigator.language || fallBackLanguage;
var languageCode = lang.toLocaleLowerCase();
var enCurrency = {
  decimal: '.',
  symbol: '$',
  decimalLimit: 2
};
var currencyLocale = {
  en: enCurrency,
  'en-us': enCurrency,
  'pt-br': {
    decimal: ',',
    symbol: 'R$',
    decimalLimit: 2
  },
  'es-mx': {
    decimal: '.',
    symbol: '$',
    decimalLimit: 2
  }
};

var isDate = function isDate(value) {
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  try {
    var format = {
      'pt-br': /^\d{1,2}\/\d{1,2}\/\d{4}$/,
      en: /^\d{4}\/\d{1,2}\/\d{1,2}$/
    };
    var parsedLang = lang.toLocaleLowerCase();
    var viewFormat = format[parsedLang] || format.en;

    if (!viewFormat.test(value)) {
      return false;
    }

    var _value$split = value.split('/'),
        _value$split2 = _slicedToArray(_value$split, 3),
        dayOrYear = _value$split2[0],
        month = _value$split2[1],
        yearOrDay = _value$split2[2];

    var obj = {
      en: {
        month: month,
        day: yearOrDay,
        year: dayOrYear
      },
      'pt-br': {
        month: month,
        day: dayOrYear,
        year: yearOrDay
      }
    };
    var dateObj = obj[parsedLang] || obj.en;
    return luxon.DateTime.fromObject(dateObj).isValid;
  } catch (_unused) {
    return false;
  }
};

var keyCodes = {
  enter: 13
};

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary() {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hasError: false
    });

    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      console.error(error);
      console.error(info);
    }
  }, {
    key: "render",
    value: function render() {
      var hasError = this.state.hasError;
      var _this$props = this.props,
          children = _this$props.children,
          CustomFallback = _this$props.renderFallback;

      if (!hasError) {
        return children;
      }

      if (CustomFallback) {
        return /*#__PURE__*/React__default["default"].createElement(CustomFallback, null);
      }

      return null;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(React__default["default"].Component);

ErrorBoundary.defaultProps = {
  renderFallback: null
};

var transformOptionsToQueryString = function transformOptionsToQueryString(checks, options) {
  var params = new URLSearchParams('');
  options.forEach(function (_ref) {
    var checkboxes = _ref.checkboxes,
        name = _ref.name;
    checkboxes.forEach(function (check) {
      var _Object$keys = Object.keys(check),
          _Object$keys2 = _slicedToArray(_Object$keys, 1),
          checkName = _Object$keys2[0];

      var checkValue = check[checkName];
      var stateKey = "".concat(name, "-").concat(checkName);
      var isChecked = checks[stateKey];

      if (isChecked) {
        params.append(name, checkValue);
      }
    });
  });
  return params.toString();
};

var $$5 = _export;
var $find = arrayIteration.find;
var addToUnscopables = addToUnscopables$3;

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$$5({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);

var transformQueryStringToOptions = function transformQueryStringToOptions(options, queryString) {
  var params = queryString.replace(/^\?/, '').split('&');
  var nameIndex = 0;
  var paramsList = params.map(function (param) {
    var _param$split = param.split('='),
        _param$split2 = _slicedToArray(_param$split, 2),
        name = _param$split2[0],
        value = _param$split2[1];

    return _defineProperty({}, name, value);
  });

  var getName = function getName(option) {
    return Object.keys(option)[nameIndex];
  };

  var getValue = function getValue(option) {
    return option[Object.keys(option)[nameIndex]];
  };

  var getValuesByName = function getValuesByName(name) {
    return paramsList.reduce(function (values, param) {
      if (getName(param) === name) {
        return [].concat(_toConsumableArray(values), [getValue(param)]);
      }

      return values;
    }, []);
  };

  var getCheckboxesNamesByValues = function getCheckboxesNamesByValues(checkboxes, values) {
    return values.map(function (value) {
      return getName(checkboxes.find(function (check) {
        return getValue(check) === value;
      }));
    });
  };

  return options.reduce(function (values, option) {
    var paramValuesList = getValuesByName(option.name);
    var checkboxes = getCheckboxesNamesByValues(option.checkboxes, paramValuesList);

    if (paramValuesList.length) {
      return [].concat(_toConsumableArray(values), [{
        name: option.name,
        checkboxes: checkboxes
      }]);
    }

    return values;
  }, []);
};

var InputDate = function InputDate(_ref) {
  var endOfDay = _ref.endOfDay,
      onBlur = _ref.onBlur,
      validate = _ref.validate,
      initialValue = _ref.initialValue,
      rest = _objectWithoutProperties(_ref, ["endOfDay", "onBlur", "validate", "initialValue"]);

  var languageCode = navigator.language;
  var parsedLanguage = languageCode.toLocaleLowerCase();
  var format = {
    'pt-br': DATE_PATTERN_PT_BR,
    en: DATE_PATTERN
  };
  var viewFormat = format[parsedLanguage] || format.en;

  var validateDate = function validateDate(value) {
    if (validate) {
      var date = toDate(normalizeFormat(value, parsedLanguage), endOfDay);
      return validate(date);
    }

    if (value && !isDate(value, parsedLanguage)) {
      return ['Invalid date'];
    }

    return null;
  };

  var setDateValue = function setDateValue(value) {
    if (isDate(value, parsedLanguage)) {
      var date = toDate(normalizeFormat(value, parsedLanguage), endOfDay);
      onBlur(date);
    }
  };

  return /*#__PURE__*/React__default["default"].createElement(InputLabelError, _extends({}, rest, {
    mask: viewFormat,
    validate: validateDate,
    initialValue: toLocalDateStringFormat(initialValue, languageCode),
    guide: false,
    onBlur: function onBlur(event, input) {
      return setDateValue(input.value);
    }
  }));
};

InputDate.defaultProps = {
  endOfDay: false,
  initialValue: null,
  onBlur: function onBlur() {},
  validate: null
};

var withError = function withError(Component) {
  return function (_ref) {
    var input = _ref.input,
        meta = _ref.meta,
        rest = _objectWithoutProperties(_ref, ["input", "meta"]);

    var hasErrorAndTouched = meta.error && meta.touched;
    var hasSubmitError = !meta.dirtySinceLastSubmit && meta.submitError;
    return /*#__PURE__*/React__default["default"].createElement(Component, _extends({
      error: hasErrorAndTouched || hasSubmitError,
      input: input,
      meta: meta
    }, input, rest));
  };
};
var withFieldError = function withFieldError(Component) {
  return function (_ref2) {
    var input = _ref2.input,
        meta = _ref2.meta,
        rest = _objectWithoutProperties(_ref2, ["input", "meta"]);

    var hasErrorAndTouched = meta.error && meta.touched;
    var hasSubmitError = !meta.dirtySinceLastSubmit && meta.submitError;
    var errors = meta.error || meta.submitError;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Component, _extends({
      input: input,
      meta: meta
    }, input, rest)), (hasErrorAndTouched || hasSubmitError) && /*#__PURE__*/React__default["default"].createElement(united.FieldError, {
      messages: errors
    }));
  };
};
var withSuccess = function withSuccess(Component) {
  return function (_ref3) {
    var input = _ref3.input,
        meta = _ref3.meta,
        rest = _objectWithoutProperties(_ref3, ["input", "meta"]);

    return /*#__PURE__*/React__default["default"].createElement(Component, _extends({
      input: input,
      meta: meta,
      success: meta.touched && meta.valid
    }, input, rest));
  };
};

var FormVisibility = /*#__PURE__*/React.createContext({});
var Visibility = /*#__PURE__*/React.createContext({});
var _DISABLED$HIDDEN = {
  DISABLED: 'disabled',
  HIDDEN: 'hidden'
},
    DISABLED = _DISABLED$HIDDEN.DISABLED,
    HIDDEN = _DISABLED$HIDDEN.HIDDEN;
var disabledInput = function disabledInput(input, status) {
  return _objectSpread2(_objectSpread2({}, input), {}, {
    disabled: status === DISABLED
  });
};

var VisibilityApply = function VisibilityApply(_ref) {
  var Component = _ref.Component,
      component = _ref.component,
      _ref$visibility = _ref.visibility,
      visibility = _ref$visibility === void 0 ? {} : _ref$visibility,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["Component", "component", "visibility", "children"]);

  var status = visibility.status;

  if (status === HIDDEN) {
    return null;
  }

  return /*#__PURE__*/React__default["default"].createElement(Visibility.Provider, {
    value: visibility
  }, /*#__PURE__*/React__default["default"].createElement(FieldVisibilityReason, props, /*#__PURE__*/React__default["default"].createElement(Component, props, function (_ref2) {
    var input = _ref2.input,
        contextState = _objectWithoutProperties(_ref2, ["input"]);

    return (component || children)(_objectSpread2(_objectSpread2({}, contextState), {}, {
      input: disabledInput(input, status)
    }));
  })));
};

var fieldWithVisibility = function fieldWithVisibility(Component) {
  return function (props) {
    return /*#__PURE__*/React__default["default"].createElement(FormVisibility.Consumer, null, function () {
      var visibilities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var visibilityName = props.visibilityName || props.name;

      var newProps = _objectSpread2(_objectSpread2({}, props), {}, {
        visibilityName: visibilityName
      });

      return VisibilityApply(_objectSpread2(_objectSpread2({}, newProps), {}, {
        Component: Component,
        visibility: visibilities[visibilityName]
      }));
    });
  };
};
var FieldVisibility = fieldWithVisibility(reactFinalForm.Field);
var FormGroupVisibility = function FormGroupVisibility(_ref3) {
  var children = _ref3.children,
      visibilityName = _ref3.visibilityName;
  return /*#__PURE__*/React__default["default"].createElement(FormVisibility.Consumer, null, function () {
    var visibilities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref4 = visibilities[visibilityName] || {},
        status = _ref4.status;

    if (status === HIDDEN) {
      return null;
    }

    return children;
  });
};
var ActionVisibility = function ActionVisibility(_ref5) {
  var children = _ref5.children,
      visibilityName = _ref5.visibilityName;
  return /*#__PURE__*/React__default["default"].createElement(FormVisibility.Consumer, null, function () {
    var visibilities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref6 = visibilities[visibilityName] || {},
        status = _ref6.status;

    if (status === HIDDEN || status === DISABLED) {
      return null;
    }

    return children;
  });
};
var FieldVisibilityReason = function FieldVisibilityReason(_ref7) {
  _ref7.visibilityName;
      var popoverConfig = _ref7.popoverConfig,
      _ref7$showPopover = _ref7.showPopover,
      showPopover = _ref7$showPopover === void 0 ? true : _ref7$showPopover,
      props = _objectWithoutProperties(_ref7, ["visibilityName", "popoverConfig", "showPopover"]);

  return /*#__PURE__*/React__default["default"].createElement(Visibility.Consumer, null, function () {
    var visibility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var description = visibility.description,
        title = visibility.title,
        status = visibility.status;
    var shouldShowPopover = showPopover && status === DISABLED && (title || description);

    if (!shouldShowPopover) {
      return props.children;
    }

    return /*#__PURE__*/React__default["default"].createElement(united.Popover, _extends({
      content: description,
      placement: "topLeft",
      title: title,
      trigger: "hover",
      width: 400
    }, popoverConfig), props.children);
  });
};

var CharacterCounter = function CharacterCounter(_ref) {
  var children = _ref.children,
      counterLabel = _ref.counterLabel,
      currentLength = _ref.currentLength,
      maxLength = _ref.maxLength,
      minLength = _ref.minLength,
      suggestedLength = _ref.suggestedLength,
      isVisited = _ref.isVisited;
  var theme = styled.useTheme();

  var getTextVariation = function getTextVariation() {
    var isLengthForbidden = currentLength < minLength || currentLength > maxLength;
    var isSuggestedLength = suggestedLength && currentLength >= suggestedLength;

    if (isLengthForbidden && isVisited) {
      return 'danger';
    }

    if (isSuggestedLength) {
      return 'success';
    }

    return 'text';
  };

  return /*#__PURE__*/React__default["default"].createElement(united.Flex, {
    flexDirection: "column",
    fontSize: theme.olist.fontSize['3xsmall']
  }, children, /*#__PURE__*/React__default["default"].createElement(united.Flex, {
    mt: theme.olist.spacing.stack['2xsmall'],
    "data-ref": "counter"
  }, /*#__PURE__*/React__default["default"].createElement(united.Text, {
    variation: getTextVariation(),
    fontWeight: "bold",
    "data-ref": "current-length"
  }, currentLength), ' / ', /*#__PURE__*/React__default["default"].createElement(united.Text, {
    color: "neutral.strong"
  }, "".concat(maxLength, " ").concat(counterLabel))));
};

CharacterCounter.defaultProps = {
  counterLabel: null,
  suggestedLength: null
};

var _templateObject$l;
var InputFileHidden = styled__default["default"].input(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n  height: 0;\n  position: absolute;\n  visibility: hidden;\n  width: 0;\n  z-index: -1;\n"])));

var preventDefault = function preventDefault(e) {
  return e.preventDefault();
};

var Dropzone = /*#__PURE__*/function (_Component) {
  _inherits(Dropzone, _Component);

  var _super = _createSuper(Dropzone);

  function Dropzone() {
    var _this;

    _classCallCheck(this, Dropzone);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "inputFile", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "isComingFromDrop", false);

    _defineProperty(_assertThisInitialized(_this), "drop", function (event) {
      event.preventDefault();
      var dataTransfer = event.dataTransfer;
      var files = dataTransfer.files;
      var _this$props = _this.props,
          accept = _this$props.accept,
          onDrop = _this$props.onDrop,
          multiple = _this$props.multiple;
      var checkMultipleFilesIsAllow = !multiple && files.length > 1;
      var fileIsEmpty = !files.length;

      if (fileIsEmpty || checkMultipleFilesIsAllow) {
        return;
      }

      var arrayOfFiles = _toConsumableArray(files);

      var acceptedFiles = arrayOfFiles.filter(function (file) {
        return fileAccept(file, accept);
      });
      var rejectedFiles = arrayOfFiles.filter(function (file) {
        return !fileAccept(file, accept);
      });
      _this.inputFile.current.files = null;

      if (!rejectedFiles.length && files instanceof FileList) {
        _this.isComingFromDrop = true;
        _this.inputFile.current.files = files;
      }

      onDrop.call(_assertThisInitialized(_this), acceptedFiles, rejectedFiles, event);
    });

    _defineProperty(_assertThisInitialized(_this), "onFileChange", function (event) {
      var onDrop = _this.props.onDrop;
      var files = event.target.files;

      var acceptedFiles = _toConsumableArray(files);

      if (!_this.isComingFromDrop) {
        onDrop.call(_assertThisInitialized(_this), acceptedFiles);
      }

      _this.isComingFromDrop = false;
    });

    _defineProperty(_assertThisInitialized(_this), "openChoose", function () {
      _this.inputFile.current.files = null;

      _this.inputFile.current.click();
    });

    return _this;
  }

  _createClass(Dropzone, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('dragover', preventDefault, false);
      document.addEventListener('drop', preventDefault, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('dragover', preventDefault, false);
      document.removeEventListener('drop', preventDefault, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          accept = _this$props2.accept,
          children = _this$props2.children,
          inputProps = _this$props2.inputProps,
          multiple = _this$props2.multiple;
      return /*#__PURE__*/React__default["default"].createElement(united.Flex, {
        onClick: this.openChoose,
        onDrop: this.drop,
        role: "presentation",
        width: 1
      }, /*#__PURE__*/React__default["default"].createElement(InputFileHidden, _extends({
        type: "file",
        accept: accept,
        ref: this.inputFile,
        multiple: multiple,
        onChange: this.onFileChange
      }, inputProps)), children);
    }
  }]);

  return Dropzone;
}(React.Component);

Dropzone.defaultProps = {
  accept: '',
  inputProps: {},
  multiple: true,
  onDrop: function onDrop() {}
};

var _templateObject$k;
var FieldTip = styled__default["default"].p(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  padding: ", " 0;\n"])), themeGet.themeGet('olist.color.neutral.strong'), themeGet.themeGet('olist.fontSize.3xsmall'), themeGet.themeGet('olist.lineHeight.1xsmall'), themeGet.themeGet('olist.spacing.stack.1xsmall'));

var formWithToken = function formWithToken(FormComponent) {
  return /*#__PURE__*/function (_Component) {
    _inherits(_class, _Component);

    var _super = _createSuper(_class);

    function _class() {
      _classCallCheck(this, _class);

      return _super.apply(this, arguments);
    }

    _createClass(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        /* eslint-disable-next-line react/no-find-dom-node */
        var form = require$$1.findDOMNode(this.comp);
        var csrftoken = Cookie__default["default"].get('csrftoken');
        var wrapperInput = document.createElement('div');
        var inputWithToken = "<input name=\"csrfmiddlewaretoken\" type=\"hidden\" value=\"".concat(csrftoken, "\" />");
        wrapperInput.innerHTML = inputWithToken;
        form.insertBefore(wrapperInput, form.firstChild);
      }
    }, {
      key: "render",
      value: function render() {
        var _this = this;

        return /*#__PURE__*/React__default["default"].createElement(FormComponent, _extends({
          ref: function ref(_ref) {
            _this.comp = _ref;
          }
        }, this.props));
      }
    }]);

    return _class;
  }(React.Component);
};

var $$4 = _export;
var repeat = stringRepeat;

// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$$4({ target: 'String', proto: true }, {
  repeat: repeat
});

var currencyWithLocale = currencyLocale[languageCode] || currencyLocale['pt-br'];
var addDecimalToNumber = function addDecimalToNumber(digits) {
  var decimalLimit = currencyWithLocale.decimalLimit;
  var decimalStartingPosition = digits.length - decimalLimit;
  var integerWithLeadingZeros = digits.substring(0, decimalStartingPosition);
  var integer = removeLeadingZeros(integerWithLeadingZeros);
  var decimal = digits.substring(decimalStartingPosition);
  return "".concat(integer).concat(currencyWithLocale.decimal).concat(decimal);
};
var padDigits = function padDigits(digits) {
  var desiredLength = currencyWithLocale.decimalLimit + 1;
  var actualLength = digits.length;

  if (actualLength >= desiredLength) {
    return digits;
  }

  var amountToAdd = desiredLength - actualLength;
  var padding = '0'.repeat(amountToAdd);
  return padding + digits;
};
var formatInputToCurrency = function formatInputToCurrency(value) {
  return addDecimalToNumber(padDigits(getDigits(value)));
};
var maskFn = function maskFn(input) {
  var numberWithDecimal = formatInputToCurrency(input);
  var digitRegex = /\d/;
  var decimal = currencyWithLocale.decimal;
  return numberWithDecimal.split('').map(function (_char) {
    return _char !== decimal ? digitRegex : decimal;
  });
};
var pipe = function pipe() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$allowEmpty = _ref.allowEmpty,
      allowEmpty = _ref$allowEmpty === void 0 ? true : _ref$allowEmpty;

  return function (conformedValue, config) {
    var digits = getDigits(config.rawValue);
    var digitsWithPadding = padDigits(digits);

    if (allowEmpty && (digits === '' || digits === '0'.repeat(currencyWithLocale.decimalLimit))) {
      return '';
    }

    return addDecimalToNumber(digitsWithPadding);
  };
};

var InputCurrency = function InputCurrency(_ref2) {
  var allowEmpty = _ref2.allowEmpty,
      withPlaceholder = _ref2.withPlaceholder,
      rest = _objectWithoutProperties(_ref2, ["allowEmpty", "withPlaceholder"]);

  return /*#__PURE__*/React__default["default"].createElement(MaskedInput__default["default"], _extends({}, rest, {
    pipe: pipe({
      allowEmpty: allowEmpty
    }),
    mask: maskFn,
    render: function render(ref, renderProps) {
      return /*#__PURE__*/React__default["default"].createElement(united.Input, _extends({
        ref: ref,
        type: "text",
        prepend: currencyWithLocale === null || currencyWithLocale === void 0 ? void 0 : currencyWithLocale.symbol,
        placeholder: withPlaceholder ? formatInputToCurrency('0') : undefined
      }, renderProps));
    }
  }));
};

InputCurrency.defaultProps = {
  maxLength: '10',
  allowEmpty: true,
  withPlaceholder: false
};

var InputDebounce = function InputDebounce(props) {
  var onChange = props.onChange,
      debounceTimeout = props.debounceTimeout;

  var onChangeDebounce = function onChangeDebounce(event) {
    var eventSyntactic = _objectSpread2({}, event);

    return debounce(function () {
      return onChange(eventSyntactic);
    }, debounceTimeout)();
  };

  return /*#__PURE__*/React__default["default"].createElement(united.Input, _extends({}, props, {
    onChange: onChangeDebounce
  }));
};

var InputOnlyDigits = function InputOnlyDigits(_ref) {
  var onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ["onChange"]);

  var inputElement = React.useRef(null);

  var updateValue = function updateValue() {
    var element = inputElement.current;

    if (element.value) {
      element.value = getDigits(element.value);
    }
  };

  var handleChange = function handleChange(event) {
    updateValue();

    if (typeof onChange === 'function') {
      onChange(event);
    }
  };

  return /*#__PURE__*/React__default["default"].createElement(united.Input, _extends({}, rest, {
    ref: inputElement,
    onChange: handleChange
  }));
};

InputOnlyDigits.defaultProps = {
  onChange: function onChange() {}
};

var useEvents = function useEvents(_ref) {
  var onSubmit = _ref.onSubmit,
      onClear = _ref.onClear,
      initialValue = _ref.initialValue,
      selectAfterSubmit = _ref.selectAfterSubmit;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var _useState3 = React.useState(initialValue),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var input = /*#__PURE__*/React.createRef();
  React.useEffect(function () {
    setValue(initialValue);
  }, [initialValue]);

  var handleFocus = function handleFocus() {
    return setIsFocused(true);
  };

  var handleBlur = function handleBlur() {
    return setIsFocused(false);
  };

  var handleChange = function handleChange(event) {
    return setValue(event.target.value);
  };

  var handleClear = function handleClear() {
    return onClear(value);
  };

  var handleSubmit = function handleSubmit() {
    onSubmit(value);

    if (selectAfterSubmit) {
      input.current.select();
    }
  };

  var handleKeyPress = function handleKeyPress(_ref2) {
    var charCode = _ref2.charCode;
    return charCode === keyCodes.enter && handleSubmit();
  };

  return {
    input: input,
    isFocused: isFocused,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleSubmit: handleSubmit,
    handleClear: handleClear,
    handleFocus: handleFocus,
    handleKeyPress: handleKeyPress,
    value: value,
    selectAfterSubmit: selectAfterSubmit
  };
};

({
  isFiltered: T.bool,
  onClear: T.func,
  onSubmit: T.func.isRequired,
  placeholder: T.string,
  searchValue: T.string,
  selectAfterSubmit: T.bool
});
var defaultProps = {
  isFiltered: false,
  onClear: function onClear() {},
  placeholder: '',
  searchValue: '',
  selectAfterSubmit: false
};
var ERROR = 'ERROR';
var LOADING = 'LOADING';
var SUCCESS = 'SUCCESS';
var SUBMITTED = 'SUBMITTED';
var DEFAULT = 'DEFAULT';
var variationsType = {
  ERROR: ERROR,
  LOADING: LOADING,
  SUCCESS: SUCCESS,
  SUBMITTED: SUBMITTED,
  DEFAULT: DEFAULT
};

var _templateObject$j, _templateObject2$d;
var Wrapper$2 = styled__default["default"](united.Relative)(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n  display: inline-block;\n"])));
var InputBorderless = styled__default["default"](united.Input)(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n  border: transparent;\n  border-bottom: 2px solid transparent;\n  border-radius: 0;\n  box-shadow: none;\n  display: inline-block;\n  transition: all 0.25s ease-in-out;\n\n  &::placeholder {\n    opacity: 1;\n    text-align: right;\n    transition: all 0.25s ease-in-out;\n  }\n\n  &:focus {\n    border: transparent;\n    border-bottom: 2px solid ", ";\n    min-width: 300px;\n    outline: none;\n    outline-offset: 0;\n\n    &::placeholder {\n      opacity: 0;\n    }\n  }\n\n  ", "\n"])), themeGet.themeGet('olist.color.primary.base'), styledSystem.layout);

var IconFeedback = function IconFeedback(_ref) {
  var _propsVariation;

  var variation = _ref.variation,
      onSearch = _ref.onSearch,
      onClear = _ref.onClear;

  var _useTheme = styled.useTheme(),
      olist = _useTheme.olist;

  if (variation === variationsType.LOADING) {
    return /*#__PURE__*/React__default["default"].createElement(LoadingSpinner, null);
  }

  var propsVariation = (_propsVariation = {}, _defineProperty(_propsVariation, variationsType.ERROR, {
    name: 'alert-circle-fill',
    color: olist.color.alert.base
  }), _defineProperty(_propsVariation, variationsType.SUCCESS, {
    name: 'success-circle-fill',
    color: olist.color.success.base
  }), _defineProperty(_propsVariation, variationsType.SUBMITTED, {
    name: 'close-outline',
    color: olist.color.primary.base,
    onClick: onClear
  }), _defineProperty(_propsVariation, variationsType.DEFAULT, {
    name: 'search-outline',
    color: olist.color.primary.base,
    onClick: onSearch
  }), _propsVariation);
  return /*#__PURE__*/React__default["default"].createElement(united.Icon, propsVariation[variation]);
};

IconFeedback.defaultProps = {
  onClear: function onClear() {},
  onSearch: function onSearch() {},
  variation: variationsType.DEFAULT
};

var getVariation = function getVariation(submitted) {
  return submitted ? variationsType.SUBMITTED : variationsType.DEFAULT;
};

var InputSearchBorderless = function InputSearchBorderless(_ref) {
  var onClear = _ref.onClear,
      onSubmit = _ref.onSubmit,
      initialValue = _ref.initialValue,
      submitted = _ref.submitted;
      _ref.error;
      _ref.loading;
      _ref.success;
      var props = _objectWithoutProperties(_ref, ["onClear", "onSubmit", "initialValue", "submitted", "error", "loading", "success"]);

  var _useEvents = useEvents({
    onSubmit: onSubmit,
    onClear: onClear,
    initialValue: initialValue
  }),
      input = _useEvents.input,
      handleBlur = _useEvents.handleBlur,
      handleChange = _useEvents.handleChange,
      handleSubmit = _useEvents.handleSubmit,
      handleClear = _useEvents.handleClear,
      handleFocus = _useEvents.handleFocus,
      handleKeyPress = _useEvents.handleKeyPress,
      value = _useEvents.value;

  var variation = getVariation(submitted);
  var Icon = /*#__PURE__*/React__default["default"].createElement(IconFeedback, {
    onSearch: handleSubmit,
    onClear: handleClear,
    variation: variation
  });
  return /*#__PURE__*/React__default["default"].createElement(Wrapper$2, null, /*#__PURE__*/React__default["default"].createElement(InputBorderless, _extends({
    append: Icon,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    onKeyPress: handleKeyPress,
    pointerEventsAppend: true,
    ref: input,
    value: value
  }, props)));
};

InputSearchBorderless.defaultProps = defaultProps;

var _templateObject$i;

var borderVariation = function borderVariation(_ref) {
  var _variationsBorders;

  var variation = _ref.variation,
      olist = _ref.theme.olist;

  var cssWithBorder = function cssWithBorder(color) {
    return styled.css(["border:2px solid ", ";&:focus{border:2px solid ", ";outline:1px solid ", ";}"], color, color, color);
  };

  var variationsBorders = (_variationsBorders = {}, _defineProperty(_variationsBorders, variationsType.LOADING, cssWithBorder(olist.color.primary.base)), _defineProperty(_variationsBorders, variationsType.ERROR, cssWithBorder(olist.color.alert.base)), _defineProperty(_variationsBorders, variationsType.SUCCESS, cssWithBorder(olist.color.success.base)), _defineProperty(_variationsBorders, variationsType.SUBMITTED, styled.css([""])), _defineProperty(_variationsBorders, variationsType.DEFAULT, styled.css([""])), _variationsBorders);
  return variationsBorders[variation];
}; // eslint-disable-next-line import/prefer-default-export


var InputVariation = styled__default["default"](united.Input)(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n  height: 38px;\n  ", ";\n"])), borderVariation);

var createVariation = function createVariation(submitted, error, loading, success) {
  if (loading) {
    return variationsType.LOADING;
  }

  if (error) {
    return variationsType.ERROR;
  }

  if (success) {
    return variationsType.SUCCESS;
  }

  if (submitted) {
    return variationsType.SUBMITTED;
  }

  return variationsType.DEFAULT;
};

var InputSearch = function InputSearch(_ref) {
  var onClear = _ref.onClear,
      onSubmit = _ref.onSubmit,
      initialValue = _ref.initialValue,
      submitted = _ref.submitted,
      error = _ref.error,
      loading = _ref.loading,
      success = _ref.success,
      append = _ref.append,
      selectAfterSubmit = _ref.selectAfterSubmit,
      props = _objectWithoutProperties(_ref, ["onClear", "onSubmit", "initialValue", "submitted", "error", "loading", "success", "append", "selectAfterSubmit"]);

  var _useEvents = useEvents({
    onSubmit: onSubmit,
    onClear: onClear,
    initialValue: initialValue,
    selectAfterSubmit: selectAfterSubmit
  }),
      input = _useEvents.input,
      handleBlur = _useEvents.handleBlur,
      handleChange = _useEvents.handleChange,
      handleSubmit = _useEvents.handleSubmit,
      handleClear = _useEvents.handleClear,
      handleFocus = _useEvents.handleFocus,
      handleKeyPress = _useEvents.handleKeyPress,
      value = _useEvents.value;

  var variation = createVariation(submitted, error, loading, success);
  var icon = append || /*#__PURE__*/React__default["default"].createElement(IconFeedback, {
    onSearch: handleSubmit,
    onClear: handleClear,
    variation: variation
  });
  return /*#__PURE__*/React__default["default"].createElement(InputVariation, _extends({
    ref: input,
    onKeyPress: handleKeyPress,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onChange: handleChange,
    value: value,
    pointerEventsAppend: true,
    variation: variation,
    append: icon
  }, props));
};

InputSearch.defaultProps = defaultProps;
InputSearch.Borderless = InputSearchBorderless;

var searchNavigation = function searchNavigation(SearchComponent) {
  return function (_ref) {
    var persistParams = _ref.persistParams,
        onQueryChange = _ref.onQueryChange,
        param = _ref.param,
        props = _objectWithoutProperties(_ref, ["persistParams", "onQueryChange", "param"]);

    var _Object$keys = Object.keys(param),
        _Object$keys2 = _slicedToArray(_Object$keys, 1),
        key = _Object$keys2[0];

    var _useState = React.useState(param[key] || ''),
        _useState2 = _slicedToArray(_useState, 2),
        searchValue = _useState2[0],
        setSearchValue = _useState2[1];

    var isSubmitted = !!searchValue && searchValue === param[key];

    var handleRequest = function handleRequest() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return function () {
        var paramsObject = value ? _objectSpread2(_defineProperty({}, key, value), persistParams) : _objectSpread2({}, persistParams);
        onQueryChange(paramsObject);
        setSearchValue(value);
      };
    };

    return /*#__PURE__*/React__default["default"].createElement(SearchComponent, _extends({
      onSubmit: handleRequest(searchValue),
      onClear: handleRequest(),
      onChange: function onChange(e) {
        return setSearchValue(e.target.value);
      },
      submitted: isSubmitted,
      value: searchValue
    }, props));
  };
};

searchNavigation.defaultProps = {
  persistParams: {}
};
var InputSearchNavigation = searchNavigation(InputSearch);
InputSearchNavigation.Borderless = searchNavigation(InputSearchBorderless);

var TOGGLE_CHECKBOX = 'TOGGLE_CHECKBOX';
var CLEAR_CHECKBOXES = 'CLEAR_CHECKBOXES';
var createHasValue = function createHasValue(options) {
  return function (name, value) {
    var hasOptionName = options.find(function (option) {
      return option.name === name;
    });
    var hasValueInOptionName = !!hasOptionName && hasOptionName.checkboxes.some(function (optionValue) {
      return optionValue === value;
    });
    return hasValueInOptionName;
  };
};
var normalizeCheckState = function normalizeCheckState(hasValue, options) {
  return options.reduce(function (checkState, option) {
    return option.checkboxes.reduce(function (optionValues, checkbox) {
      var value = checkbox.value;
      return _objectSpread2(_objectSpread2({}, optionValues), {}, _defineProperty({}, "".concat(option.name, "-").concat(value), hasValue(option.name, value)));
    }, checkState);
  }, {});
};
var checkboxesReducer = function checkboxesReducer(state, action) {
  switch (action.type) {
    case TOGGLE_CHECKBOX:
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.name, !state[action.name]));

    case CLEAR_CHECKBOXES:
      return Object.keys(state).reduce(function (options, optionKey) {
        return _objectSpread2(_objectSpread2({}, options), {}, _defineProperty({}, optionKey, false));
      }, {});

    default:
      return state;
  }
};

var useFilter = function useFilter(_ref) {
  var options = _ref.options,
      onSubmit = _ref.onSubmit,
      onClear = _ref.onClear,
      searchValue = _ref.searchValue;
  var hasValue = createHasValue(searchValue);
  var checkInitialState = normalizeCheckState(hasValue, options);

  var _useReducer = React.useReducer(checkboxesReducer, checkInitialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      checks = _useReducer2[0],
      dispatch = _useReducer2[1]; // actions


  var toggleCheckbox = function toggleCheckbox(name) {
    return dispatch({
      type: TOGGLE_CHECKBOX,
      name: name
    });
  };

  var clearCheckboxes = function clearCheckboxes() {
    return dispatch({
      type: CLEAR_CHECKBOXES
    });
  }; // events


  var handleSubmit = function handleSubmit() {
    return onSubmit(checks, options);
  };

  var handleClear = function handleClear() {
    clearCheckboxes();
    onClear(checks);
  };

  return {
    checks: checks,
    toggleCheckbox: toggleCheckbox,
    clearCheckboxes: clearCheckboxes,
    handleSubmit: handleSubmit,
    handleClear: handleClear
  };
};

var _templateObject$h, _templateObject2$c, _templateObject3$8, _templateObject4$4;
var listCss = styled.css(["list-style:none;"]);
var ContainerMenu = styled__default["default"].div(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n  max-height: 300px;\n  overflow: auto;\n"])));
var OptionGroup = styled__default["default"].ul(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n  font-size: ", ";\n  margin: 6px 0;\n  padding: 0 ", ";\n"])), themeGet.themeGet('olist.fontSize.1xsmall'), themeGet.themeGet('olist.spacing.inline.small'));
var Label = styled__default["default"].li(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  padding-bottom: 6px;\n\n  ", "\n"])), themeGet.themeGet('olist.color.neutral.strong'), themeGet.themeGet('olist.fontSize.1xsmall'), listCss);
var Option = styled__default["default"].li(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n  padding: 6px 0;\n  white-space: nowrap;\n\n  ", "\n"])), listCss);

var checkboxOnChange = function checkboxOnChange(name, toggleCheckbox) {
  return function () {
    return toggleCheckbox(name);
  };
};

var CheckBoxFilter = function CheckBoxFilter(_ref) {
  var label = _ref.label,
      labelActions = _ref.labelActions,
      justifyContent = _ref.justifyContent,
      options = _ref.options,
      onSubmit = _ref.onSubmit,
      onClear = _ref.onClear,
      searchValue = _ref.searchValue,
      optionsDirection = _ref.optionsDirection,
      width = _ref.width,
      typeButton = _ref.typeButton;

  var _useFilter = useFilter({
    options: options,
    onSubmit: onSubmit,
    onClear: onClear,
    searchValue: searchValue
  }),
      checks = _useFilter.checks,
      toggleCheckbox = _useFilter.toggleCheckbox,
      handleSubmit = _useFilter.handleSubmit,
      handleClear = _useFilter.handleClear;

  var description = typeof label === 'function' ? label(checks) : label;
  return /*#__PURE__*/React__default["default"].createElement(united.Dropdown, null, /*#__PURE__*/React__default["default"].createElement(united.Dropdown.Toggle, {
    direction: optionsDirection,
    width: width,
    justifyContent: justifyContent,
    type: "button"
  }, description), /*#__PURE__*/React__default["default"].createElement(united.Dropdown.Menu, {
    direction: optionsDirection,
    width: width
  }, /*#__PURE__*/React__default["default"].createElement(ContainerMenu, null, options.map(function (_ref2) {
    var title = _ref2.title,
        name = _ref2.name,
        checkboxes = _ref2.checkboxes;
    return /*#__PURE__*/React__default["default"].createElement(OptionGroup, {
      key: name
    }, title && /*#__PURE__*/React__default["default"].createElement(Label, null, title), checkboxes.map(function (_ref3) {
      var checkboxLabel = _ref3.label,
          value = _ref3.value;
      var checkName = "".concat(name, "-").concat(value);
      return /*#__PURE__*/React__default["default"].createElement(Option, {
        key: checkName
      }, /*#__PURE__*/React__default["default"].createElement(united.Checkbox, {
        label: checkboxLabel,
        onChange: checkboxOnChange(checkName, toggleCheckbox),
        checked: checks[checkName]
      }));
    }));
  })), /*#__PURE__*/React__default["default"].createElement(united.Flex, {
    px: 3,
    pb: 3,
    flexDirection: "column"
  }, /*#__PURE__*/React__default["default"].createElement(united.Box, {
    mb: 2
  }, /*#__PURE__*/React__default["default"].createElement(united.Button, {
    fullWidth: true,
    variation: "alternate",
    onClick: handleSubmit,
    type: typeButton
  }, labelActions.submitLabel)), /*#__PURE__*/React__default["default"].createElement(united.Box, null, /*#__PURE__*/React__default["default"].createElement(united.Button, {
    fullWidth: true,
    onClick: handleClear,
    type: "button"
  }, labelActions.clearLabel)))));
};

CheckBoxFilter.transformQueryStringToOptions = transformQueryStringToOptions;
CheckBoxFilter.transformOptionsToQueryString = transformOptionsToQueryString;
CheckBoxFilter.defaultProps = {
  justifyContent: 'center',
  labelActions: {
    submitLabel: 'Submit',
    clearLabel: 'Clear'
  },
  optionsDirection: 'bottom',
  options: [],
  onSubmit: function onSubmit() {},
  onClear: function onClear() {},
  searchValue: [],
  typeButton: 'submit',
  width: ''
};

var MEGA = 1e6;
var maxSizeToMB = Math.round(MAX_FILE_SIZE / MEGA);
var initialState = {
  bytesUploaded: 0,
  error: false,
  file: null,
  rejectedErrors: [],
  success: false,
  bytesTotal: 1
};

var _templateObject$g, _templateObject2$b, _templateObject3$7, _templateObject4$3, _templateObject5$2;

var styleBorderColor = function styleBorderColor(hasErrors) {
  return hasErrors ? themeGet.themeGet('olist.color.alert.base') : themeGet.themeGet('olist.color.neutral.soft');
};

var styleFeedback = styled.css(["align-items:center;justify-content:space-between;"]);
var StyledDropzone = styled__default["default"](united.Flex).attrs(function () {
  return {
    alignItems: 'center',
    width: 1,
    m: '0 auto',
    mt: 2,
    bg: themeGet.themeGet('olist.color.neutral.softer'),
    flexDirection: 'column',
    justifyContent: 'center'
  };
})(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  border: 1px dashed ", ";\n  cursor: pointer;\n"])), themeGet.themeGet('olist.borderRadius.1xsmall'), function (_ref) {
  var hasErrors = _ref.hasErrors;
  return styleBorderColor(hasErrors);
});
var Success = styled__default["default"](united.Flex).attrs(function () {
  return {
    bg: themeGet.themeGet('olist.color.success.softer')
  };
})(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n  ", "\n"])), styleFeedback);
var IconStyled = styled__default["default"](united.Icon)(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  & path {\n    fill: ", ";\n  }\n"])), themeGet.themeGet('olist.color.neutral.base'));
var List = styled__default["default"].ul(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: ", " 0;\n"])), themeGet.themeGet('olist.spacing.stack.1xsmall'));
var Item = styled__default["default"].li(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-left: ", ";\n"])), themeGet.themeGet('olist.color.alert.base'), themeGet.themeGet('olist.spacing.inline.medium'));

var UploaderErrors = function UploaderErrors(_ref) {
  var errors = _ref.errors,
      showErrors = _ref.showErrors;

  var _useState = React.useState(showErrors),
      _useState2 = _slicedToArray(_useState, 2),
      showErrorsList = _useState2[0],
      setShowErrorsList = _useState2[1];

  return showErrorsList && /*#__PURE__*/React__default["default"].createElement(united.Alert, {
    m: 0
  }, /*#__PURE__*/React__default["default"].createElement(united.Flex, null, /*#__PURE__*/React__default["default"].createElement(List, null, errors.map(function (rejectedError) {
    return /*#__PURE__*/React__default["default"].createElement(Item, {
      key: rejectedError
    }, /*#__PURE__*/React__default["default"].createElement(united.Text, {
      variation: "danger",
      "data-ref": "rejectedError"
    }, rejectedError));
  })), /*#__PURE__*/React__default["default"].createElement(united.Flex, {
    flex: 1,
    justifyContent: "flex-end"
  }, /*#__PURE__*/React__default["default"].createElement(IconStyled, {
    name: "close-outline",
    size: 22,
    onClick: function onClick() {
      return setShowErrorsList(false);
    }
  }))));
};

UploaderErrors.defaultProps = {
  showErrors: false
};

var Uploader = function Uploader(_ref) {
  var accept = _ref.accept,
      customPayload = _ref.customPayload,
      forceReset = _ref.forceReset,
      onUploaded = _ref.onUploaded,
      endpoint = _ref.endpoint,
      mgs = _ref.messages;

  var _useState = React.useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = React.useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      uppyInstance = _useState4[0],
      setUppyInstance = _useState4[1];

  var acceptedFileTypes = _toConsumableArray(accept).join(', ');

  var defaultMessage = {
    insertFileSize: "insert ".concat(acceptedFileTypes, " with maximum size of ").concat(maxSizeToMB, "MB"),
    dragTheFile: 'drag the file or ',
    clickToUpload: 'click to upload',
    errorOnSendFile: 'An error occurred while trying to send the file',
    sendFile: 'send file'
  };

  var messages = _objectSpread2(_objectSpread2({}, defaultMessage), mgs);

  var resetState = function resetState() {
    return setState(initialState);
  };

  var fileName = customPayload.fileName,
      restPayloadFields = _objectWithoutProperties(customPayload, ["fileName"]);

  var onDrop = function onDrop() {
    var newFiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var rejectedFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var hasNewFiles = !!newFiles.length;
    var hasRejectedFiles = !!rejectedFiles.length;
    resetState();

    if (hasRejectedFiles) {
      var _rejectedErrors = rejectedFiles.map(function (_ref2) {
        var name = _ref2.name;
        return "Failed to send ".concat(name, ": type should be \"").concat(acceptedFileTypes, "\".");
      });

      setState(_objectSpread2(_objectSpread2({}, state), {}, {
        rejectedErrors: _rejectedErrors
      }));
    }

    if (hasNewFiles) {
      var _newFiles = _slicedToArray(newFiles, 1),
          first = _newFiles[0];

      var fileObj = {
        data: first,
        name: first.name,
        type: first.type
      };

      try {
        uppyInstance.addFile(fileObj);
        uppyInstance.upload();
      } catch (e) {
        setState(_objectSpread2(_objectSpread2({}, state), {}, {
          error: true,
          file: fileObj
        }));
      }
    }
  };

  var handleUppyInstance = function handleUppyInstance() {
    var uppy = createUppyInstance({
      autoProceed: true,
      allowedFileTypes: accept,
      endpoint: endpoint,
      fieldName: fileName,
      useXHR: true
    });
    setUppyInstance(uppy);
  };

  var handleEvents = function handleEvents() {
    Uploader.handleFileAdded = function (file) {
      uppyInstance.setFileMeta(file.id, _objectSpread2({}, restPayloadFields));
      setState(_objectSpread2(_objectSpread2({}, state), {}, {
        file: file
      }));
    };

    Uploader.handleFileRemoved = function () {
      uppyInstance.reset();
      resetState();
    };

    Uploader.handleUploadSuccess = function (file, response) {
      onUploaded(response);
      setState(_objectSpread2(_objectSpread2({}, state), {}, {
        success: true,
        file: file
      }));
    };

    Uploader.handleUploadProgress = function (file, progress) {
      var bytesUploaded = progress.bytesUploaded,
          bytesTotal = progress.bytesTotal;
      setState(_objectSpread2(_objectSpread2({}, state), {}, {
        file: file,
        bytesUploaded: bytesUploaded,
        bytesTotal: bytesTotal
      }));
    };

    Uploader.handleUploadError = function (file) {
      setState(_objectSpread2(_objectSpread2({}, state), {}, {
        error: true,
        file: file
      }));
    };

    uppyInstance.on('file-added', Uploader.handleFileAdded).on('file-removed', Uploader.handleFileRemoved).on('upload-success', Uploader.handleUploadSuccess).on('upload-progress', Uploader.handleUploadProgress).on('upload-error', Uploader.handleUploadError);
  };

  var bytesTotal = state.bytesTotal,
      bytesUploaded = state.bytesUploaded,
      error = state.error,
      file = state.file,
      rejectedErrors = state.rejectedErrors,
      success = state.success;
  React.useEffect(function () {
    if (!uppyInstance) {
      handleUppyInstance();
    }
  }, [uppyInstance]);
  React.useEffect(function () {
    if (uppyInstance) {
      handleEvents();
    }
  }, [uppyInstance]);
  React.useEffect(function () {
    if (forceReset && uppyInstance) {
      uppyInstance.reset();
      resetState();
    }
  }, [forceReset]);
  var showProgressUpload = !!file && !success && !error;
  var showSuccessUpload = !!file && success;
  var showErrorUpload = !!file && error;
  var hasFormatErrors = !!rejectedErrors.length;
  return /*#__PURE__*/React__default["default"].createElement(united.Box, {
    m: "0 auto"
  }, /*#__PURE__*/React__default["default"].createElement(Dropzone, {
    accept: accept,
    onDrop: onDrop,
    multiple: false,
    forceReset: forceReset
  }, /*#__PURE__*/React__default["default"].createElement(united.Box, {
    width: 1
  }, !file && /*#__PURE__*/React__default["default"].createElement(StyledDropzone, null, /*#__PURE__*/React__default["default"].createElement(united.Box, {
    m: 3
  }, /*#__PURE__*/React__default["default"].createElement(united.Icon, {
    name: "upload-fill",
    size: 64,
    color: "primary.base"
  })), /*#__PURE__*/React__default["default"].createElement(united.Box, null, /*#__PURE__*/React__default["default"].createElement(united.Text, {
    as: "span",
    "data-ref": "tipDropzone1"
  }, messages.dragTheFile), /*#__PURE__*/React__default["default"].createElement(united.Text, {
    as: "span",
    variation: "alternate",
    "data-ref": "tipDropzone2"
  }, ' ', messages.clickToUpload)), /*#__PURE__*/React__default["default"].createElement(united.Box, {
    mb: 4
  }, /*#__PURE__*/React__default["default"].createElement(united.Text, {
    "data-ref": "tipDropzone3"
  }, messages.insertFileSize))))), showProgressUpload && /*#__PURE__*/React__default["default"].createElement(united.Box, {
    mt: 5
  }, /*#__PURE__*/React__default["default"].createElement(united.Flex, {
    justifyContent: "center",
    mb: 2
  }, /*#__PURE__*/React__default["default"].createElement(united.Text.Small, {
    color: "neutral.strong"
  }, file.name)), /*#__PURE__*/React__default["default"].createElement(united.ProgressBar, {
    current: bytesUploaded,
    total: bytesTotal
  })), showSuccessUpload && /*#__PURE__*/React__default["default"].createElement(Success, {
    p: 3,
    mt: 5,
    "data-ref": "success"
  }, /*#__PURE__*/React__default["default"].createElement(united.Flex, null, /*#__PURE__*/React__default["default"].createElement(united.Icon, {
    name: "success-outline",
    color: "success.base",
    size: 22
  }), /*#__PURE__*/React__default["default"].createElement(united.Text, {
    ml: 2,
    variation: "primary"
  }, file.name))), showErrorUpload && /*#__PURE__*/React__default["default"].createElement(united.Box, {
    mt: 5,
    "data-ref": "generic-error"
  }, /*#__PURE__*/React__default["default"].createElement(UploaderErrors, {
    errors: [messages.errorOnSendFile],
    showErrors: showErrorUpload
  })), hasFormatErrors && /*#__PURE__*/React__default["default"].createElement(united.Box, {
    mt: 5
  }, /*#__PURE__*/React__default["default"].createElement(UploaderErrors, {
    errors: rejectedErrors,
    showErrors: hasFormatErrors
  })));
};

Uploader.defaultProps = {
  customPayload: {
    fileName: 'filename'
  },
  forceReset: true,
  onUploaded: function onUploaded() {},
  messages: {}
};

var _templateObject$f, _templateObject2$a, _templateObject3$6, _templateObject4$2;
var Title$2 = styled__default["default"](united.Text).attrs({
  as: 'h2'
})(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n"])), themeGet.themeGet('olist.color.neutral.stronger'), themeGet.themeGet('olist.fontSize.2xlarge'), themeGet.themeGet('olist.fontWeight.bold'));
var SubTitle = styled__default["default"](united.Text).attrs({
  as: 'h5'
})(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n"])), themeGet.themeGet('olist.color.neutral.base'), themeGet.themeGet('olist.fontSize.1xsmall'), themeGet.themeGet('olist.fontWeight.regular'));
var SubHeader = styled__default["default"].div(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n  margin: ", " 0 ", ";\n  ", "\n"])), themeGet.themeGet('olist.spacing.stack.medium'), themeGet.themeGet('olist.spacing.stack.1xlarge'), styledSystem.space);
var Container$1 = styled__default["default"].div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  margin: 0 auto;\n  max-width: 1280px;\n  padding: 0 15px;\n  width: 100%;\n  ", "\n"])), styledSystem.space);
Title$2.defaultProps = {
  textTransform: 'lowercase'
};
Title$2.propTypes = {
  textTransform: T.string
};
SubTitle.defaultProps = {
  textTransform: 'lowercase'
};
SubTitle.propTypes = {
  textTransform: T.string
};

var img$5 = "data:image/svg+xml,%3csvg width='139' height='24' viewBox='0 0 139 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M89.2208 9.92018V17.2845C89.2208 17.7074 89.2208 18.0667 89.2542 18.5548C89.3512 20.2815 89.906 21.2926 91.5356 21.2926C92.1875 21.2926 92.8393 21.097 93.3608 20.8363L94.1748 23.2148C93.3608 23.6377 92.2193 23.9318 91.1445 23.9318C88.8631 23.9318 87.4624 22.9222 86.7772 21.3896C86.386 20.477 86.2557 19.2719 86.2557 18V9.92018H84.0728V7.3128H86.2557V3.40173H89.2208V7.3128H93.7822V9.92018H89.2208ZM80.6513 10.6053C79.9025 9.95348 78.5336 9.40018 77.4254 9.40018C75.9262 9.40018 74.9818 10.2794 74.9818 11.5513C74.9818 12.7883 76.5424 13.4067 78.1049 14.026L78.1106 14.0283C80.2284 14.8423 82.8676 16.049 82.8676 18.8838C82.8676 22.5341 80.0328 24 76.9692 24C74.7529 24 72.6351 23.1207 71.3648 21.4578L73.4507 19.7963C74.5255 20.9363 75.6988 21.523 77.0025 21.523C78.5988 21.523 79.9358 20.7089 79.9358 19.0141C79.9358 17.7566 78.4666 17.169 76.8561 16.5249L76.807 16.5053L76.7131 16.4683C74.5836 15.6301 72.147 14.6709 72.147 11.7802C72.147 8.48911 74.6892 6.92468 77.3936 6.92468C79.2506 6.92468 81.1091 7.54318 82.4113 8.7165L80.6513 10.6053ZM103.004 23.9985C107.762 23.9985 111.314 20.2178 111.314 15.4609C111.314 10.7024 107.762 6.92322 103.004 6.92322C98.2451 6.92322 94.6933 10.7024 94.6933 15.4609C94.6933 20.2193 98.2466 23.9985 103.004 23.9985ZM97.7267 15.4609C97.7267 12.3002 99.9414 9.66096 103.005 9.66096C106.069 9.66096 108.283 12.3002 108.283 15.4609C108.283 18.6216 106.069 21.2608 103.005 21.2608C99.9429 21.2608 97.7267 18.6216 97.7267 15.4609ZM121.285 6.92322C119.526 6.92322 118.061 8.25736 117.083 10.016V7.31432H114.118V23.6074H117.083V12.6913C118.093 10.9313 119.3 9.95354 120.961 9.95354C121.58 9.95354 122.004 10.0506 122.492 10.2795L123.045 7.11877C122.425 6.9884 121.969 6.92322 121.285 6.92322ZM126.044 16.2112C126.24 19.0135 128.162 21.4563 131.291 21.4563C133.442 21.4563 135.168 20.6741 136.146 18.8171L138.297 20.186C136.667 22.7934 134.453 23.9985 131.16 23.9985C125.979 23.9985 123.079 20.2193 123.079 15.4609C123.079 10.6054 126.631 6.92322 131.16 6.92322C135.462 6.92322 138.59 10.1491 138.59 14.5164C138.59 15.0698 138.524 15.7868 138.459 16.2112H126.044ZM135.526 13.8313H126.271C126.858 11.3876 128.553 9.46541 131.192 9.4639C133.636 9.4639 135.396 11.518 135.526 13.8313Z' fill='%230C29D0'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M27.4366 0H31.9025V3.81102H27.4366V0ZM19.6781 0.00305176H24.144V23.621H19.6781V0.00305176ZM0 15.5276C0 10.8495 3.79282 7.05664 8.47095 7.05664C13.1491 7.05664 16.9419 10.8495 16.9419 15.5276C16.9419 20.2057 13.1491 23.9985 8.47095 23.9985C3.79282 23.9985 0 20.2057 0 15.5276ZM4.31127 15.5261C4.31127 17.8242 6.17433 19.6857 8.47095 19.6857C10.7676 19.6857 12.6306 17.8242 12.6306 15.5261C12.6306 13.2279 10.7676 11.3664 8.47095 11.3664C6.17281 11.3664 4.31127 13.2279 4.31127 15.5261ZM41.6225 13.575C40.2385 13.0081 39.0121 12.473 39.0121 11.433C39.0121 10.6463 39.767 10.1733 40.616 10.1733C41.8742 10.1733 43.0369 10.8024 43.8873 11.5589L45.7367 8.22536C43.8676 7.10358 42.8186 6.67761 40.6175 6.67761C37.5978 6.67761 34.7054 8.37847 34.7054 11.7468C34.7054 14.6438 36.8747 15.7777 38.856 16.6281C39.0405 16.7098 39.2233 16.7887 39.4026 16.8661C40.813 17.4747 42.0015 17.9875 42.0015 19.0217C42.0015 20.0298 40.807 20.4709 39.8944 20.4709C38.2905 20.4709 37.2521 19.7463 35.9939 18.5184L34.2142 21.6806C36.0834 23.1753 37.5356 23.997 40.1142 23.997C43.3219 23.997 46.4674 22.3279 46.4674 18.6746C46.4659 15.5727 43.8371 14.4885 41.7149 13.6132L41.6225 13.575ZM27.4366 7.05664H31.9025V23.6211H27.4366V7.05664ZM57.7276 19.716C57.1622 19.9995 56.6271 20.189 55.9343 20.189C54.9914 20.189 54.6139 19.5902 54.4881 18.614C54.426 18.141 54.426 17.7014 54.426 17.1966V10.7721H58.6402V7.05662H54.426V3.40326H50.6513L49.9601 7.05662H47.9788V10.7721H49.9601V17.668C49.9601 18.6443 50.0237 19.6205 50.2739 20.4391C50.8711 22.5811 52.6008 23.997 55.1794 23.997C56.4694 23.997 58.0414 23.6498 59.1101 23.0207L57.7276 19.716Z' fill='%230C29D0'/%3e%3c/svg%3e";

var img$4 = "data:image/svg+xml,%3csvg width='139' height='24' viewBox='0 0 139 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M89.2208 9.92018V17.2845C89.2208 17.7074 89.2208 18.0667 89.2542 18.5548C89.3512 20.2815 89.906 21.2926 91.5356 21.2926C92.1875 21.2926 92.8393 21.097 93.3608 20.8363L94.1748 23.2148C93.3608 23.6377 92.2193 23.9318 91.1445 23.9318C88.8631 23.9318 87.4624 22.9222 86.7772 21.3896C86.386 20.477 86.2557 19.2719 86.2557 18V9.92018H84.0728V7.3128H86.2557V3.40173H89.2208V7.3128H93.7822V9.92018H89.2208ZM80.6513 10.6053C79.9025 9.95348 78.5336 9.40018 77.4254 9.40018C75.9262 9.40018 74.9818 10.2794 74.9818 11.5513C74.9818 12.7883 76.5424 13.4067 78.1049 14.026L78.1106 14.0283C80.2284 14.8423 82.8676 16.049 82.8676 18.8838C82.8676 22.5341 80.0328 24 76.9692 24C74.7529 24 72.6351 23.1207 71.3648 21.4578L73.4507 19.7963C74.5255 20.9363 75.6988 21.523 77.0025 21.523C78.5988 21.523 79.9358 20.7089 79.9358 19.0141C79.9358 17.7566 78.4666 17.169 76.8561 16.5249L76.807 16.5053L76.7131 16.4683C74.5836 15.6301 72.147 14.6709 72.147 11.7802C72.147 8.48911 74.6892 6.92468 77.3936 6.92468C79.2506 6.92468 81.1091 7.54318 82.4113 8.7165L80.6513 10.6053ZM103.004 23.9985C107.762 23.9985 111.314 20.2178 111.314 15.4609C111.314 10.7024 107.762 6.92322 103.004 6.92322C98.2451 6.92322 94.6933 10.7024 94.6933 15.4609C94.6933 20.2193 98.2466 23.9985 103.004 23.9985ZM97.7267 15.4609C97.7267 12.3002 99.9414 9.66096 103.005 9.66096C106.069 9.66096 108.283 12.3002 108.283 15.4609C108.283 18.6216 106.069 21.2608 103.005 21.2608C99.9429 21.2608 97.7267 18.6216 97.7267 15.4609ZM121.285 6.92322C119.526 6.92322 118.061 8.25736 117.083 10.016V7.31432H114.118V23.6074H117.083V12.6913C118.093 10.9313 119.3 9.95354 120.961 9.95354C121.58 9.95354 122.004 10.0506 122.492 10.2795L123.045 7.11877C122.425 6.9884 121.969 6.92322 121.285 6.92322ZM126.044 16.2112C126.24 19.0135 128.162 21.4563 131.291 21.4563C133.442 21.4563 135.168 20.6741 136.146 18.8171L138.297 20.186C136.667 22.7934 134.453 23.9985 131.16 23.9985C125.979 23.9985 123.079 20.2193 123.079 15.4609C123.079 10.6054 126.631 6.92322 131.16 6.92322C135.462 6.92322 138.59 10.1491 138.59 14.5164C138.59 15.0698 138.524 15.7868 138.459 16.2112H126.044ZM135.526 13.8313H126.271C126.858 11.3876 128.553 9.46541 131.192 9.4639C133.636 9.4639 135.396 11.518 135.526 13.8313Z' fill='white'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M27.4366 0H31.9025V3.81102H27.4366V0ZM19.6781 0.00305176H24.144V23.621H19.6781V0.00305176ZM0 15.5276C0 10.8495 3.79282 7.05664 8.47095 7.05664C13.1491 7.05664 16.9419 10.8495 16.9419 15.5276C16.9419 20.2057 13.1491 23.9985 8.47095 23.9985C3.79282 23.9985 0 20.2057 0 15.5276ZM4.31127 15.5261C4.31127 17.8242 6.17433 19.6857 8.47095 19.6857C10.7676 19.6857 12.6306 17.8242 12.6306 15.5261C12.6306 13.2279 10.7676 11.3664 8.47095 11.3664C6.17281 11.3664 4.31127 13.2279 4.31127 15.5261ZM41.6225 13.575C40.2385 13.0081 39.0121 12.473 39.0121 11.433C39.0121 10.6463 39.767 10.1733 40.616 10.1733C41.8742 10.1733 43.0369 10.8024 43.8873 11.5589L45.7367 8.22536C43.8676 7.10358 42.8186 6.67761 40.6175 6.67761C37.5978 6.67761 34.7054 8.37847 34.7054 11.7468C34.7054 14.6438 36.8747 15.7777 38.856 16.6281C39.0405 16.7098 39.2233 16.7887 39.4026 16.8661C40.813 17.4747 42.0015 17.9875 42.0015 19.0217C42.0015 20.0298 40.807 20.4709 39.8944 20.4709C38.2905 20.4709 37.2521 19.7463 35.9939 18.5184L34.2142 21.6806C36.0834 23.1753 37.5356 23.997 40.1142 23.997C43.3219 23.997 46.4674 22.3279 46.4674 18.6746C46.4659 15.5727 43.8371 14.4885 41.7149 13.6132L41.6225 13.575ZM27.4366 7.05664H31.9025V23.6211H27.4366V7.05664ZM57.7276 19.716C57.1622 19.9995 56.6271 20.189 55.9343 20.189C54.9914 20.189 54.6139 19.5902 54.4881 18.614C54.426 18.141 54.426 17.7014 54.426 17.1966V10.7721H58.6402V7.05662H54.426V3.40326H50.6513L49.9601 7.05662H47.9788V10.7721H49.9601V17.668C49.9601 18.6443 50.0237 19.6205 50.2739 20.4391C50.8711 22.5811 52.6008 23.997 55.1794 23.997C56.4694 23.997 58.0414 23.6498 59.1101 23.0207L57.7276 19.716Z' fill='white'/%3e%3c/svg%3e";

var _templateObject$e;
var LogoOlistStore = styled__default["default"].img.attrs(function (_ref) {
  var variation = _ref.variation;
  return {
    alt: 'olist store logo',
    src: variation === VARIATION_DEFAULT ? img$5 : img$4
  };
})(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral([""])));
LogoOlistStore.defaultProps = {
  variation: VARIATION_DEFAULT
};
LogoOlistStore.propTypes = {
  variation: T.oneOf([VARIATION_DEFAULT, VARIATION_INVERTER])
};

var _templateObject$d;
/* eslint-disable-next-line */

var Title$1 = styled__default["default"].p(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  padding: 6px ", ";\n"])), themeGet.themeGet('olist.fontWeight.bold'), themeGet.themeGet('olist.spacing.inline.1xlarge'));

var HeaderOnboarding = function HeaderOnboarding(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/React__default["default"].createElement(Container$1, null, /*#__PURE__*/React__default["default"].createElement(united.Flex, {
    py: 40
  }, /*#__PURE__*/React__default["default"].createElement(LogoOlistStore, {
    width: "120px",
    height: "65px"
  }), /*#__PURE__*/React__default["default"].createElement(Title$1, null, title)));
};

HeaderOnboarding.defaultProps = {
  title: ''
};

var useDeprecatedComponent = function useDeprecatedComponent() {
  var component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'design system';
  React.useEffect(function () {
    // eslint-disable-next-line
    console.warn("This Header will be deprecated shortly, please update to the new ".concat(component, " component."));
  }, []);
};

var useDeviceInfo = function useDeviceInfo() {
  var _useState = React.useState({
    width: undefined,
    height: undefined
  }),
      _useState2 = _slicedToArray(_useState, 2),
      windowSize = _useState2[0],
      setWindowSize = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isMobile = _useState4[0],
      setIsMobile = _useState4[1];

  var _useState5 = React.useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isDesktop = _useState6[0],
      setIsDesktop = _useState6[1];

  var handleResize = function handleResize() {
    setWindowSize({
      height: window.innerHeight,
      width: window.innerWidth
    });

    if (window.innerWidth < 768 && !isMobile) {
      setIsMobile(true);
      return setIsDesktop(false);
    }

    if (!isDesktop) {
      setIsDesktop(true);
      return setIsMobile(false);
    }

    return true;
  };

  React.useEffect(function () {
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  var deviceInfo = {
    isMobile: isMobile,
    isDesktop: isDesktop,
    windowSize: windowSize
  };
  return deviceInfo;
};

var img$3 = "data:image/svg+xml,%3csvg width='158' height='24' viewBox='0 0 158 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M21.2477 2H24.7062V4.95137H21.2477V2ZM15.2394 2.00236H18.6979V20.2928H15.2394V2.00236ZM0 14.025C0 10.4021 2.93728 7.46485 6.56016 7.46485C10.183 7.46485 13.1203 10.4021 13.1203 14.025C13.1203 17.6479 10.183 20.5852 6.56016 20.5852C2.93728 20.5852 0 17.6479 0 14.025ZM3.33878 14.0238C3.33878 15.8036 4.78159 17.2452 6.56016 17.2452C8.33873 17.2452 9.78154 15.8036 9.78154 14.0238C9.78154 12.2441 8.33873 10.8025 6.56016 10.8025C4.78042 10.8025 3.33878 12.2441 3.33878 14.0238ZM32.2337 12.5129C31.1619 12.0739 30.2122 11.6594 30.2122 10.8541C30.2122 10.2448 30.7968 9.87852 31.4542 9.87852C32.4286 9.87852 33.3291 10.3657 33.9877 10.9515L35.4199 8.36997C33.9724 7.50123 33.16 7.17134 31.4554 7.17134C29.1168 7.17134 26.8769 8.48854 26.8769 11.0971C26.8769 13.3406 28.5569 14.2187 30.0912 14.8773C30.2341 14.9406 30.3757 15.0017 30.5145 15.0616L30.5146 15.0616C31.6068 15.5329 32.5272 15.93 32.5272 16.731C32.5272 17.5117 31.6021 17.8533 30.8954 17.8533C29.6533 17.8533 28.8492 17.2922 27.8748 16.3412L26.4965 18.7901C27.944 19.9477 29.0687 20.584 31.0656 20.584C33.5498 20.584 35.9858 19.2914 35.9858 16.4622C35.9846 14.06 33.9488 13.2203 32.3053 12.5424L32.2337 12.5129ZM21.2477 7.46485H24.7062V20.2928H21.2477V7.46485ZM44.706 17.2687C44.2681 17.4882 43.8537 17.635 43.3172 17.635C42.587 17.635 42.2947 17.1713 42.1972 16.4152C42.1491 16.0489 42.1491 15.7085 42.1491 15.3176V10.3423H45.4128V7.46485H42.1491V4.63558H39.2259L38.6906 7.46485H37.1562V10.3423H38.6906V15.6827C38.6906 16.4387 38.7399 17.1947 38.9336 17.8287C39.3961 19.4875 40.7356 20.584 42.7326 20.584C43.7316 20.584 44.949 20.3152 45.7767 19.828L44.706 17.2687Z' fill='%230C29D0'/%3e%3cpath d='M61.1014 4.4832C60.4578 4.21964 59.6367 4 58.9044 4C57.4176 4 56.5077 4.4832 55.9529 5.29587C55.4647 6.02067 55.2649 7.03101 55.2649 8.17313V9.75452H54V11.5116H55.2649V20.7364H57.2844V11.5116H60.2803V9.75452H57.2844V8.3708C57.2844 7.38243 57.351 6.6137 57.8614 6.19638C58.1499 5.97674 58.5493 5.84496 59.1485 5.84496C59.6811 5.84496 60.1028 5.95478 60.5244 6.15245L61.1014 4.4832Z' fill='%230C29D0'/%3e%3cpath d='M70.0207 20.7364H72.0401V9.75452H70.0207V17.0465C69.2217 18.2765 68.0012 19.155 66.7141 19.155C65.7376 19.155 65.1384 18.8036 64.7834 18.2765C64.2508 17.4858 64.2064 16.3217 64.2064 15.2455V9.75452H62.1869V15.4651C62.1869 17.1344 62.431 18.6059 63.1855 19.6163C63.8291 20.4729 64.8499 21 66.4034 21C67.8902 21 69.1996 20.2313 70.0207 18.9354V20.7364Z' fill='%230C29D0'/%3e%3cpath d='M77.7977 4.26356H75.7782V20.7364H77.7977V4.26356Z' fill='%230C29D0'/%3e%3cpath d='M86.9583 11.5116V9.75452H83.9624V8.3708C83.9624 7.38243 84.029 6.6137 84.5394 6.19638C84.8279 5.97674 85.2273 5.84496 85.8265 5.84496C86.226 5.84496 86.581 5.91085 86.9139 6.02067L87.2246 4.28553C86.692 4.10982 86.115 4 85.5824 4C84.0955 4 83.1857 4.4832 82.6309 5.29587C82.1426 6.02067 81.9429 7.03101 81.9429 8.17313V9.75452H80.678V11.5116H81.9429V20.7364H83.9624V11.5116H86.9583ZM91.0194 20.7364V9.75452H88.9999V20.7364H91.0194ZM91.0194 7.60207V5.36176H88.9999V7.60207H91.0194Z' fill='%230C29D0'/%3e%3cpath d='M96.7605 4.26356H94.7411V20.7364H96.7605V4.26356Z' fill='%230C29D0'/%3e%3cpath d='M102.504 4.26356H100.484V20.7364H102.504V4.26356Z' fill='%230C29D0'/%3e%3cpath d='M123.026 20.7364V15.0258C123.026 13.3346 122.782 11.7972 122.006 10.7868C121.384 9.97416 120.43 9.49096 118.943 9.49096C117.434 9.49096 116.036 10.1718 115.082 11.5116C115.015 11.3579 114.926 11.1602 114.815 11.0065C114.127 9.9522 113.018 9.49096 111.731 9.49096C110.444 9.49096 109.068 10.2597 108.247 11.4238V9.75452H106.227V20.7364H108.247V13.3566C108.979 12.3463 110.177 11.3359 111.309 11.3359C112.152 11.3359 112.685 11.6434 113.018 12.1047C113.595 12.9173 113.617 14.1912 113.617 15.2455V20.7364H115.636V15.0258C115.636 14.3669 115.592 13.708 115.503 13.1589C116.324 12.0827 117.501 11.3359 118.566 11.3359C119.52 11.3359 120.119 11.6873 120.474 12.2145C120.985 13.0052 121.007 14.1912 121.007 15.2455V20.7364H123.026Z' fill='%230C29D0'/%3e%3cpath d='M136.163 15.7506C136.207 15.4651 136.252 14.9819 136.252 14.6085C136.252 11.6654 134.121 9.49096 131.192 9.49096C128.107 9.49096 125.688 11.9729 125.688 15.2455C125.688 18.4522 127.663 21 131.192 21C133.433 21 134.942 20.1873 136.052 18.4302L134.587 17.5078C133.921 18.7597 132.745 19.2868 131.281 19.2868C129.15 19.2868 127.841 17.6395 127.708 15.7506H136.163ZM131.214 11.2041C132.878 11.2041 134.077 12.5879 134.166 14.1473H127.863C128.262 12.5 129.416 11.2041 131.214 11.2041Z' fill='%230C29D0'/%3e%3cpath d='M139.038 9.75452V20.7364H141.058V13.4444C141.857 12.2145 143.077 11.3359 144.364 11.3359C145.341 11.3359 145.94 11.6873 146.295 12.2145C146.828 13.0052 146.872 14.1693 146.872 15.2455V20.7364H148.891V15.0258C148.891 13.3566 148.647 11.885 147.893 10.8747C147.249 10.0181 146.228 9.49096 144.675 9.49096C143.188 9.49096 141.879 10.2597 141.058 11.5556V9.75452H139.038Z' fill='%230C29D0'/%3e%3cpath d='M157.734 11.5116V9.75452H154.627V7.11886H152.607V9.75452H151.12V11.5116H152.607V16.9587C152.607 17.8152 152.696 18.6279 152.962 19.2429C153.428 20.2752 154.383 20.9561 155.936 20.9561C156.668 20.9561 157.445 20.7584 158 20.4729L157.445 18.8695C157.09 19.0452 156.646 19.177 156.202 19.177C155.093 19.177 154.716 18.4961 154.649 17.332C154.627 17.0026 154.627 16.761 154.627 16.4755V11.5116H157.734Z' fill='%230C29D0'/%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3csvg width='158' height='24' viewBox='0 0 158 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M61.1014 4.4832C60.4578 4.21964 59.6367 4 58.9044 4C57.4176 4 56.5077 4.4832 55.9529 5.29587C55.4647 6.02067 55.2649 7.03101 55.2649 8.17313V9.75452H54V11.5116H55.2649V20.7364H57.2844V11.5116H60.2803V9.75452H57.2844V8.3708C57.2844 7.38243 57.351 6.6137 57.8614 6.19638C58.1499 5.97674 58.5493 5.84496 59.1485 5.84496C59.6811 5.84496 60.1028 5.95478 60.5244 6.15245L61.1014 4.4832Z' fill='white'/%3e%3cpath d='M70.0207 20.7364H72.0401V9.75452H70.0207V17.0465C69.2217 18.2765 68.0012 19.155 66.7141 19.155C65.7376 19.155 65.1384 18.8036 64.7834 18.2765C64.2508 17.4858 64.2064 16.3217 64.2064 15.2455V9.75452H62.1869V15.4651C62.1869 17.1344 62.431 18.6059 63.1855 19.6163C63.8291 20.4729 64.8499 21 66.4034 21C67.8902 21 69.1996 20.2313 70.0207 18.9354V20.7364Z' fill='white'/%3e%3cpath d='M77.7977 4.26356H75.7782V20.7364H77.7977V4.26356Z' fill='white'/%3e%3cpath d='M86.9583 11.5116V9.75452H83.9624V8.3708C83.9624 7.38243 84.029 6.6137 84.5394 6.19638C84.8279 5.97674 85.2273 5.84496 85.8265 5.84496C86.226 5.84496 86.581 5.91085 86.9139 6.02067L87.2246 4.28553C86.692 4.10982 86.115 4 85.5824 4C84.0955 4 83.1857 4.4832 82.6309 5.29587C82.1426 6.02067 81.9429 7.03101 81.9429 8.17313V9.75452H80.678V11.5116H81.9429V20.7364H83.9624V11.5116H86.9583ZM91.0194 20.7364V9.75452H88.9999V20.7364H91.0194ZM91.0194 7.60207V5.36176H88.9999V7.60207H91.0194Z' fill='white'/%3e%3cpath d='M96.7605 4.26356H94.7411V20.7364H96.7605V4.26356Z' fill='white'/%3e%3cpath d='M102.504 4.26356H100.484V20.7364H102.504V4.26356Z' fill='white'/%3e%3cpath d='M123.026 20.7364V15.0258C123.026 13.3346 122.782 11.7972 122.006 10.7868C121.384 9.97416 120.43 9.49096 118.943 9.49096C117.434 9.49096 116.036 10.1718 115.082 11.5116C115.015 11.3579 114.926 11.1602 114.815 11.0065C114.127 9.9522 113.018 9.49096 111.731 9.49096C110.444 9.49096 109.068 10.2597 108.247 11.4238V9.75452H106.227V20.7364H108.247V13.3566C108.979 12.3463 110.177 11.3359 111.309 11.3359C112.152 11.3359 112.685 11.6434 113.018 12.1047C113.595 12.9173 113.617 14.1912 113.617 15.2455V20.7364H115.636V15.0258C115.636 14.3669 115.592 13.708 115.503 13.1589C116.324 12.0827 117.501 11.3359 118.566 11.3359C119.52 11.3359 120.119 11.6873 120.474 12.2145C120.985 13.0052 121.007 14.1912 121.007 15.2455V20.7364H123.026Z' fill='white'/%3e%3cpath d='M136.163 15.7506C136.207 15.4651 136.252 14.9819 136.252 14.6085C136.252 11.6654 134.121 9.49096 131.192 9.49096C128.107 9.49096 125.688 11.9729 125.688 15.2455C125.688 18.4522 127.663 21 131.192 21C133.433 21 134.942 20.1873 136.052 18.4302L134.587 17.5078C133.921 18.7597 132.745 19.2868 131.281 19.2868C129.15 19.2868 127.841 17.6395 127.708 15.7506H136.163ZM131.214 11.2041C132.878 11.2041 134.077 12.5879 134.166 14.1473H127.863C128.262 12.5 129.416 11.2041 131.214 11.2041Z' fill='white'/%3e%3cpath d='M139.038 9.75452V20.7364H141.058V13.4444C141.857 12.2145 143.077 11.3359 144.364 11.3359C145.341 11.3359 145.94 11.6873 146.295 12.2145C146.828 13.0052 146.872 14.1693 146.872 15.2455V20.7364H148.891V15.0258C148.891 13.3566 148.647 11.885 147.893 10.8747C147.249 10.0181 146.228 9.49096 144.675 9.49096C143.188 9.49096 141.879 10.2597 141.058 11.5556V9.75452H139.038Z' fill='white'/%3e%3cpath d='M157.734 11.5116V9.75452H154.627V7.11886H152.607V9.75452H151.12V11.5116H152.607V16.9587C152.607 17.8152 152.696 18.6279 152.962 19.2429C153.428 20.2752 154.383 20.9561 155.936 20.9561C156.668 20.9561 157.445 20.7584 158 20.4729L157.445 18.8695C157.09 19.0452 156.646 19.177 156.202 19.177C155.093 19.177 154.716 18.4961 154.649 17.332C154.627 17.0026 154.627 16.761 154.627 16.4755V11.5116H157.734Z' fill='white'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M21.2477 2H24.7062V4.95137H21.2477V2ZM15.2394 2.00236H18.6979V20.2928H15.2394V2.00236ZM0 14.025C0 10.4021 2.93728 7.46485 6.56016 7.46485C10.183 7.46485 13.1203 10.4021 13.1203 14.025C13.1203 17.6479 10.183 20.5852 6.56016 20.5852C2.93728 20.5852 0 17.6479 0 14.025ZM3.33878 14.0238C3.33878 15.8036 4.78159 17.2452 6.56016 17.2452C8.33873 17.2452 9.78154 15.8036 9.78154 14.0238C9.78154 12.2441 8.33873 10.8025 6.56016 10.8025C4.78042 10.8025 3.33878 12.2441 3.33878 14.0238ZM32.2337 12.5129C31.1619 12.0739 30.2122 11.6594 30.2122 10.8541C30.2122 10.2448 30.7968 9.87852 31.4542 9.87852C32.4286 9.87852 33.3291 10.3657 33.9877 10.9515L35.4199 8.36997C33.9724 7.50123 33.16 7.17134 31.4554 7.17134C29.1168 7.17134 26.8769 8.48854 26.8769 11.0971C26.8769 13.3406 28.5569 14.2187 30.0912 14.8773C30.2341 14.9406 30.3757 15.0017 30.5145 15.0616L30.5146 15.0616C31.6068 15.5329 32.5272 15.93 32.5272 16.731C32.5272 17.5117 31.6021 17.8533 30.8954 17.8533C29.6533 17.8533 28.8492 17.2922 27.8748 16.3412L26.4965 18.7901C27.944 19.9477 29.0687 20.584 31.0656 20.584C33.5498 20.584 35.9858 19.2914 35.9858 16.4622C35.9846 14.06 33.9488 13.2203 32.3053 12.5424L32.2337 12.5129ZM21.2477 7.46485H24.7062V20.2928H21.2477V7.46485ZM44.706 17.2687C44.2681 17.4882 43.8537 17.635 43.3172 17.635C42.587 17.635 42.2947 17.1713 42.1972 16.4152C42.1491 16.0489 42.1491 15.7085 42.1491 15.3176V10.3423H45.4128V7.46485H42.1491V4.63558H39.2259L38.6906 7.46485H37.1562V10.3423H38.6906V15.6827C38.6906 16.4387 38.7399 17.1947 38.9336 17.8287C39.3961 19.4875 40.7356 20.584 42.7326 20.584C43.7316 20.584 44.949 20.3152 45.7767 19.828L44.706 17.2687Z' fill='white'/%3e%3c/svg%3e";

var _templateObject$c;
var LogoOlistFbo = styled__default["default"].img.attrs(function (_ref) {
  var variation = _ref.variation;
  return {
    alt: 'olist fulfillment logo',
    src: variation === VARIATION_DEFAULT ? img$3 : img$2
  };
})(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral([""])));
LogoOlistFbo.defaultProps = {
  variation: VARIATION_DEFAULT
};
LogoOlistFbo.propTypes = {
  variation: T.oneOf([VARIATION_DEFAULT, VARIATION_INVERTER])
};

var permissionsTypes = T.arrayOf(T.shape({
  active: T.bool,
  permission: T.string
}));
var headerDefaultProps = {
  isSticky: false,
  translate: function translate(a) {
    return a;
  },
  urls: {
    dashboard: '.',
    orders: '.',
    collections: '.',
    myProducts: '.',
    stockPrice: '.',
    promotions: '.',
    individualRegistration: '.',
    massRegistration: '.',
    registrationViaIntegrations: '.',
    questions: '.',
    financial: '.',
    help: '.',
    settings: '.',
    integrations: '.',
    referral: '.',
    termsOfUse: '.',
    privacyPolicy: '.',
    helpCenter: '.',
    logout: '.'
  },
  userName: '',
  permissions: [],
  userId: '',
  workspaces: []
};
T.shape({
  isSticky: T.bool,
  translate: T.func,
  urls: T.shape({
    dashboard: T.string,
    orders: T.string,
    collections: T.string,
    myProducts: T.string,
    stockPrice: T.string,
    promotions: T.string,
    individualRegistration: T.string,
    massRegistration: T.string,
    registrationViaIntegrations: T.string,
    questions: T.string,
    financial: T.string,
    olistTurbo: T.string,
    help: T.string,
    settings: T.string,
    integrations: T.string,
    referral: T.string,
    termsOfUse: T.string,
    privacyPolicy: T.string,
    helpCenter: T.string,
    logout: T.string
  }),
  userName: T.string,
  featuresTags: T.arrayOf(T.string).isRequired,
  permissions: permissionsTypes,
  userId: T.string,
  workspaces: T.arrayOf(T.shape({
    permissions: permissionsTypes
  }))
});

var _templateObject$b, _templateObject2$9, _templateObject3$5, _templateObject4$1, _templateObject5$1, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
var H3 = united.Text.H3;
var HeaderButtonTextWrapper = styled__default["default"].div(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n"])));
var MenuButton = styled__default["default"](united.Button)(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n  border: none;\n  margin-top: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n"])), function (_ref) {
  var mt = _ref.mt;
  return mt && mt;
}, function (_ref2) {
  var mb = _ref2.mb;
  return mb && mb;
}, function (_ref3) {
  var ml = _ref3.ml;
  return ml && ml;
}, function (_ref4) {
  var mr = _ref4.mr;
  return mr && mr;
});
var MenuHeader = styled__default["default"].div(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 20% 60% 20%;\n  padding: ", ";\n"])), themeGet.themeGet('olist.spacing.inset.1xsmall'));
var MenuHeaderTitle = styled__default["default"](united.Text)(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  text-align: center;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var MenuBody = styled__default["default"](united.Box)(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  padding: ", ";\n  margin-bottom: 30px;\n"])), themeGet.themeGet('olist.spacing.inset.small'));
var SellerName = styled__default["default"](H3)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n"])), themeGet.themeGet('olist.fontWeight.bold'));
var MenuDrawer = styled__default["default"](united.Drawer)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  z-index: 10;\n  height: 100vh;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  top: 0;\n  margin-top: -", ";\n"])), themeGet.themeGet('olist.spacing.stack.1xsmall'));
var MenuLink = styled__default["default"](united.Link).attrs({
  rel: 'noopener noreferrer'
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  padding: ", " 0px;\n  font-size: ", ";\n  height: auto;\n  border: none;\n  border-radius: 0px;\n  line-height: 22.5px;\n  ", ";\n"])), themeGet.themeGet('olist.spacing.inset.small'), themeGet.themeGet('olist.fontSize.1xsmall'), function (_ref5) {
  var borderColor = _ref5.borderColor;
  return borderColor && styled.css(["border-bottom:1px solid ", ";padding-bottom:24px;padding-top:9.5px;margin-bottom:8px;"], themeGet.themeGet(borderColor));
});
var MenuCollapseButton = styled__default["default"](united.Button)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  border: none;\n  display: flex;\n  justify-content: space-between;\n  padding: 0;\n  font-weight: 300;\n  border-radius: 0px;\n  font-size: ", ";\n  line-height: ", ";\n  :focus {\n    box-shadow: none;\n  }\n  :hover:not([disabled]) {\n    box-shadow: none;\n  }\n"])), themeGet.themeGet('olist.fontSize.1xsmall'), themeGet.themeGet('olist.lineHeight.2xsmall'));
var MobileHeaderContainer = styled__default["default"](united.Navbar)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: ", ";\n  top: ", ";\n  background-color: ", ";\n"])), function (_ref6) {
  var isSticky = _ref6.isSticky;
  return isSticky && 'sticky';
}, function (_ref7) {
  var isSticky = _ref7.isSticky;
  return isSticky && 0;
}, function (_ref8) {
  var isSticky = _ref8.isSticky;
  return isSticky && themeGet.themeGet('olist.color.neutral.softest');
});
var DesktopHeaderContainer = styled__default["default"](united.Flex)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: ", ";\n  top: ", ";\n  background-color: ", ";\n  max-width: 1280px;\n  margin: auto;\n  padding: 17px ", ";\n  z-index: 2;\n"])), function (_ref9) {
  var isSticky = _ref9.isSticky;
  return isSticky && 'sticky';
}, function (_ref10) {
  var isSticky = _ref10.isSticky;
  return isSticky && 0;
}, function (_ref11) {
  var isSticky = _ref11.isSticky;
  return isSticky && themeGet.themeGet('olist.color.neutral.softest');
}, themeGet.themeGet('olist.spacing.inset.small'));
var HeaderButtonText = styled__default["default"](united.Text)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref12) {
  var isActive = _ref12.isActive;
  return isActive ? themeGet.themeGet('olist.color.primary.base') : themeGet.themeGet('olist.color.neutral.stronger');
});

function OrdersWithSubMenu(_ref) {
  var translate = _ref.translate,
      hasCollections = _ref.hasCollections,
      urls = _ref.urls;
  var isCollectionMenuActive = window.location.href.includes(urls.collections);
  var isOrderMenuActive = window.location.href.includes(urls.orders);
  var isQuestionsMenuActive = window.location.href.includes(urls.questions);
  return /*#__PURE__*/React__default["default"].createElement(united.NavDropdown, null, /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Toggle, {
    isActive: isCollectionMenuActive || isOrderMenuActive
  }, translate('orders')), /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Menu, null, /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Item, {
    href: urls.questions,
    isActive: isQuestionsMenuActive,
    onClick: function onClick() {
      return window.mixpanel && window.mixpanel.track('Header Menu - Clicked on Pre-sale Questions');
    }
  }, translate('pre-sale questions')), /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Item, {
    href: urls.orders,
    isActive: isOrderMenuActive
  }, translate('my orders')), hasCollections && /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Item, {
    href: urls.collections,
    isActive: isCollectionMenuActive,
    onClick: function onClick() {
      return window.mixpanel && window.mixpanel.track('Header Menu - Clicked on Collections List');
    }
  }, translate('collection receipts'))));
}
OrdersWithSubMenu.defaultProps = {
  hasCollections: false,
  translate: headerDefaultProps.translate,
  urls: headerDefaultProps.urls
};

var $$3 = _export;
var aFunction = aFunction$6;
var toObject = toObject$c;
var fails$1 = fails$r;
var arrayMethodIsStrict$1 = arrayMethodIsStrict$7;

var test = [];
var nativeSort = test.sort;

// IE8-
var FAILS_ON_UNDEFINED = fails$1(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails$1(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD$1 = arrayMethodIsStrict$1('sort');

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD$1;

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$$3({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? nativeSort.call(toObject(this))
      : nativeSort.call(toObject(this), aFunction(comparefn));
  }
});

var AnimatedImage = function AnimatedImage(_ref) {
  var ariaLabel = _ref.ariaLabel,
      goTo = _ref.goTo,
      loop = _ref.loop,
      play = _ref.play,
      role = _ref.role,
      src = _ref.src,
      style = _ref.style,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["ariaLabel", "goTo", "loop", "play", "role", "src", "style", "title"]);

  return /*#__PURE__*/React__default["default"].createElement(united.Box, rest, /*#__PURE__*/React__default["default"].createElement(Lottie__default["default"], {
    animationData: src,
    "aria-label": ariaLabel,
    goTo: goTo,
    loop: loop,
    play: play,
    role: role,
    style: style,
    title: title
  }));
};

AnimatedImage.defaultProps = {
  play: true,
  loop: true,
  style: {},
  role: 'presentation',
  ariaLabel: 'animation',
  title: null,
  goTo: null
};

var img$1 = "data:image/svg+xml,%3csvg width='80' height='32' viewBox='0 0 80 32' aria-labelledby='olist-logo' xmlns='http://www.w3.org/2000/svg' fill='%230C29D0'%3e %3ctitle id='olist-logo'%3elogo olist%3c/title%3e %3cpath d='M 11.547 8.90289C 4.81126 8.90289 0 13.9423 0 20.4514C 0 26.9606 4.81126 32 11.547 32C 18.241 32 23.0522 26.9606 23.0522 20.4514C 23.0522 13.9423 18.241 8.90289 11.547 8.90289ZM 16.9859 20.4514C 16.9859 24.063 14.8103 26.8766 11.547 26.8766C 8.28374 26.8766 6.06638 24.063 6.06638 20.4514C 6.06638 16.8399 8.28374 14.0262 11.547 14.0262C 14.8103 14.0262 16.9859 16.8399 16.9859 20.4514Z' /%3e %3cpath d='M 32.4316 0L 26.4907 0L 26.4907 31.4961L 32.4316 31.4961L 32.4316 0Z' /%3e %3cpath d='M 43.3207 31.4961L 43.3207 9.40682L 37.3798 9.40682L 37.3798 31.4961L 43.3207 31.4961ZM 43.3207 6.34121L 43.3207 1.25984L 37.3798 1.25984L 37.3798 6.34121L 43.3207 6.34121Z'/%3e %3cpath d='M 63.4976 11.8005C 61.4475 9.86877 58.8118 8.90289 55.8832 8.90289C 51.8669 8.90289 48.0178 11.1706 48.0178 15.664C 48.0178 19.5276 50.9046 21.0394 53.5403 22.1732C 55.7159 23.1391 57.724 23.811 57.724 25.3648C 57.724 26.7087 56.1342 27.2966 54.921 27.2966C 52.7873 27.2966 51.4066 26.3307 49.7332 24.6929L 46.3444 28.2205C 48.7709 30.6562 51.7832 32 55.2138 32C 59.4812 32 63.6649 29.7743 63.6649 24.9029C 63.6649 20.7034 60.0669 19.2756 57.222 18.0997C 55.3812 17.3438 53.7495 16.6299 53.7495 15.2441C 53.7495 14.1942 54.7536 13.5643 55.8832 13.5643C 57.5567 13.5643 59.1047 14.4042 60.2343 15.4121L 63.4976 11.8005Z' /%3e %3cpath d='M 79.3724 14.3622L 79.3724 9.40682L 73.7663 9.40682L 73.7663 4.53543L 68.7458 4.53543L 67.8254 9.40682L 65.1897 9.40682L 65.1897 14.3622L 67.8254 14.3622L 67.8254 23.5591C 67.8254 24.8609 67.9091 26.1627 68.2438 27.2546C 69.0387 30.1102 71.3397 32 74.7704 32C 76.4857 32 78.5775 31.5381 80 30.6982L 78.1592 26.2887C 77.4061 26.6667 76.6949 26.9186 75.7745 26.9186C 74.5193 26.9186 74.0173 26.1207 73.8499 24.8189C 73.7663 24.189 73.7663 23.601 73.7663 22.9291L 73.7663 14.3622L 79.3724 14.3622Z' /%3e%3c/svg%3e";

var img = "data:image/svg+xml,%3csvg width='80' height='32' viewBox='0 0 80 32' aria-labelledby='olist-logo' xmlns='http://www.w3.org/2000/svg' fill='white'%3e %3ctitle id='olist-logo'%3elogo olist%3c/title%3e %3cpath d='M 11.547 8.90289C 4.81126 8.90289 0 13.9423 0 20.4514C 0 26.9606 4.81126 32 11.547 32C 18.241 32 23.0522 26.9606 23.0522 20.4514C 23.0522 13.9423 18.241 8.90289 11.547 8.90289ZM 16.9859 20.4514C 16.9859 24.063 14.8103 26.8766 11.547 26.8766C 8.28374 26.8766 6.06638 24.063 6.06638 20.4514C 6.06638 16.8399 8.28374 14.0262 11.547 14.0262C 14.8103 14.0262 16.9859 16.8399 16.9859 20.4514Z' /%3e %3cpath d='M 32.4316 0L 26.4907 0L 26.4907 31.4961L 32.4316 31.4961L 32.4316 0Z' /%3e %3cpath d='M 43.3207 31.4961L 43.3207 9.40682L 37.3798 9.40682L 37.3798 31.4961L 43.3207 31.4961ZM 43.3207 6.34121L 43.3207 1.25984L 37.3798 1.25984L 37.3798 6.34121L 43.3207 6.34121Z'/%3e %3cpath d='M 63.4976 11.8005C 61.4475 9.86877 58.8118 8.90289 55.8832 8.90289C 51.8669 8.90289 48.0178 11.1706 48.0178 15.664C 48.0178 19.5276 50.9046 21.0394 53.5403 22.1732C 55.7159 23.1391 57.724 23.811 57.724 25.3648C 57.724 26.7087 56.1342 27.2966 54.921 27.2966C 52.7873 27.2966 51.4066 26.3307 49.7332 24.6929L 46.3444 28.2205C 48.7709 30.6562 51.7832 32 55.2138 32C 59.4812 32 63.6649 29.7743 63.6649 24.9029C 63.6649 20.7034 60.0669 19.2756 57.222 18.0997C 55.3812 17.3438 53.7495 16.6299 53.7495 15.2441C 53.7495 14.1942 54.7536 13.5643 55.8832 13.5643C 57.5567 13.5643 59.1047 14.4042 60.2343 15.4121L 63.4976 11.8005Z' /%3e %3cpath d='M 79.3724 14.3622L 79.3724 9.40682L 73.7663 9.40682L 73.7663 4.53543L 68.7458 4.53543L 67.8254 9.40682L 65.1897 9.40682L 65.1897 14.3622L 67.8254 14.3622L 67.8254 23.5591C 67.8254 24.8609 67.9091 26.1627 68.2438 27.2546C 69.0387 30.1102 71.3397 32 74.7704 32C 76.4857 32 78.5775 31.5381 80 30.6982L 78.1592 26.2887C 77.4061 26.6667 76.6949 26.9186 75.7745 26.9186C 74.5193 26.9186 74.0173 26.1207 73.8499 24.8189C 73.7663 24.189 73.7663 23.601 73.7663 22.9291L 73.7663 14.3622L 79.3724 14.3622Z' /%3e%3c/svg%3e";

var v = "5.7.4";
var fr = 25;
var ip = 0;
var op = 63;
var w = 414;
var h = 414;
var nm = "loading";
var ddd = 0;
var assets = [
	{
		id: "comp_0",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Camada 1 contornos 3",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.517
									],
									y: [
										1.008
									]
								},
								o: {
									x: [
										0.447
									],
									y: [
										0.002
									]
								},
								t: 22,
								s: [
									0
								]
							},
							{
								t: 58,
								s: [
									163
								]
							}
						],
						ix: 10
					},
					p: {
						a: 0,
						k: [
							206.845,
							206.846,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							206.845,
							206.846,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0.085,
												12.402
											],
											[
												-54.403,
												44.367
											],
											[
												-14.018,
												0.134
											],
											[
												-43.947,
												-43.738
											],
											[
												0.084,
												-10.073
											],
											[
												36.384,
												-40.84
											],
											[
												10.016,
												-0.118
											],
											[
												44.525,
												49.595
											]
										],
										o: [
											[
												0.199,
												-9.854
											],
											[
												39.464,
												-32.183
											],
											[
												10.485,
												0.023
											],
											[
												45.023,
												44.809
											],
											[
												-0.234,
												12.841
											],
											[
												-44.482,
												49.929
											],
											[
												-9.955,
												-0.098
											],
											[
												-37.571,
												-41.846
											]
										],
										v: [
											[
												-154.186,
												-0.001
											],
											[
												-97.171,
												-119.605
											],
											[
												-0.042,
												-154.145
											],
											[
												108.644,
												-109.203
											],
											[
												154.101,
												1.627
											],
											[
												115.084,
												102.384
											],
											[
												-0.042,
												154.145
											],
											[
												-114.751,
												102.857
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Caminho 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.047058823529,
										0.160784313725,
										0.81568627451,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 95,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Traçado 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										206.888,
										206.846
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transformar"
							}
						],
						nm: "Grupo 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.436
										],
										y: [
											1.057
										]
									},
									o: {
										x: [
											0.49
										],
										y: [
											-0.006
										]
									},
									t: 22,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.533
										],
										y: [
											7.363
										]
									},
									o: {
										x: [
											0.375
										],
										y: [
											5.41
										]
									},
									t: 58,
									s: [
										100
									]
								},
								{
									t: 59,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Aparar caminhos 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 22,
				op: 272,
				st: 22,
				bm: 0
			},
			{
				ddd: 0,
				ind: 2,
				ty: 4,
				nm: "Camada 1 contornos 2",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.517
									],
									y: [
										1.008
									]
								},
								o: {
									x: [
										0.447
									],
									y: [
										0.002
									]
								},
								t: 16,
								s: [
									0
								]
							},
							{
								t: 52,
								s: [
									163
								]
							}
						],
						ix: 10
					},
					p: {
						a: 0,
						k: [
							206.845,
							206.846,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							206.845,
							206.846,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0.085,
												12.402
											],
											[
												-54.403,
												44.367
											],
											[
												-14.018,
												0.134
											],
											[
												-43.947,
												-43.738
											],
											[
												0.084,
												-10.073
											],
											[
												36.384,
												-40.84
											],
											[
												10.016,
												-0.118
											],
											[
												44.525,
												49.595
											]
										],
										o: [
											[
												0.199,
												-9.854
											],
											[
												39.464,
												-32.183
											],
											[
												10.485,
												0.023
											],
											[
												45.023,
												44.809
											],
											[
												-0.234,
												12.841
											],
											[
												-44.482,
												49.929
											],
											[
												-9.955,
												-0.098
											],
											[
												-37.571,
												-41.846
											]
										],
										v: [
											[
												-154.186,
												-0.001
											],
											[
												-97.171,
												-119.605
											],
											[
												-0.042,
												-154.145
											],
											[
												108.644,
												-109.203
											],
											[
												154.101,
												1.627
											],
											[
												115.084,
												102.384
											],
											[
												-0.042,
												154.145
											],
											[
												-114.751,
												102.857
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Caminho 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.058823529412,
										0.886274509804,
										0.623529411765,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 93,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Traçado 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										206.888,
										206.846
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transformar"
							}
						],
						nm: "Grupo 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.436
										],
										y: [
											1.057
										]
									},
									o: {
										x: [
											0.49
										],
										y: [
											-0.006
										]
									},
									t: 16,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.533
										],
										y: [
											7.363
										]
									},
									o: {
										x: [
											0.375
										],
										y: [
											5.41
										]
									},
									t: 52,
									s: [
										100
									]
								},
								{
									t: 53,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Aparar caminhos 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 16,
				op: 58,
				st: 16,
				bm: 0
			},
			{
				ddd: 0,
				ind: 3,
				ty: 4,
				nm: "Camada 1 contornos 4",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.517
									],
									y: [
										1.028
									]
								},
								o: {
									x: [
										0.447
									],
									y: [
										0.008
									]
								},
								t: 9,
								s: [
									0
								]
							},
							{
								t: 45,
								s: [
									45
								]
							}
						],
						ix: 10
					},
					p: {
						a: 0,
						k: [
							206.845,
							206.846,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							206.845,
							206.846,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0.085,
												12.402
											],
											[
												-54.403,
												44.367
											],
											[
												-14.018,
												0.134
											],
											[
												-43.947,
												-43.738
											],
											[
												0.084,
												-10.073
											],
											[
												36.384,
												-40.84
											],
											[
												10.016,
												-0.118
											],
											[
												44.525,
												49.595
											]
										],
										o: [
											[
												0.199,
												-9.854
											],
											[
												39.464,
												-32.183
											],
											[
												10.485,
												0.023
											],
											[
												45.023,
												44.809
											],
											[
												-0.234,
												12.841
											],
											[
												-44.482,
												49.929
											],
											[
												-9.955,
												-0.098
											],
											[
												-37.571,
												-41.846
											]
										],
										v: [
											[
												-154.186,
												-0.001
											],
											[
												-97.171,
												-119.605
											],
											[
												-0.042,
												-154.145
											],
											[
												108.644,
												-109.203
											],
											[
												154.101,
												1.627
											],
											[
												115.084,
												102.384
											],
											[
												-0.042,
												154.145
											],
											[
												-114.751,
												102.857
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Caminho 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.490196078431,
										0.011764705882,
										0.749019607843,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 93,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Traçado 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										206.888,
										206.846
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transformar"
							}
						],
						nm: "Grupo 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.436
										],
										y: [
											1.057
										]
									},
									o: {
										x: [
											0.49
										],
										y: [
											-0.006
										]
									},
									t: 9,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.533
										],
										y: [
											7.363
										]
									},
									o: {
										x: [
											0.375
										],
										y: [
											5.41
										]
									},
									t: 45,
									s: [
										100
									]
								},
								{
									t: 46,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Aparar caminhos 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 9,
				op: 43,
				st: 9,
				bm: 0
			},
			{
				ddd: 0,
				ind: 4,
				ty: 4,
				nm: "Camada 1 contornos",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 1,
						k: [
							{
								i: {
									x: [
										0.517
									],
									y: [
										1.028
									]
								},
								o: {
									x: [
										0.447
									],
									y: [
										0.008
									]
								},
								t: 0,
								s: [
									0
								]
							},
							{
								t: 36,
								s: [
									45
								]
							}
						],
						ix: 10
					},
					p: {
						a: 0,
						k: [
							206.845,
							206.846,
							0
						],
						ix: 2,
						l: 2
					},
					a: {
						a: 0,
						k: [
							206.845,
							206.846,
							0
						],
						ix: 1,
						l: 2
					},
					s: {
						a: 0,
						k: [
							100,
							100,
							100
						],
						ix: 6,
						l: 2
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0.085,
												12.402
											],
											[
												-54.403,
												44.367
											],
											[
												-14.018,
												0.134
											],
											[
												-43.947,
												-43.738
											],
											[
												0.084,
												-10.073
											],
											[
												36.384,
												-40.84
											],
											[
												10.016,
												-0.118
											],
											[
												44.525,
												49.595
											]
										],
										o: [
											[
												0.199,
												-9.854
											],
											[
												39.464,
												-32.183
											],
											[
												10.485,
												0.023
											],
											[
												45.023,
												44.809
											],
											[
												-0.234,
												12.841
											],
											[
												-44.482,
												49.929
											],
											[
												-9.955,
												-0.098
											],
											[
												-37.571,
												-41.846
											]
										],
										v: [
											[
												-154.186,
												-0.001
											],
											[
												-97.171,
												-119.605
											],
											[
												-0.042,
												-154.145
											],
											[
												108.644,
												-109.203
											],
											[
												154.101,
												1.627
											],
											[
												115.084,
												102.384
											],
											[
												-0.042,
												154.145
											],
											[
												-114.751,
												102.857
											]
										],
										c: true
									},
									ix: 2
								},
								nm: "Caminho 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.901960784314,
										0.298039215686,
										0.176470588235,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 92,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Traçado 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										206.888,
										206.846
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transformar"
							}
						],
						nm: "Grupo 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.436
										],
										y: [
											1.057
										]
									},
									o: {
										x: [
											0.49
										],
										y: [
											-0.006
										]
									},
									t: 0,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.533
										],
										y: [
											7.363
										]
									},
									o: {
										x: [
											0.375
										],
										y: [
											5.41
										]
									},
									t: 36,
									s: [
										100
									]
								},
								{
									t: 37,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Aparar caminhos 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					}
				],
				ip: 0,
				op: 37,
				st: 0,
				bm: 0
			}
		]
	}
];
var layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 0,
		nm: "Pré-composição 1",
		refId: "comp_0",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 0,
						s: [
							88
						]
					},
					{
						t: 63,
						s: [
							268
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					207,
					207,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					207,
					207,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		w: 414,
		h: 414,
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	}
];
var markers = [
];
var OlistOLoading = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers
};

var _templateObject$a, _templateObject2$8;

var HandleWorkspaces = function HandleWorkspaces(_ref) {
  var hasError = _ref.hasError,
      isFulfillment = _ref.isFulfillment,
      isLoading = _ref.isLoading,
      onChangeToastr = _ref.onChangeToastr,
      translate = _ref.translate;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(united.Toastr, {
    position: "top-right",
    showToast: hasError,
    variation: "danger",
    onHide: function onHide() {
      return onChangeToastr();
    }
  }, translate('Something went wrong to accessing your workspace. Please, try again.')), isLoading && /*#__PURE__*/React__default["default"].createElement(Wrapper$1, {
    height: "100vh",
    width: "100vw"
  }, /*#__PURE__*/React__default["default"].createElement(united.Flex, {
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100vw"
  }, /*#__PURE__*/React__default["default"].createElement(AnimatedImage, {
    width: "92px",
    height: "92px",
    margin: "36px",
    play: true,
    src: OlistOLoading,
    role: "presentation"
  }), /*#__PURE__*/React__default["default"].createElement(Animation, null, /*#__PURE__*/React__default["default"].createElement(united.Text, {
    fontWeight: "bold",
    fontSize: ['medium', 'medium', '2xlarge', '2xlarge']
  }, translate('accessing'), ' ', /*#__PURE__*/React__default["default"].createElement(united.Text, {
    color: "primary.base",
    fontWeight: "bold",
    as: "span"
  }, "olist ", isFulfillment ? 'fulfillment' : 'store'))))));
};

var Wrapper$1 = styled__default["default"](united.Flex)(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  background: ", ";\n  left: 0;\n  position: absolute;\n  top: 0;\n  z-index: 1001;\n"])), themeGet.themeGet('olist.color.neutral.softest'));
var fadeIn = styled.keyframes(["0%{opacity:0;transform:translateY(30px);}100%{opacity:1;transform:translateY(0);}"]);
var Animation = styled__default["default"](united.Flex)(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n  animation: ", " ", " cubic-bezier(0.39, 0.575, 0.565, 1) both;\n  animation-delay: 0.5s;\n"])), fadeIn, themeGet.themeGet('duration.normal'));
HandleWorkspaces.defaultProps = {
  hasError: false,
  isFulfillment: false,
  isLoading: false,
  onChangeToastr: function onChangeToastr() {},
  translate: function translate(a) {
    return a;
  }
};

var _templateObject$9, _templateObject2$7, _templateObject3$4;
var CustomToggle = styled__default["default"](united.Button)(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  border: 2px solid ", ";\n  border-radius: 57px;\n  font-weight: ", ";\n  margin-right: 20px;\n\n  span {\n    margin-bottom: 2px;\n  }\n\n  &:focus:not([disabled]):hover,\n  &:focus:not([disabled]) {\n    background: ", ";\n  }\n\n  &:focus:not([disabled]):hover,\n  &:focus:not([disabled]),\n  &:hover:not([disabled]) {\n    box-shadow: none;\n  }\n"])), themeGet.themeGet('olist.color.neutral.softer'), themeGet.themeGet('olist.fontWeight.regular'), function (props) {
  return props.isDropdownOpen ? themeGet.themeGet('olist.color.primary.softer') : themeGet.themeGet('olist.color.neutral.softest');
});
var WrapperDropdown = styled__default["default"].div(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n  border: 2px solid ", ";\n  border-radius: ", ";\n  box-shadow: 0px 7px 6px rgba(49, 47, 79, 0.08), 0px 13px 16px rgba(49, 47, 79, 0.08),\n    0px 5px 20px rgba(49, 47, 79, 0.08);\n  height: 272px;\n  margin-top: 10px;\n  padding: ", ";\n  right: -130px;\n  width: 320px;\n\n  ul {\n    margin-top: ", ";\n  }\n"])), themeGet.themeGet('olist.color.neutral.softer'), themeGet.themeGet('olist.borderRadius.medium'), themeGet.themeGet('olist.spacing.inset.small'), themeGet.themeGet('olist.spacing.stack.small'));
var WrapperItem = styled__default["default"].div(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border-radius: ", ";\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 10px;\n  padding: ", ";\n"])), function (props) {
  return props.isActive ? themeGet.themeGet('olist.color.primary.softer') : themeGet.themeGet('olist.color.neutral.softest');
}, themeGet.themeGet('olist.borderRadius.medium'), themeGet.themeGet('olist.spacing.inset.small'));

var userHasPermission = function userHasPermission(_ref) {
  var permission = _ref.permission,
      permissions = _ref.permissions;
  var hasPermission = permissions.find(function (item) {
    return item.permission === permission && item.active === true;
  });
  return !!hasPermission;
};

var CHANGE_WORKSPACE = '/api/change-workspace';
var changeWorkspace = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var id, url, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            id = _ref.id;
            url = "".concat(CHANGE_WORKSPACE, "/").concat(id);
            response = axios__default["default"].get(url);
            return _context.abrupt("return", response);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function changeWorkspace(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var Workspaces = function Workspaces(_ref) {
  var permissions = _ref.permissions,
      userId = _ref.userId,
      workspaces = _ref.workspaces,
      translate = _ref.translate;

  var _useState = React.useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      sellerWorkspaces = _useState2[0],
      setSellerWorkspaces = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isDropdownOpen = _useState4[0],
      setIsDropdownOpen = _useState4[1];

  var _useState5 = React.useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      hasError = _useState6[0],
      setHasError = _useState6[1];

  var _useState7 = React.useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isLoading = _useState8[0],
      setIsLoading = _useState8[1];

  var _useState9 = React.useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isFulfillmentSelectedSeller = _useState10[0],
      setIsFulfillmentSelectedSeller = _useState10[1];

  var permission = 'can_use_fulfillment_by_olist';
  var isCurrentUserFulfillment = userHasPermission({
    permissions: permissions,
    permission: permission
  });

  var timeout = function timeout(ms) {
    return new Promise(function (res) {
      return setTimeout(res, ms);
    });
  };

  var onSuccessSelectedWorkspace = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return timeout(1000);

            case 2:
              window.location.reload();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSuccessSelectedWorkspace() {
      return _ref2.apply(this, arguments);
    };
  }();

  var onErrorSelectedWorkspace = function onErrorSelectedWorkspace() {
    setIsLoading(false);
    setHasError(true);
  };

  var setSelectedWorkspace = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return changeWorkspace({
                id: id
              });

            case 3:
              onSuccessSelectedWorkspace();
              _context2.next = 9;
              break;

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              onErrorSelectedWorkspace();

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 6]]);
    }));

    return function setSelectedWorkspace(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var getMessages = function getMessages(isFulfillment) {
    var messages = {
      title: isFulfillment ? 'fulfillment' : 'store',
      subtitle: isFulfillment ? translate('transfer products to our warehouse') : translate('bill, prepare and ship products by carriers or by collection mode')
    };
    return messages;
  };

  React.useEffect(function () {
    if (workspaces && workspaces.length > 0) {
      var workspacesOptions = workspaces.map(function (workSpaceItem) {
        var isFulfillment = userHasPermission({
          permissions: workSpaceItem.permissions,
          permission: permission
        });
        return _objectSpread2(_objectSpread2({}, workSpaceItem), {}, {
          isFulfillment: isFulfillment,
          messages: getMessages(isFulfillment)
        });
      });
      var currentUser = {
        id: userId,
        isFulfillment: isCurrentUserFulfillment,
        isCurrentUser: true,
        messages: getMessages(isCurrentUserFulfillment)
      };
      workspacesOptions.push(currentUser);
      var workspacesOptionsSorted = workspacesOptions.sort(function (a, b) {
        return a.isFulfillment - b.isFulfillment;
      });
      setSellerWorkspaces(workspacesOptionsSorted);
    }
  }, [isCurrentUserFulfillment, userId, workspaces]);

  var handleChangeWorkspace = function handleChangeWorkspace(_ref4) {
    var id = _ref4.id,
        isFulfillment = _ref4.isFulfillment;
    setIsLoading(true);
    setIsFulfillmentSelectedSeller(isFulfillment);
    setSelectedWorkspace(id);
  };

  var dropdownToggle = function dropdownToggle() {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(HandleWorkspaces, {
    isLoading: isLoading,
    hasError: hasError,
    isFulfillment: isFulfillmentSelectedSeller,
    onChangeToastr: function onChangeToastr() {
      return setHasError(false);
    },
    translate: translate
  }), workspaces && workspaces.length > 0 && /*#__PURE__*/React__default["default"].createElement(united.Dropdown, {
    shouldShowChevron: false,
    onOpen: function onOpen() {
      return dropdownToggle();
    },
    onClose: function onClose() {
      return dropdownToggle();
    }
  }, /*#__PURE__*/React__default["default"].createElement(united.Dropdown.Toggle, {
    as: CustomToggle,
    icon: "dots-menu-fill",
    isDropdownOpen: isDropdownOpen
  }, /*#__PURE__*/React__default["default"].createElement("span", null, isCurrentUserFulfillment ? 'fulfillment' : 'store')), /*#__PURE__*/React__default["default"].createElement(united.Dropdown.Menu, {
    as: WrapperDropdown
  }, /*#__PURE__*/React__default["default"].createElement(united.Text, null, translate('your operating workspaces')), /*#__PURE__*/React__default["default"].createElement("ul", null, sellerWorkspaces.map(function (_ref5) {
    var id = _ref5.id,
        isCurrentUser = _ref5.isCurrentUser,
        isFulfillment = _ref5.isFulfillment,
        messages = _ref5.messages;
    return /*#__PURE__*/React__default["default"].createElement(WrapperItem, {
      key: id,
      isActive: isCurrentUser,
      onClick: function onClick() {
        return handleChangeWorkspace({
          id: id,
          isFulfillment: isFulfillment
        });
      },
      "data-testid": "workspace-item"
    }, /*#__PURE__*/React__default["default"].createElement(united.Flex, {
      flexDirection: "column"
    }, /*#__PURE__*/React__default["default"].createElement(united.Text, null, /*#__PURE__*/React__default["default"].createElement("b", null, "olist"), " ", messages.title), /*#__PURE__*/React__default["default"].createElement(united.Text, {
      fontSize: 12,
      color: "neutral.strong"
    }, messages.subtitle)), isCurrentUser && /*#__PURE__*/React__default["default"].createElement(united.Icon, {
      name: "success-outline",
      size: "50px"
    }), !isCurrentUser && isFulfillment && /*#__PURE__*/React__default["default"].createElement(united.Badge, {
      size: "small",
      variation: "foundation.info"
    }, translate('new')));
  })))));
};

Workspaces.defaultProps = {
  userId: '',
  workspaces: [],
  permissions: [],
  translate: function translate(a) {
    return a;
  }
};

var HeaderDesktop = function HeaderDesktop(_ref) {
  var isSticky = _ref.isSticky,
      translate = _ref.translate,
      urls = _ref.urls,
      userName = _ref.userName,
      featuresTags = _ref.featuresTags,
      permissions = _ref.permissions,
      userId = _ref.userId,
      workspaces = _ref.workspaces;
  var permission = 'can_use_fulfillment_by_olist';
  var isCurrentUserFulfillment = userHasPermission({
    permissions: permissions,
    permission: permission
  });
  var isPermissionsLoaded = permissions.length > 0;
  return /*#__PURE__*/React__default["default"].createElement(DesktopHeaderContainer, {
    isSticky: isSticky
  }, /*#__PURE__*/React__default["default"].createElement(united.Navbar.Brand, {
    rel: "noopener noreferrer",
    href: urls.dashboard,
    height: "39px"
  }, !isPermissionsLoaded && /*#__PURE__*/React__default["default"].createElement(united.Skeleton, {
    width: "145px",
    height: "40px"
  }), isCurrentUserFulfillment && isPermissionsLoaded && /*#__PURE__*/React__default["default"].createElement(LogoOlistFbo, {
    width: "150px"
  }), !isCurrentUserFulfillment && isPermissionsLoaded && /*#__PURE__*/React__default["default"].createElement(LogoOlistStore, {
    width: "130px"
  })), /*#__PURE__*/React__default["default"].createElement(united.Box, {
    display: ['none', 'none', 'flex'],
    width: 1
  }, /*#__PURE__*/React__default["default"].createElement(united.Nav, {
    mr: "auto"
  }, /*#__PURE__*/React__default["default"].createElement(united.Nav.Link, {
    rel: "noopener noreferrer",
    href: urls.dashboard
  }, translate('dashboard')), /*#__PURE__*/React__default["default"].createElement(OrdersWithSubMenu, {
    hasCollections: featuresTags.includes('hasCollections'),
    translate: translate,
    urls: urls
  }), /*#__PURE__*/React__default["default"].createElement(united.NavDropdown, null, /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Toggle, null, /*#__PURE__*/React__default["default"].createElement(united.Flex, {
    alignItems: "center"
  }, translate('products'))), /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Menu, null, /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Item, {
    rel: "noopener noreferrer",
    href: urls.myProducts
  }, translate('my products')), /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Item, {
    rel: "noopener noreferrer",
    href: urls.stockPrice
  }, translate('stock & price')), /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Item, {
    rel: "noopener noreferrer",
    href: urls.promotions,
    onClick: function onClick() {
      return window.mixpanel && window.mixpanel.track('Header Menu - Clicked on Promotions');
    }
  }, translate('promotions')), /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Item, {
    rel: "noopener noreferrer",
    href: urls.individualRegistration
  }, translate('individual registration')), /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Item, {
    rel: "noopener noreferrer",
    href: urls.massRegistration
  }, translate('mass registration')), /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Item, {
    rel: "noopener noreferrer",
    href: urls.registrationViaIntegrations
  }, translate('registration via integrations')))), /*#__PURE__*/React__default["default"].createElement(united.Nav.Link, {
    rel: "noopener noreferrer",
    href: urls.analytics,
    onClick: function onClick() {
      return window.mixpanel && window.mixpanel.track('Header Menu - Clicked on Performance and Sales');
    }
  }, translate('performance and sales')), /*#__PURE__*/React__default["default"].createElement(united.Nav.Link, {
    rel: "noopener noreferrer",
    href: urls.financial,
    onClick: function onClick() {
      return window.mixpanel && window.mixpanel.track('Header Menu - Clicked on Financial');
    }
  }, translate('financial')), featuresTags.includes('olist_turbo') && !!urls.olistTurbo && /*#__PURE__*/React__default["default"].createElement(united.Nav.Link, {
    rel: "noopener noreferrer",
    href: urls.olistTurbo,
    onClick: function onClick() {
      return window.mixpanel && window.mixpanel.track('Header Menu - Clicked on Olist Turbo');
    }
  }, translate('olist turbo'), /*#__PURE__*/React__default["default"].createElement(united.Badge, {
    size: "small",
    ml: 2,
    variation: "foundation.info"
  }, translate('new')))), /*#__PURE__*/React__default["default"].createElement(Workspaces, {
    permissions: permissions,
    userId: userId,
    workspaces: workspaces,
    translate: translate
  }), /*#__PURE__*/React__default["default"].createElement(united.Nav, null, /*#__PURE__*/React__default["default"].createElement(united.NavDropdown, null, /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Toggle, null, /*#__PURE__*/React__default["default"].createElement(united.Flex, {
    alignItems: "center",
    "data-testid": userName
  }, userName)), /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Menu, {
    right: "0",
    top: "100%"
  }, /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Item, {
    rel: "noopener noreferrer",
    href: urls.settings
  }, translate('settings')), /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Item, {
    rel: "noopener noreferrer",
    href: urls.integrations
  }, translate('integrations')), /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Item, {
    rel: "noopener noreferrer",
    href: urls.referral,
    target: "_blank"
  }, translate('referral & earn')), /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Item, {
    rel: "noopener noreferrer",
    href: urls.termsOfUse
  }, translate('terms of use')), /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Item, {
    rel: "noopener noreferrer",
    href: urls.privacyPolicy,
    target: "_blank"
  }, translate('privacy policy')), /*#__PURE__*/React__default["default"].createElement(united.NavDropdown.Item, {
    rel: "noopener noreferrer",
    href: urls.logout
  }, translate('logout')))))));
};

HeaderDesktop.defaultProps = headerDefaultProps;

var HeaderButton = function HeaderButton(props) {
  var badgeLabel = props.badgeLabel,
      borderColor = props.borderColor,
      isActive = props.isActive,
      name = props.name,
      url = props.url;
  return /*#__PURE__*/React__default["default"].createElement(MenuLink, _extends({
    fullWidth: true,
    href: url,
    borderColor: borderColor
  }, props), /*#__PURE__*/React__default["default"].createElement(HeaderButtonTextWrapper, null, /*#__PURE__*/React__default["default"].createElement(HeaderButtonText, {
    isActive: isActive
  }, name), badgeLabel && /*#__PURE__*/React__default["default"].createElement(united.Badge, {
    size: "small",
    ml: 2,
    variation: "foundation.info"
  }, badgeLabel)), /*#__PURE__*/React__default["default"].createElement(united.Icon, {
    color: "neutral.soft",
    name: "chevron-right-outline"
  }));
};

HeaderButton.defaultProps = {
  badgeLabel: '',
  borderColor: '',
  isActive: false,
  name: '',
  url: ''
};

var HeaderMobile = function HeaderMobile(_ref) {
  var isSticky = _ref.isSticky,
      translate = _ref.translate,
      urls = _ref.urls,
      userName = _ref.userName,
      featuresTags = _ref.featuresTags;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMenuOpen = _useState2[0],
      setIsMenuOpen = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isCollapseOpen = _useState4[0],
      setIsCollapseOpen = _useState4[1];

  var _useState5 = React.useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isOrdersCollapseOpen = _useState6[0],
      setIsOrdersCollapseOpen = _useState6[1];

  var currentLocation = window.location.pathname;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(MobileHeaderContainer, {
    isSticky: isSticky,
    justifyContent: "space-between",
    alignItems: "center",
    my: 2
  }, /*#__PURE__*/React__default["default"].createElement(LogoOlistStore, {
    width: "130px"
  }), /*#__PURE__*/React__default["default"].createElement(MenuButton, {
    endIcon: "menu-outline",
    color: "primary.base",
    onClick: function onClick() {
      return setIsMenuOpen(!isCollapseOpen);
    }
  }, "menu")), /*#__PURE__*/React__default["default"].createElement(MenuDrawer, {
    visible: isMenuOpen
  }, /*#__PURE__*/React__default["default"].createElement(united.Box, null, /*#__PURE__*/React__default["default"].createElement(MenuHeader, null, /*#__PURE__*/React__default["default"].createElement(MenuButton, {
    onClick: function onClick() {
      return setIsMenuOpen(false);
    },
    startIcon: "arrow-left-outline",
    color: "primary.base"
  }), /*#__PURE__*/React__default["default"].createElement(MenuHeaderTitle, null, "menu")), /*#__PURE__*/React__default["default"].createElement(MenuBody, null, /*#__PURE__*/React__default["default"].createElement(SellerName, null, userName), /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('dashboard'),
    url: urls.dashboard,
    isActive: currentLocation.includes(urls.dashboard)
  }), /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(MenuCollapseButton, {
    onClick: function onClick() {
      return setIsOrdersCollapseOpen(!isOrdersCollapseOpen);
    },
    fullWidth: true
  }, /*#__PURE__*/React__default["default"].createElement("span", null, translate('orders')), /*#__PURE__*/React__default["default"].createElement(united.Icon, {
    name: isOrdersCollapseOpen ? 'chevron-up-outline' : 'chevron-down-outline',
    color: "neutral.soft"
  })), /*#__PURE__*/React__default["default"].createElement(united.Collapse, {
    "in": isOrdersCollapseOpen,
    timeout: 500
  }, /*#__PURE__*/React__default["default"].createElement(united.Box, {
    pl: 4
  }, /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('pre-sale questions'),
    url: urls.orders,
    isActive: currentLocation.includes(urls.questions)
  }), /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('my orders'),
    url: urls.orders,
    isActive: currentLocation.includes(urls.orders)
  }), featuresTags.includes('hasCollections') && /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('collection receipts'),
    url: urls.collections,
    isActive: currentLocation.includes(urls.collections)
  })))), /*#__PURE__*/React__default["default"].createElement(MenuCollapseButton, {
    onClick: function onClick() {
      return setIsCollapseOpen(!isCollapseOpen);
    },
    fullWidth: true
  }, /*#__PURE__*/React__default["default"].createElement("span", null, translate('products')), /*#__PURE__*/React__default["default"].createElement(united.Icon, {
    name: isCollapseOpen ? 'chevron-up-outline' : 'chevron-down-outline',
    color: "neutral.soft"
  })), /*#__PURE__*/React__default["default"].createElement(united.Collapse, {
    "in": isCollapseOpen,
    timeout: 500
  }, /*#__PURE__*/React__default["default"].createElement(united.Box, {
    pl: 4
  }, /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('my products'),
    url: urls.myProducts
  }), /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('stock & price'),
    url: urls.stockPrice
  }), /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('promotions'),
    url: urls.promotions
  }), /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('individual registration'),
    url: urls.individualRegistration,
    isActive: currentLocation.includes(urls.individualRegistration)
  }), /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('mass registration'),
    url: urls.massRegistration
  }), /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('registration via integrations'),
    url: urls.registrationViaIntegrations
  }))), /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('performance and sales'),
    url: urls.analytics
  }), /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('financial'),
    url: urls.financial
  }), featuresTags.includes('olist_turbo') && !!urls.olistTurbo && /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('olist turbo'),
    url: urls.olistTurbo,
    badgeLabel: translate('new')
  }), /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('settings'),
    url: urls.settings
  }), /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('integrations'),
    url: urls.integrations
  }), /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    target: "_blank",
    name: translate('referral & earn'),
    url: urls.referral
  }), /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('terms of use'),
    url: urls.termsOfUse
  }), /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    target: "_blank",
    name: translate('privacy policy'),
    url: urls.privacyPolicy
  }), /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('help center'),
    url: urls.helpCenter,
    target: "_blank",
    borderColor: "olist.color.primary.base"
  }), /*#__PURE__*/React__default["default"].createElement(HeaderButton, {
    name: translate('logout'),
    url: urls.logout
  })))));
};

HeaderMobile.defaultProps = headerDefaultProps;

var Header = function Header(_ref) {
  var isSticky = _ref.isSticky,
      translate = _ref.translate,
      urls = _ref.urls,
      userName = _ref.userName,
      featuresTags = _ref.featuresTags,
      permissions = _ref.permissions,
      userId = _ref.userId,
      workspaces = _ref.workspaces;

  var _useDeviceInfo = useDeviceInfo(),
      isDesktop = _useDeviceInfo.isDesktop;
      _useDeviceInfo.isMobile;

  useDeprecatedComponent('shapeshifter Header');

  if (isDesktop) {
    return /*#__PURE__*/React__default["default"].createElement(HeaderDesktop, {
      featuresTags: featuresTags,
      userName: userName,
      urls: urls,
      translate: translate,
      isSticky: isSticky,
      permissions: permissions,
      userId: userId,
      workspaces: workspaces
    });
  }

  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
};

Header.defaultProps = headerDefaultProps;

var Layout = {
  Container: Container$1,
  SubHeader: SubHeader,
  SubTitle: SubTitle,
  Title: Title$2
};

var requireObjectCoercible = requireObjectCoercible$d;

var quot = /"/g;

// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
// https://tc39.es/ecma262/#sec-createhtml
var createHtml = function (string, tag, attribute, value) {
  var S = String(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};

var fails = fails$r;

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
var stringHtmlForced = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};

var $$2 = _export;
var createHTML = createHtml;
var forcedStringHTMLMethod = stringHtmlForced;

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$$2({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});

var _templateObject$8, _templateObject2$6, _templateObject3$3;
var Container = styled__default["default"](united.Flex)(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  flex-direction: column;\n  align-items: center;\n"])));
var Title = styled__default["default"].h3(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  white-space: nowrap;\n  margin-bottom: 10px;\n"])), themeGet.themeGet('olist.color.neutral.stronger'), themeGet.themeGet('olist.fontSize.2xlarge'));
var Subtitle = styled__default["default"].div(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  margin-bottom: 36px;\n\n  > * {\n    margin: 0;\n    text-align: center;\n  }\n"])), themeGet.themeGet('olist.color.neutral.base'), themeGet.themeGet('olist.fontSize.1xsmall'));

var SplashFeedbackLink = function SplashFeedbackLink(_ref) {
  var _ref$link = _ref.link,
      text = _ref$link.text,
      rest = _objectWithoutProperties(_ref$link, ["text"]);

  return /*#__PURE__*/React__default["default"].createElement(united.Box, {
    width: "240px"
  }, /*#__PURE__*/React__default["default"].createElement(united.Link, _extends({
    fullWidth: true
  }, rest), text || ''));
};

var SplashFeedback = function SplashFeedback(_ref2) {
  var imgSrc = _ref2.imgSrc,
      subtitle = _ref2.subtitle,
      link = _ref2.link,
      title = _ref2.title;
  return /*#__PURE__*/React__default["default"].createElement(Container, null, /*#__PURE__*/React__default["default"].createElement(united.Box, {
    mb: "34px"
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    src: imgSrc,
    alt: title
  })), /*#__PURE__*/React__default["default"].createElement(Title, null, title), /*#__PURE__*/React__default["default"].createElement(Subtitle, null, subtitle), link && /*#__PURE__*/React__default["default"].createElement(SplashFeedbackLink, {
    link: link
  }));
};

SplashFeedback.defaultProps = {
  link: undefined
};

var _templateObject$7;
var Logo = styled__default["default"].img.attrs(function (_ref) {
  var variation = _ref.variation;
  return {
    alt: 'olist logo',
    src: variation === VARIATION_DEFAULT ? img$1 : img
  };
})(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral([""])));
Logo.defaultProps = {
  variation: VARIATION_DEFAULT
};
Logo.propTypes = {
  variation: T.oneOf([VARIATION_DEFAULT, VARIATION_INVERTER])
};

var _templateObject$6, _templateObject2$5, _templateObject3$2, _templateObject4, _templateObject5;
var Wrapper = styled__default["default"](united.Box)(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));
var StyledThumbnail = styled__default["default"](united.Flex)(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n  align-items: center;\n  background: url(", ") no-repeat center center;\n  background-position: center;\n  background-size: cover;\n  height: 100%;\n  justify-content: center;\n  width: 100%;\n"])), function (_ref) {
  var src = _ref.src;
  return src;
});
var StyledPlay = styled__default["default"].div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  opacity: 0.83;\n  &:hover {\n    opacity: 1;\n  }\n"])));
var StyledModal = styled__default["default"](united.Modal)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border: none;\n  border-radius: 0;\n  display: flex;\n  padding: 0;\n"])));
var StyledVideo = styled__default["default"].iframe(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  border: none;\n  height: 584px;\n  width: 100%;\n"])));

var BASE_URL_IMAGE = 'https://img.youtube.com/vi';
var BASE_URL_VIDEO = 'https://www.youtube.com/embed';

var YoutubeVideoPlayer = function YoutubeVideoPlayer(_ref) {
  var children = _ref.children,
      videoId = _ref.videoId,
      thumbOption = _ref.thumbOption,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      options = _ref.options,
      title = _ref.title,
      boxProps = _objectWithoutProperties(_ref, ["children", "videoId", "thumbOption", "onOpen", "onClose", "options", "title"]);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpenModal = _useState2[0],
      setIsOpenModal = _useState2[1];

  var openModal = function openModal() {
    onOpen();
    setIsOpenModal(true);
  };

  var closeModal = function closeModal() {
    onClose();
    setIsOpenModal(false);
  };

  var params = objectToQueryString(options, {
    rel: 0
  });
  return /*#__PURE__*/React__default["default"].createElement(Wrapper, boxProps, children && /*#__PURE__*/React__default["default"].createElement(united.Box, {
    onClick: openModal
  }, children), !children && /*#__PURE__*/React__default["default"].createElement(StyledThumbnail, {
    src: "".concat(BASE_URL_IMAGE, "/").concat(videoId, "/").concat(thumbOption, ".jpg"),
    onClick: openModal
  }, /*#__PURE__*/React__default["default"].createElement(StyledPlay, null, /*#__PURE__*/React__default["default"].createElement(united.Icon, {
    name: "play-fill",
    color: "white",
    size: 30
  }))), /*#__PURE__*/React__default["default"].createElement(StyledModal, {
    ariaHideApp: false,
    isOpen: isOpenModal,
    onRequestClose: closeModal,
    variation: "theater"
  }, /*#__PURE__*/React__default["default"].createElement(StyledVideo, {
    title: title,
    src: "".concat(BASE_URL_VIDEO, "/").concat(videoId, "?").concat(params)
  })));
};

YoutubeVideoPlayer.defaultProps = {
  children: null,
  thumbOption: 'hqdefault',
  onClose: function onClose() {},
  onOpen: function onOpen() {},
  options: {},
  title: ''
};

var generateQueryParams = function generateQueryParams(page, amountPerPage, queryParams) {
  var offset = page > 0 ? (page - 1) * parseInt(amountPerPage, 10) : 0;
  return "".concat(queryParams, "&offset=").concat(offset);
};

var LinkPagination = function LinkPagination(_ref) {
  var amountPages = _ref.amountPages,
      amountPerPage = _ref.amountPerPage,
      currentPage = _ref.currentPage,
      queryParams = _ref.queryParams,
      props = _objectWithoutProperties(_ref, ["amountPages", "amountPerPage", "currentPage", "queryParams"]);

  return amountPages > 1 && /*#__PURE__*/React__default["default"].createElement(united.Pagination, _extends({
    currentPage: parseInt(currentPage, 10),
    pageCount: parseInt(amountPages, 10),
    hrefBuilder: function hrefBuilder(page) {
      return generateQueryParams(page, amountPerPage, queryParams);
    }
  }, props));
};

var _templateObject$5, _templateObject2$4, _templateObject3$1;
var ProductImage = styled__default["default"].img(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  align-self: center;\n  ", "\n"])), styledSystem.width);
ProductImage.propTypes = _objectSpread2({}, styledSystem.width.propTypes);
var ProductMetadata = styled__default["default"].p(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  user-select: none;\n\n  span {\n    margin-right: ", ";\n    user-select: all;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"])), themeGet.themeGet('olist.color.neutral.base'), themeGet.themeGet('olist.fontSize.3xsmall'), themeGet.themeGet('olist.lineHeight.1xsmall'), themeGet.themeGet('olist.spacing.inline.small'));
var ProductTitle = styled__default["default"].h5(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  margin: 0;\n"])), themeGet.themeGet('olist.color.neutral.stronger'), themeGet.themeGet('olist.fontWeight.regular'), themeGet.themeGet('olist.fontSize.1xsmall'), themeGet.themeGet('olist.lineHeight.small'));

var $$1 = _export;
var $values = objectToArray.values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$$1({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});

var ProductAttributes = function ProductAttributes(_ref) {
  var attributes = _ref.attributes;
  var theme = styled.useTheme();
  return attributes.map(function (attribute) {
    return Object.values(attribute).map(function (value) {
      return /*#__PURE__*/React__default["default"].createElement(united.Badge, {
        bg: themeGet.themeGet('olist.color.neutral.softer')({
          theme: theme
        }),
        color: themeGet.themeGet('olist.color.neutral.base')({
          theme: theme
        }),
        key: value,
        size: "small",
        variation: "inactive"
      }, value);
    });
  });
};

ProductAttributes.defaultProps = {
  attributes: []
};

var $ = _export;
var $every = arrayIteration.every;
var arrayMethodIsStrict = arrayMethodIsStrict$7;

var STRICT_METHOD = arrayMethodIsStrict('every');

// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var useMultipleCheckbox = function useMultipleCheckbox() {
  var _useState = React.useState(new Set()),
      _useState2 = _slicedToArray(_useState, 2),
      checkedItems = _useState2[0],
      setCheckedItems = _useState2[1];

  var checkItem = React.useCallback(function (item) {
    return setCheckedItems(function (previousState) {
      return new Set(previousState.add(item));
    });
  }, []);
  var unCheckItem = React.useCallback(function (item) {
    return setCheckedItems(function (previousState) {
      return new Set(_toConsumableArray(previousState).filter(function (checkedItem) {
        return checkedItem !== item;
      }));
    });
  }, []);

  var checkItems = function checkItems(items) {
    return setCheckedItems(function (previousState) {
      return new Set([].concat(_toConsumableArray(previousState), _toConsumableArray(items)));
    });
  };

  var unCheckAll = function unCheckAll() {
    setCheckedItems(new Set());
  };

  return {
    checkItem: checkItem,
    checkItems: checkItems,
    checkedItems: _toConsumableArray(checkedItems),
    unCheckItem: unCheckItem,
    unCheckAll: unCheckAll
  };
};

var _templateObject$4, _templateObject2$3;
var HeaderRow = styled__default["default"](united.Table.Row)(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  border-top: 1px solid ", ";\n  position: relative;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.olist.color.neutral.softer;
});
var ThStyled = styled__default["default"](united.Table.Th).attrs({
  isSticky: true
})(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  position: ", ";\n  top: ", ";\n  background-color: ", ";\n  z-index: 1;\n"])), function (_ref2) {
  var isSticky = _ref2.isSticky;
  return isSticky ? 'sticky' : 'relative';
}, function (_ref3) {
  var isSticky = _ref3.isSticky;
  return isSticky && 0;
}, function (_ref4) {
  var isSticky = _ref4.isSticky,
      theme = _ref4.theme;
  return isSticky && theme.olist.color.neutral.softest;
});

var FilterOptions = function FilterOptions(_ref) {
  var items = _ref.items,
      label = _ref.label,
      onChange = _ref.onChange,
      type = _ref.type,
      initialValue = _ref.initialValue;
  var isSingle = type === 'single';

  var getInitialValue = function getInitialValue() {
    return isSingle ? initialValue[0] : initialValue;
  };

  var _useState = React.useState(getInitialValue()),
      _useState2 = _slicedToArray(_useState, 2),
      selectedItems = _useState2[0],
      setSelectedItems = _useState2[1];

  var handleChangeMultiple = function handleChangeMultiple(_ref2, isChecked) {
    var name = _ref2.name,
        value = _ref2.value;
    return isChecked ? setSelectedItems([].concat(_toConsumableArray(selectedItems), [_defineProperty({}, name, value)])) : setSelectedItems(selectedItems.filter(function (item) {
      return item[name] !== value;
    }));
  };

  var handleChangeSingle = function handleChangeSingle(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return setSelectedItems(_defineProperty({}, name, value));
  };

  var isChecked = function isChecked(_ref5) {
    var name = _ref5.name,
        value = _ref5.value;
    return isSingle ? !!selectedItems && selectedItems[name] === value : !!selectedItems.find(function (item) {
      return item[name] === value;
    });
  };

  React.useEffect(function () {
    onChange(selectedItems);
  }, [selectedItems]);
  React.useEffect(function () {
    setSelectedItems(getInitialValue());
  }, [initialValue]);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(united.Text, {
    color: "foundation.shadeDark",
    lineHeight: "1.3",
    mb: 3
  }, label), items.map(function (_ref6) {
    var itemLabel = _ref6.label,
        field = _objectWithoutProperties(_ref6, ["label"]);

    return /*#__PURE__*/React__default["default"].createElement(united.Box, {
      mb: 2,
      key: itemLabel
    }, isSingle ? /*#__PURE__*/React__default["default"].createElement(united.Radio, {
      label: itemLabel,
      checked: isChecked(field),
      onChange: function onChange() {
        return handleChangeSingle(field);
      }
    }) : /*#__PURE__*/React__default["default"].createElement(united.Checkbox, {
      label: itemLabel,
      checked: isChecked(field),
      onChange: function onChange(_ref7) {
        var target = _ref7.target;
        return handleChangeMultiple(field, target.checked);
      }
    }));
  }));
};

FilterOptions.defaultProps = {
  initialValue: [],
  label: 'filter',
  type: 'single'
};

var _templateObject$3, _templateObject2$2, _templateObject3;
var OptionsWrapper = styled__default["default"](united.Box).attrs({
  p: 3
})(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral([""])));
var FilterWrapper = styled__default["default"](united.Box)(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  max-height: 200px;\n  overflow-y: auto;\n"])));
var ActionButton = styled__default["default"](united.Button).attrs(function (_ref) {
  var isActive = _ref.isActive,
      props = _objectWithoutProperties(_ref, ["isActive"]);

  return {
    endIcon: 'filter-outline',
    color: isActive ? themeGet.themeGet('olist.color.primary.base')(props) : themeGet.themeGet('olist.color.neutral.strong')(props)
  };
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: 30px;\n  border: 1px solid ", ";\n  box-shadow: none;\n  font-size: 14px;\n  font-weight: normal;\n  height: 26px;\n  line-height: 26px;\n  padding: 0 10px;\n  text-transform: lowercase;\n\n  svg path {\n    fill: ", ";\n  }\n\n  :active,\n  :focus,\n  :hover {\n    svg path {\n      fill: ", ";\n    }\n\n    &:active:not([disabled]),\n    &:focus:not([disabled]),\n    &:hover:not([disabled]) {\n      box-shadow: none;\n      border-color: ", ";\n      background: ", ";\n    }\n  }\n"])), themeGet.themeGet('olist.color.neutral.softer'), themeGet.themeGet('olist.color.neutral.softer'), function (_ref2) {
  var isActive = _ref2.isActive;
  return isActive ? themeGet.themeGet('olist.color.primary.base') : themeGet.themeGet('neutral.strong');
}, themeGet.themeGet('olist.color.primary.base'), themeGet.themeGet('olist.color.neutral.softer'), themeGet.themeGet('olist.color.neutral.softer'));

var ColumnHead = function ColumnHead(_ref) {
  var children = _ref.children,
      filter = _ref.filter,
      isActive = _ref.isActive,
      labelButtons = _ref.labelButtons,
      onClear = _ref.onClear,
      onSubmit = _ref.onSubmit,
      sorting = _ref.sorting;

  var _ref2 = filter || {},
      _ref2$initialValue = _ref2.initialValue,
      initialValue = _ref2$initialValue === void 0 ? [] : _ref2$initialValue,
      filterType = _ref2.type;

  var _useState = React.useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedOptions = _useState2[0],
      setSelectedOptions = _useState2[1];

  var _useState3 = React.useState(initialValue),
      _useState4 = _slicedToArray(_useState3, 2),
      initialFilterValue = _useState4[0],
      setInitialFilterValue = _useState4[1];

  var _ref3 = filter || {},
      customFilter = _ref3.customFilter,
      isCustomFilter = _ref3.isCustomFilter;

  var hasSorting = !!sorting;
  var hasFilter = !!filter;
  var isDefaultFilter = hasFilter && !isCustomFilter;
  var hasAction = hasSorting || hasFilter;

  var getInitialValue = function getInitialValue() {
    if (selectedOptions.filters) {
      return Array.isArray(selectedOptions.filters) ? selectedOptions.filters : [selectedOptions.filters];
    }

    return initialFilterValue;
  };

  var clearFilter = function clearFilter() {
    setSelectedOptions({});
    setInitialFilterValue([]);
  };

  var handleClear = function handleClear() {
    onClear();
    clearFilter();
  };

  var handleSubmit = function handleSubmit() {
    onSubmit(selectedOptions);
  };

  var handleChangeFilter = function handleChangeFilter(filters) {
    setSelectedOptions(_objectSpread2(_objectSpread2({}, selectedOptions), {}, {
      filters: filters
    }));
  };

  var actionsMenu = hasAction ? /*#__PURE__*/React__default["default"].createElement(ActionButton, {
    isActive: isActive,
    "data-ref": "dropdown-toggle"
  }, children) : children;
  return /*#__PURE__*/React__default["default"].createElement(united.Dropdown, {
    shouldShowChevron: false,
    onClose: function onClose() {
      return !isActive && clearFilter();
    }
  }, /*#__PURE__*/React__default["default"].createElement(united.Dropdown.Toggle, {
    as: united.Flex
  }, actionsMenu), hasFilter ? /*#__PURE__*/React__default["default"].createElement(united.Dropdown.Menu, {
    minWidth: "220px",
    "data-ref": "option-dropdown"
  }, /*#__PURE__*/React__default["default"].createElement(OptionsWrapper, null, /*#__PURE__*/React__default["default"].createElement(FilterWrapper, null, isDefaultFilter ? /*#__PURE__*/React__default["default"].createElement(FilterOptions, _extends({}, filter, {
    initialValue: getInitialValue(),
    onChange: handleChangeFilter,
    type: filterType
  })) : customFilter), /*#__PURE__*/React__default["default"].createElement(united.Flex, {
    justifyContent: "space-between",
    mt: 4
  }, /*#__PURE__*/React__default["default"].createElement(united.Button, {
    onClick: handleClear,
    "data-ref": "button-clear"
  }, labelButtons.clearButton), /*#__PURE__*/React__default["default"].createElement(united.Button, {
    onClick: handleSubmit,
    variation: "alternate",
    "data-ref": "button-submit"
  }, labelButtons.submitButton)))) : /*#__PURE__*/React__default["default"].createElement(united.Box, null));
};

ColumnHead.defaultProps = {
  filter: null,
  isActive: false,
  labelButtons: {
    clearButton: 'clear',
    submitButton: 'apply'
  },
  onClear: function onClear() {},
  onSubmit: function onSubmit() {},
  sorting: null,
  children: ''
};

var Fallbacks = function Fallbacks(_ref) {
  var fallbacks = _ref.fallbacks,
      hasItems = _ref.hasItems;
  var blank = fallbacks.blank,
      error = fallbacks.error,
      hasError = fallbacks.hasError,
      isLoading = fallbacks.isLoading,
      loading = fallbacks.loading,
      minHeight = fallbacks.minHeight;

  var Wrapper = function Wrapper(props) {
    return /*#__PURE__*/React__default["default"].createElement(united.Flex, _extends({
      alignItems: "center",
      "data-ref": "fallback",
      justifyContent: "center",
      minHeight: minHeight || '340px',
      width: "100%"
    }, props));
  };

  if (isLoading) {
    return /*#__PURE__*/React__default["default"].createElement(Wrapper, null, loading || /*#__PURE__*/React__default["default"].createElement(united.Loading, null));
  }

  if (!isLoading && hasError) {
    if (!error) {
      console.error('Set a "fallbacks.error" property to display a fallback to the error state!');
      return null;
    }

    return /*#__PURE__*/React__default["default"].createElement(Wrapper, null, error);
  }

  if (!isLoading && !hasItems) {
    return !!blank && /*#__PURE__*/React__default["default"].createElement(Wrapper, null, blank);
  }

  return null;
};

Fallbacks.defaultProps = {
  fallbacks: {},
  hasItems: false
};

var _templateObject$2, _templateObject2$1;
var FilterRow = styled__default["default"](united.Table.Row)(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  outline: none;\n\n  && {\n    border: none;\n  }\n"])), themeGet__default["default"]('olist.color.neutral.softer'));
var ClearFilterButton = styled__default["default"](united.Button).attrs(function () {
  return {
    size: 'small'
  };
})(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  align-self: center;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  height: 16px;\n\n  svg {\n    margin-left: 12px;\n    outline: none;\n  }\n\n  &&:focus,\n  &&:active,\n  &&:hover {\n    background: transparent;\n    box-shadow: none;\n    outline: none;\n\n    &:hover,\n    &:active {\n      box-shadow: none;\n    }\n  }\n"])));

var Td$1 = united.Table.Td;

var FilterInfo = function FilterInfo(_ref) {
  var columnsCount = _ref.columnsCount,
      hasSelection = _ref.hasSelection,
      filter = _ref.filter,
      isExpandable = _ref.isExpandable;
  var clearButtonText = filter.clearButtonText,
      count = filter.count,
      chips = filter.chips,
      filterText = filter.filterText,
      onClearAllFilters = filter.onClearAllFilters;

  var getFilterText = function getFilterText() {
    return filterText ? filterText(count) : "showing ".concat(count, " items to the active filters");
  };

  var getClearButtonText = function getClearButtonText() {
    return clearButtonText ? clearButtonText() : 'clear filter';
  };

  var getColSpanFilter = function getColSpanFilter() {
    return columnsCount + (hasSelection && 1) + (isExpandable && 1);
  };

  var getChips = function getChips() {
    return chips && chips.map(function (chip) {
      return /*#__PURE__*/React__default["default"].createElement(Chip, {
        key: chip.label,
        label: chip.label,
        onClick: function onClick() {
          return chip.onClearFilter();
        },
        mx: 1
      });
    });
  };

  return /*#__PURE__*/React__default["default"].createElement(FilterRow, null, /*#__PURE__*/React__default["default"].createElement(Td$1, {
    colSpan: getColSpanFilter()
  }, /*#__PURE__*/React__default["default"].createElement(united.Flex, {
    justifyContent: "space-between"
  }, /*#__PURE__*/React__default["default"].createElement(united.Flex, null, /*#__PURE__*/React__default["default"].createElement(united.Box, {
    mr: 2
  }, getFilterText()), getChips()), /*#__PURE__*/React__default["default"].createElement(ClearFilterButton, {
    onClick: onClearAllFilters
  }, /*#__PURE__*/React__default["default"].createElement(united.Text, {
    color: "textLight"
  }, getClearButtonText()), /*#__PURE__*/React__default["default"].createElement(united.Icon, {
    name: "close-outline",
    size: 13
  })))));
};

FilterInfo.defaultProps = {
  columnsCount: 0,
  filter: {
    chips: [],
    count: -1,
    onClearAllFilters: function onClearAllFilters() {}
  },
  hasSelection: false,
  isExpandable: false
};

var _templateObject$1, _templateObject2;
var ChevronIcon = styled__default["default"](united.Icon)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));
var ExpandableRow = styled__default["default"](united.Table.Row)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: ", ";\n\n  ", " {\n    padding-bottom: 0;\n    padding-top: 0;\n  }\n\n  &&& {\n    border: none;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.olist.color.neutral.softer;
}, united.Table.Td);

var Row$1 = united.Table.Row,
    Td = united.Table.Td;

var MemoizeRow = function MemoizeRow(_ref) {
  var checkItem = _ref.checkItem,
      columnsData = _ref.columnsData,
      expandedContent = _ref.expandedContent,
      hasSelection = _ref.hasSelection,
      isChecked = _ref.isChecked,
      isExpandable = _ref.isExpandable,
      itemKey = _ref.itemKey,
      unCheckItem = _ref.unCheckItem;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var hasExpandableContent = !!expandedContent;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Row$1, null, hasSelection && /*#__PURE__*/React__default["default"].createElement(Td, null, /*#__PURE__*/React__default["default"].createElement(united.Flex, null, /*#__PURE__*/React__default["default"].createElement(united.Checkbox, {
    onChange: function onChange(_ref2) {
      var target = _ref2.target;
      return target.checked ? checkItem(itemKey) : unCheckItem(itemKey);
    },
    checked: isChecked
  }))), isExpandable && /*#__PURE__*/React__default["default"].createElement(Td, {
    "data-ref": "expandable-column"
  }, hasExpandableContent && /*#__PURE__*/React__default["default"].createElement(ChevronIcon, {
    name: isExpanded ? 'chevron-up-outline' : 'chevron-down-outline',
    color: isExpanded ? 'blue' : 'text',
    size: 24,
    onClick: function onClick() {
      return setIsExpanded(!isExpanded);
    }
  })), columnsData.map(function (_ref3) {
    var content = _ref3.content,
        dataKey = _ref3.dataKey,
        style = _ref3.style;
    return /*#__PURE__*/React__default["default"].createElement(Td, _extends({}, style, {
      key: dataKey,
      "data-ref": "content"
    }), content);
  })), hasExpandableContent && /*#__PURE__*/React__default["default"].createElement(ExpandableRow, null, /*#__PURE__*/React__default["default"].createElement(Td, null), hasSelection && /*#__PURE__*/React__default["default"].createElement(Td, null), /*#__PURE__*/React__default["default"].createElement(Td, {
    colSpan: columnsData.length
  }, /*#__PURE__*/React__default["default"].createElement(united.Collapse, {
    "in": isExpanded,
    timeout: 500
  }, /*#__PURE__*/React__default["default"].createElement("div", null, expandedContent)))));
};

MemoizeRow.defaultProps = {
  expandedContent: undefined
};
var MemoizeRow$1 = /*#__PURE__*/React.memo(MemoizeRow, isEqual__default["default"]);

var Pagination = function Pagination(_ref) {
  var isLinkPagination = _ref.isLinkPagination,
      pagination = _ref.pagination;
  var memoizedPagination = React.useMemo(function () {
    var amountPages = pagination.amountPages,
        amountPerPage = pagination.amountPerPage,
        count = pagination.count,
        currentPage = pagination.currentPage;
    return _objectSpread2(_objectSpread2({}, pagination), {}, {
      amountPages: Number(amountPages),
      amountPerPage: Number(amountPerPage),
      count: Number(count),
      currentPage: Number(currentPage)
    });
  }, [pagination]);
  var amountPages = memoizedPagination.amountPages,
      amountPerPage = memoizedPagination.amountPerPage,
      count = memoizedPagination.count,
      memoizedCurrentPage = memoizedPagination.currentPage;

  var _useState = React.useState(memoizedCurrentPage || 1),
      _useState2 = _slicedToArray(_useState, 2),
      currentPage = _useState2[0],
      setCurrentPage = _useState2[1];

  var pageCount = Math.ceil(count / amountPerPage);
  var showPagination = pageCount > 1;
  React.useEffect(function () {
    if (memoizedCurrentPage && memoizedCurrentPage !== currentPage) {
      setCurrentPage(memoizedCurrentPage);
    }
  }, [pagination.currentPage]);

  var onChange = function onChange(page) {
    var offset = (page - 1) * amountPerPage;
    setCurrentPage(page);
    pagination.onChange({
      offset: offset,
      currentPage: page,
      limit: amountPerPage
    });
  };

  var getPaginationText = function getPaginationText() {
    var totalItems = currentPage * amountPerPage;
    var showingItemsCount = totalItems > count ? count : totalItems;

    if (pagination.customPaginationText) {
      return pagination.customPaginationText(showingItemsCount);
    }

    return "showing ".concat(showingItemsCount, " of ").concat(count, " items");
  };

  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(united.Flex, {
    mt: 3,
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React__default["default"].createElement(united.Text, {
    "data-ref": "pagination-text"
  }, getPaginationText()), showPagination && (isLinkPagination ? /*#__PURE__*/React__default["default"].createElement(LinkPagination, {
    amountPages: amountPages,
    amountPerPage: amountPerPage,
    currentPage: currentPage,
    queryParams: pagination.queryParams,
    size: "small"
  }) : /*#__PURE__*/React__default["default"].createElement(united.Pagination, {
    currentPage: currentPage,
    onPageChange: onChange,
    pageCount: pageCount,
    size: "small"
  }))));
};

Pagination.defaultProps = {
  isLinkPagination: false,
  pagination: {
    amountPerPage: 25,
    count: 0,
    currentPage: 1,
    onChange: function onChange() {},
    customPaginationText: function customPaginationText() {}
  }
};

var Body = united.Table.Body,
    Column = united.Table.Column,
    ColumnGroup = united.Table.ColumnGroup,
    Foot = united.Table.Foot,
    Head = united.Table.Head,
    Row = united.Table.Row,
    Th = united.Table.Th;

var DataTable = function DataTable(_ref) {
  var columns = _ref.columns,
      dataSource = _ref.dataSource,
      expandable = _ref.expandable,
      fallbacks = _ref.fallbacks,
      footer = _ref.footer,
      filter = _ref.filter,
      pagination = _ref.pagination,
      rowSelection = _ref.rowSelection,
      size = _ref.size;
  var onChange = rowSelection.onChange;
  var expandedRowRender = expandable.expandedRowRender,
      _expandable$rowExpand = expandable.rowExpandable,
      rowExpandable = _expandable$rowExpand === void 0 ? function () {
    return true;
  } : _expandable$rowExpand;
  var isExpandable = !!Object.keys(expandable).length;
  var hasSelection = !!Object.keys(rowSelection).length;

  var _useMultipleCheckbox = useMultipleCheckbox(),
      checkItem = _useMultipleCheckbox.checkItem,
      checkItems = _useMultipleCheckbox.checkItems,
      checkedItems = _useMultipleCheckbox.checkedItems,
      unCheckAll = _useMultipleCheckbox.unCheckAll,
      unCheckItem = _useMultipleCheckbox.unCheckItem;

  var checkKeys = React.useMemo(function () {
    return hasSelection && dataSource.map(function (_ref2) {
      var key = _ref2.key;
      return key;
    });
  }, [dataSource]);
  var isAllChecked = React.useMemo(function () {
    return hasSelection && checkKeys.every(function (checkKey) {
      return checkedItems.includes(checkKey);
    });
  }, [checkKeys, checkedItems]);
  var isLinkPagination = pagination.isLinkPagination,
      paginateCount = pagination.count;
  var hasPagination = !!paginateCount;
  var hasError = fallbacks.hasError,
      isLoading = fallbacks.isLoading;
  var hasItems = !!dataSource.length;
  var shouldShowContent = !isLoading && !hasError && hasItems;
  reactUse.useUpdateEffect(function () {
    if (hasSelection && onChange) {
      onChange(checkedItems);
    }
  }, [JSON.stringify(checkedItems)]);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(united.Table, {
    size: size
  }, /*#__PURE__*/React__default["default"].createElement(ColumnGroup, null, _toConsumableArray(Array(columns.length).map(function (key) {
    return /*#__PURE__*/React__default["default"].createElement(Column, {
      key: key
    });
  }))), /*#__PURE__*/React__default["default"].createElement(Head, null, /*#__PURE__*/React__default["default"].createElement(HeaderRow, null, hasSelection && /*#__PURE__*/React__default["default"].createElement(Th, {
    width: "26px"
  }, /*#__PURE__*/React__default["default"].createElement(united.Flex, null, /*#__PURE__*/React__default["default"].createElement(united.Checkbox, {
    onChange: function onChange(e) {
      return e.target.checked ? checkItems(checkKeys) : unCheckAll();
    },
    checked: isAllChecked,
    indeterminate: !isAllChecked && checkedItems.length > 0
  }))), isExpandable && /*#__PURE__*/React__default["default"].createElement(Th, {
    width: "26px"
  }), columns.map(function (_ref3) {
    var actions = _ref3.actions,
        dataIndex = _ref3.dataIndex,
        style = _ref3.style,
        title = _ref3.title;
    return /*#__PURE__*/React__default["default"].createElement(ThStyled, {
      style: style,
      key: dataIndex
    }, /*#__PURE__*/React__default["default"].createElement(ColumnHead, actions, title));
  }))), shouldShowContent && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Body, null, filter.showInfo && /*#__PURE__*/React__default["default"].createElement(FilterInfo, {
    columnsCount: columns.length,
    filter: filter,
    hasSelection: hasSelection,
    isExpandable: isExpandable
  }), dataSource.map(function (_ref4, index) {
    var key = _ref4.key;
    var dataObject = dataSource[index];
    var columnsData = columns.map(function (column) {
      var dataValue = dataSource[index][column.dataIndex];
      return {
        content: column.render ? column.render(dataValue, dataObject) : dataValue,
        dataKey: column.key,
        style: column.style
      };
    });
    var isChecked = hasSelection && checkedItems.includes(key);
    var expandedContent = isExpandable && rowExpandable(dataObject) && expandedRowRender(dataObject);
    return /*#__PURE__*/React__default["default"].createElement(MemoizeRow$1, {
      checkItem: checkItem,
      columnsData: columnsData,
      expandedContent: expandedContent,
      hasSelection: hasSelection,
      isChecked: isChecked,
      isExpandable: isExpandable,
      itemKey: key,
      key: key,
      unCheckItem: unCheckItem
    });
  })), footer && /*#__PURE__*/React__default["default"].createElement(Foot, null, /*#__PURE__*/React__default["default"].createElement(Row, null, footer)))), /*#__PURE__*/React__default["default"].createElement(Fallbacks, {
    fallbacks: fallbacks,
    hasItems: hasItems
  }), hasPagination && /*#__PURE__*/React__default["default"].createElement(Pagination, {
    isLinkPagination: isLinkPagination,
    pagination: pagination
  }));
};

DataTable.defaultProps = {
  dataSource: [],
  expandable: {},
  fallbacks: {},
  filter: {
    chips: [],
    count: -1,
    onClearAllFilters: function onClearAllFilters() {},
    showInfo: false
  },
  pagination: {
    count: 0,
    currentPage: 1,
    amountPerPage: 25,
    isLinkPagination: false,
    onChange: function onChange() {},
    customPaginationText: function customPaginationText() {}
  },
  footer: null,
  rowSelection: {},
  size: 'small'
};

var _templateObject;
var StyledRow = styled__default["default"](united.Table.Row)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n\n  :hover {\n    background-color: ", ";\n  }\n"])), themeGet.themeGet('olist.color.neutral.softer'));

var navigateLink = function navigateLink(href) {
  return function (event) {
    var ENTER = 13;
    var isClick = event.button === 0;
    var isMiddleClick = event.button === 1;
    var isEnter = event.keyCode === ENTER;
    var isCtrl = window.event && (window.event.ctrlKey || window.event.metaKey);
    var isClickOrEnter = isClick || isEnter;
    var shouldOpenNewTab = isClickOrEnter && isCtrl || isMiddleClick;

    if (shouldOpenNewTab) {
      window.open(href, '_blank');
      return;
    }

    if (isClickOrEnter) {
      window.location.assign(href);
    }
  };
};

var RowLink = function RowLink(_ref) {
  var children = _ref.children,
      className = _ref.className,
      href = _ref.href;
  return /*#__PURE__*/React__default["default"].createElement(StyledRow, {
    className: className,
    onMouseUp: navigateLink(href),
    onKeyDown: navigateLink(href),
    tabIndex: "0",
    role: "link"
  }, children);
};

RowLink.defaultProps = {
  className: ''
};

/* eslint sort-keys: "error" */
var ICONS = {
  'bank-alt': 'M22.01 8L22 6L12 2L2 6L2.01 8H4V17H3V19H2V22H22V19H21V17H20V8H22.01ZM3.005 7V6.675L12 3.075L21.005 6.675V6.995H20H16H14H10H8H4H3.005V7ZM10 17H8V8H10V17ZM11 8H13V17H11V8ZM14 8H16V17H14V8ZM5 8H7V17H5V8ZM21 21H3V20H21V21ZM20 19H4V18H8H10H14H16H20V19ZM19 17H17V8H19V17Z M12.9998 4.99907H10.9998V5.99907H12.9998V4.99907Z',
  'computer-alt': 'M13.8058 20.55H23.0058L23 5.6H18.4058V5.025V3.875V3.12175L16.1058 1H15.5308H14.3808H4.60575V5.6H0L0.00575123 20.55H9.1655V22.85H6.90575V24H9.1655H13.8058H16.1058V22.85H13.8058V20.55ZM15.5308 2.15H15.6573L17.2558 3.62775V3.875H15.5308V2.15ZM5.75575 2.15H14.3808V4.45L14.9558 5.025H17.2558V13.65H5.75575V2.15ZM4.60575 6.75V13.65H3.45575V14.8H4.60575H18.4058H19.5558V13.65H18.4058V6.75H21.85L21.8558 17.1H1.15575L1.15 6.75H4.60575ZM12.6558 22.85H10.3155V20.55H12.6558V22.85ZM9.1655 19.4H1.15575V18.25H21.8558V19.4H13.8058H9.1655Z M12.656 4.45056H8.05597V5.60056H12.656V4.45056Z M12.656 11.3503H8.05597V12.5003H12.656V11.3503Z M14.956 6.75H8.05597V7.9H14.956V6.75Z M9.20597 9.04944H8.05597V10.1994H9.20597V9.04944Z M14.9559 9.04944H10.3559V10.1994H14.9559V9.04944Z',
  'document-alt': 'M18 12.74C19.745 12.12 21 10.46 21 8.5C21 6.54 19.745 4.88 18 4.26V2H2V19.5C2 20.88 3.12 22 4.5 22H17.875H19.62L19.615 21.99C20.945 21.925 22 20.84 22 19.5V14H18V12.74ZM21 19.5C21 20.325 20.325 21 19.5 21C18.675 21 18 20.325 18 19.5V18.925V15H21V19.5ZM20 8.5C20 10.43 18.43 12 16.5 12C14.57 12 13 10.43 13 8.5C13 6.57 14.57 5 16.5 5C18.43 5 20 6.57 20 8.5ZM3 19.5V3H17V4.03C16.835 4.01 16.67 4 16.5 4C14.015 4 12 6.015 12 8.5C12 10.985 14.015 13 16.5 13C16.67 13 16.835 12.99 17 12.97V14V18.925V19.175V19.5C17 20.065 17.195 20.58 17.51 21H4.5C3.675 21 3 20.325 3 19.5Z M11.0001 4.99968H5.00006V5.99968H11.0001V4.99968Z M14 17H7V18H14V17Z M6.00006 17H5.00006V18H6.00006V17Z M10.0001 8.00016H5.00006V9.00016H10.0001V8.00016Z M7.00006 10.9998H5.00006V11.9998H7.00006V10.9998Z M10.9999 10.9998H7.99994V11.9998H10.9999V10.9998Z M14 14.0003H12V15.0003H14V14.0003Z M11.0001 14.0003H5.00006V15.0003H11.0001V14.0003Z M15.235 7.77538L14.525 8.48038L16.145 10.1004L18.745 7.52038L18.04 6.81038L16.15 8.69038L15.235 7.77538Z',
  'list-alt': 'M5 4.99805H3C2.45 4.99805 2 5.44805 2 5.99805V7.99805C2 8.54805 2.45 8.99805 3 8.99805H5C5.55 8.99805 6 8.54805 6 7.99805V5.99805C6 5.44805 5.55 4.99805 5 4.99805ZM5 7.99805H3V5.99805H5V7.99805Z M5 10.9978H3C2.45 10.9978 2 11.4478 2 11.9978V13.9978C2 14.5478 2.45 14.9978 3 14.9978H5C5.55 14.9978 6 14.5478 6 13.9978V11.9978C6 11.4478 5.55 10.9978 5 10.9978ZM5 13.9978H3V11.9978H5V13.9978Z M5 16.999H3C2.45 16.999 2 17.449 2 17.999V19.999C2 20.549 2.45 20.999 3 20.999H5C5.55 20.999 6 20.549 6 19.999V17.999C6 17.449 5.55 16.999 5 16.999ZM5 19.999H3V17.999H5V19.999Z M20.9997 4.99658H8.99969C8.44969 4.99658 7.99969 5.44658 7.99969 5.99658V7.99658C7.99969 8.54658 8.44969 8.99658 8.99969 8.99658H20.9997C21.5497 8.99658 21.9997 8.54658 21.9997 7.99658V5.99658C21.9997 5.44658 21.5497 4.99658 20.9997 4.99658ZM20.9997 7.99658H8.99969V5.99658H20.9997V7.99658Z M20.9997 10.9978H8.99969C8.44969 10.9978 7.99969 11.4478 7.99969 11.9978V13.9978C7.99969 14.5478 8.44969 14.9978 8.99969 14.9978H20.9997C21.5497 14.9978 21.9997 14.5478 21.9997 13.9978V11.9978C21.9997 11.4478 21.5497 10.9978 20.9997 10.9978ZM20.9997 13.9978H8.99969V11.9978H20.9997V13.9978Z M20.9997 16.999H8.99969C8.44969 16.999 7.99969 17.449 7.99969 17.999V19.999C7.99969 20.549 8.44969 20.999 8.99969 20.999H20.9997C21.5497 20.999 21.9997 20.549 21.9997 19.999V17.999C21.9997 17.449 21.5497 16.999 20.9997 16.999ZM20.9997 19.999H8.99969V17.999H20.9997V19.999Z',
  'package-alt': 'M22.2727 7L15.3927 3.56L15.3877 3.555L15.3827 3.56L12.2727 2L2.27271 7.395V17L12.2727 22L22.2727 17V7ZM12.2727 11.44L10.5577 10.585L18.8827 6.42L20.5927 7.275L12.2727 11.44ZM6.1127 9.485L8.33271 10.59C8.19771 10.685 8.11271 10.83 8.11271 10.995V14.315L7.50771 13.39C7.43271 13.275 7.31771 13.2 7.18771 13.175C7.05271 13.15 6.9177 13.175 6.8077 13.255L6.11771 13.73V9.485H6.1127ZM7.05271 8.84L15.3827 4.675L17.7627 5.865L9.43771 10.03L7.05271 8.84ZM12.2727 3.12L14.2677 4.115L5.93771 8.28L3.94271 7.285L12.2727 3.12ZM3.27271 8.07L5.1127 8.99C5.1127 8.995 5.1127 8.995 5.1127 9V14.685C5.1127 14.87 5.2177 15.04 5.3827 15.125C5.5477 15.21 5.74771 15.2 5.89771 15.095L6.9527 14.37L8.19771 16.27C8.29271 16.415 8.4527 16.495 8.6177 16.495C8.6627 16.495 8.7127 16.49 8.7627 16.475C8.9727 16.41 9.1177 16.215 9.1177 15.995V11.305L9.44271 11.14L11.7727 12.31V20.635L3.27271 16.385V8.07ZM21.2727 16.38L12.7727 20.63V12.31L21.2727 8.06V16.38ZM20.1177 15.6397V12.4297L15.6327 14.6697V17.8797L20.1177 15.6397ZM16.6327 15.2947L19.1177 14.0547V15.0247L16.6327 16.2647V15.2947ZM20.1177 11.4299V10.3149L16.5227 12.085V13.2L20.1177 11.4299Z',
  'truck-alt': 'M20.4 6.6H16.8V3H2.4C1.074 3 0 4.074 0 5.4V18.6H3.666C3.624 18.798 3.6 19.008 3.6 19.218C3.6 20.886 4.95 22.236 6.618 22.236C8.286 22.236 9.636 20.886 9.636 19.218C9.636 19.008 9.612 18.798 9.57 18.6H15.6H15.666C15.624 18.798 15.6 19.008 15.6 19.218C15.6 20.886 16.95 22.236 18.618 22.236C20.286 22.236 21.636 20.886 21.636 19.218C21.636 19.008 21.612 18.798 21.57 18.6H24V13.95V11.55V11.4L20.4 6.6ZM6.618 21.042C5.616 21.042 4.8 20.226 4.8 19.224C4.8 18.222 5.616 17.406 6.618 17.406C7.62 17.406 8.436 18.222 8.436 19.224C8.436 20.226 7.626 21.042 6.618 21.042ZM15.6 6.6V17.4H9.018C8.466 16.674 7.602 16.2 6.624 16.2C5.646 16.2 4.782 16.674 4.23 17.4H1.2V5.4C1.2 4.74 1.74 4.2 2.4 4.2H15.6V6.6ZM18.618 21.042C17.616 21.042 16.8 20.226 16.8 19.224C16.8 18.222 17.616 17.406 18.618 17.406C19.62 17.406 20.436 18.222 20.436 19.224C20.436 20.226 19.626 21.042 18.618 21.042ZM22.8 17.4H21.018C20.466 16.674 19.602 16.2 18.624 16.2C17.934 16.2 17.31 16.44 16.806 16.824V7.8H19.806L21.492 10.05H19.2V12.15C19.2 13.14 20.01 13.95 21 13.95H22.8V17.4ZM22.8 12.75H21C20.67 12.75 20.4 12.48 20.4 12.15V11.25H22.386L22.8 11.802V12.75Z M4.19976 7.19905H5.99976V5.99905H2.99976V9.29905H4.19976V7.19905Z M12.5998 9.29905H13.7998V5.99905H10.7998V7.19905H12.5998V9.29905Z M13.7998 11.1011H12.5998V13.2011H10.7998V14.4011H13.7998V11.1011Z M5.99976 13.2011H4.19976V11.1011H2.99976V14.4011H5.99976V13.2011Z'
};

var OIcon = function OIcon(_ref) {
  var name = _ref.name,
      rest = _objectWithoutProperties(_ref, ["name"]);

  var iconPath = ICONS[name];

  if (!iconPath) {
    console.error("The icon ".concat(name, " doesn't exist"));
    return false;
  }

  return /*#__PURE__*/React__default["default"].createElement(united.Icon, _extends({
    name: name,
    path: iconPath
  }, rest));
};

var BestFridayWrapper = function BestFridayWrapper(_ref) {
  var children = _ref.children,
      endDate = _ref.endDate,
      initialDate = _ref.initialDate;
  var shouldDisplayContent = shouldDisplayBestFridayContent(initialDate, endDate);
  return shouldDisplayContent && children;
};

BestFridayWrapper.defaultProps = {
  endDate: '',
  initialDate: ''
};
BestFridayWrapper.propTypes = {
  children: T__namespace.node.isRequired,
  endDate: T__namespace.string,
  initialDate: T__namespace.string
};

exports.ActionVisibility = ActionVisibility;
exports.BestFridayWrapper = BestFridayWrapper;
exports.CardFeedback = CardFeedback;
exports.CharacterCounter = CharacterCounter;
exports.CheckboxFilter = CheckBoxFilter;
exports.Chip = Chip;
exports.Condition = Condition;
exports.CopyButton = CopyButton;
exports.DataTable = DataTable;
exports.DescriptionItem = DescriptionItem;
exports.DescriptionTerm = DescriptionTerm;
exports.DescriptionValue = DescriptionValue;
exports.Dropzone = Dropzone;
exports.Emoji = Emoji;
exports.FieldTip = FieldTip;
exports.FieldVisibility = FieldVisibility;
exports.FieldVisibilityReason = FieldVisibilityReason;
exports.Fields = Fields;
exports.FormGroupVisibility = FormGroupVisibility;
exports.FormVisibility = FormVisibility;
exports.HeaderOnboarding = HeaderOnboarding;
exports.Info = Info;
exports.InputCurrency = InputCurrency;
exports.InputDate = InputDate;
exports.InputDebounce = InputDebounce;
exports.InputFileHidden = InputFileHidden;
exports.InputLabelError = InputLabelError;
exports.InputOnlyDigits = InputOnlyDigits;
exports.InputSearch = InputSearch;
exports.InputSearchNavigation = InputSearchNavigation;
exports.Layout = Layout;
exports.LinkPagination = LinkPagination;
exports.LoadingSpinner = LoadingSpinner;
exports.LogoOlist = Logo;
exports.LogoOlistFbo = LogoOlistFbo;
exports.LogoOlistStore = LogoOlistStore;
exports.OIcon = OIcon;
exports.ProductAttributes = ProductAttributes;
exports.ProductImage = ProductImage;
exports.ProductMetadata = ProductMetadata;
exports.ProductTitle = ProductTitle;
exports.ResponsiveHeader = Header;
exports.RowLink = RowLink;
exports.SelectLabelError = SelectLabelError;
exports.SeparatorWithText = SeparatorWithText;
exports.SplashFeedback = SplashFeedback;
exports.Uploader = Uploader;
exports.Visibility = Visibility;
exports.YoutubeVideoPlayer = YoutubeVideoPlayer;
exports.disabledInput = disabledInput;
exports.errorBoundary = ErrorBoundary;
exports.fieldWithVisibility = fieldWithVisibility;
exports.formWithToken = formWithToken;
exports.getFieldErrors = getErrors;
exports.withError = withError;
exports.withFieldError = withFieldError;
exports.withSuccess = withSuccess;
